// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Archivo-VariableFont_wdth,wght.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/KaTeX_Z-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M8 6v14l14-7z\" fill=\"rgb%2810, 9, 9%29\"/><path d=\"M7 5v14l14-7z\" fill=\"rgb%28250, 225, 225%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #region tap highlight disable */
* {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

html {
  touch-action: pan-x pan-y;
}

*:focus {
  outline: none;
}

button, a, input, select, textarea {
  -webkit-tap-highlight-color: transparent;
  outline: none;
}
/* #endregion */

/* #region .ui */
.ui {
  align-items: center;
  background-color: rgb(140, 126, 126);
  border-radius: 4px;
  box-shadow: 0.15vmin 0.15vmin rgba(10, 9, 9, 0.5);
  box-sizing: border-box;
  color: rgb(10, 9, 9);
  display: flex;
  flex-wrap: wrap;
  font-family: Archivo, sans-serif;
  font-size: 16px;
  font-stretch: 100%;
  font-weight: 650;
  letter-spacing: 0.025em;
  padding: 0px 6px 6px 6px;
  width: 240px;
  z-index: 1;
}

.ui button {
  align-items: center;
  background-color: rgba(10, 9, 9, 0.2);
  border: none;
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: none;
  color: rgb(250, 225, 225);
  cursor: pointer;
  display: inline-flex;
  font-family: Archivo, sans-serif;
  font-size: 16px;
  font-weight: 600;
  height: 42px;
  justify-content: center;
  letter-spacing: 0.025em;
  padding: 6.5px;
}

.ui button:not(.dpad-button):not(.tab):hover {
  background-color: rgba(10, 9, 9, 0.22);
}

.ui h1 {
  align-items: center;
  box-sizing: border-box;
  display: inline-flex;
  flex-basis: 100%;
  font-size: 16px;
  font-weight: 400;
  height: 42px;
  justify-content: center;
  margin: 0px;
  text-align: center;
}

.ui input, .ui select, .ui textarea {
  background-color: rgb(250, 225, 225);
  border: 1px solid rgb(140, 126, 126);
  border-radius: 4px;
  box-shadow: none;
  box-sizing: border-box;
  flex-basis: 100%;
  font-family: Archivo, sans-serif;
  font-size: 18px;
  font-weight: 550;
  height: 42px;
  letter-spacing: 0.025em;
  padding: 8px 0px;
  text-align: center;
}

.ui li {
  background-color: rgba(250, 225, 225, 0.25);
  border-radius: 4px;
  display: flex;
  flex-basis: 100%;
  flex-direction: column;
  font-weight: 550;
  justify-content: space-between;
  letter-spacing: 0.025em;
  margin: 0px 0px 6px 0px;
  padding: 3px;
}

.ui li:last-child {
  margin: 0px;
}

.ui li button {
  font-size: 24px;
  font-weight: bold;
  height: 30.6px;
  margin-left: 3px;
  width: 30.6px;
}

.ui ol {
  display: flex;
  flex-basis: 100%;
  flex-direction: column;
  list-style-type: none;
  margin: 0px;
  overflow: auto;
  padding: 0px;
}

.ui td {
  flex-grow: 1;
  padding: 3px;
}

.ui td:first-child {
  padding-left: 0px;
}

.ui tr:first-child td {
  padding-top: 0px;
}

.ui td:last-child {
  padding-right: 0px;
}

.ui tr:last-child td {
  padding-bottom: 0px;
}

.visible {
  opacity: 0.75;
  z-index: 2 !important;
}
/* #endregion */
/* #region mobile */
html.mobile #board-div, html.mobile  #chart-div, html.mobile .game-div #sheet-div {
  right: 0 !important;
  transform: none !important;
  width: 100vmin !important;
}

html.mobile .canvas-div:not(.slide-div[data-type="review"] .canvas-div) {
  transform: scale(2) translateY(-25%) !important;
}

html.mobile #carat {
  transform: scale(2) translate(2px, -3px) !important;
}

html.mobile #keyboard {
  transform: none !important;
  width: 100vmin !important;
}

html.mobile .slide-div #chart-div, html.mobile .game-div #chart-div {
  display: none;
}

html.mobile #toolbar-print-button {
  display: none !important;
}

html.mobile .game-div .popup {
  font-size: 3vmin;
  height: 3vmin;
  padding: 2vmin 2.75vmin;
}

html.mobile .game-div #popup svg {
  height: 3.5vmin;
  margin: 0 1.5vmin 0 -0.7vmin;
  width: 3.5vmin;
}
/* #endregion */
/* #region fonts */
@font-face {
  font-family: 'Archivo';
  font-style: normal;
  font-stretch: 62% 125%;
  font-weight: 100 900;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
}

@font-face {
  font-family: 'KaTeX_Z';
  font-style: normal;
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
}
/* #endregion */
/* #region index.html */
#background {
  bottom: 0;
  left: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 0;
  transition: background-color 350ms ease-in-out, opacity 200ms ease-in-out;
  z-index: -1;
}

#background.blur * {
  opacity: 0.15 !important;
}

#background.rain {
  background: none;
  opacity: 1;
}

body {
  background: linear-gradient(33deg, #211a1e 0%, #19211e 100%);
  background-attachment: fixed;
  background-color: rgb(30, 27, 27);
  filter: saturate(0.875);
}

.br {
  height: 4.75vmin;
}

#loading {
  background: none;
  bottom: 50%;
  bottom: calc(50% - env(safe-area-inset-top) - env(safe-area-inset-bottom));
  height: 80px;
  left: 50%;
  position: fixed;
  transform: translate(-50%, 50%);
  width: 80px;
}

/* Orbit spinner styling lives in getOrbit() and orbit.svg */

/* #endregion */
/* #region panel.js */
#chart-div {
  left: 0;
  opacity: 1;
  transform-origin: top left;
  transition: opacity 250ms ease-in-out;
  width: 275px;
  z-index: 2;
}

#board-video, #chart-rankings, #chart-stats, #sheet-friends, #sheet-songs {
  align-items: start;
  margin-bottom: 5.25px;
  /* The app's scroll fade (dash.css lists, the memo, the toolbag): --scroll is set by fadeScroll
     (script.js) only while the list overflows, so otherwise the mask is invalid and nothing fades. */
  mask-image: linear-gradient(rgba(0, 0, 0, calc(1 - var(--scroll))) 0%, rgba(0, 0, 0, calc(0.75 * (1 / var(--scroll)))) 5%, rgba(0, 0, 0, 1) 10%, rgba(0, 0, 0, 1) 90%, rgba(0, 0, 0, calc(0.75 * (1 / (1 - var(--scroll))))) 95%, rgba(0, 0, 0, var(--scroll)) 100%);
  overflow-x: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}

#board-video, #chart-rankings, #chart-stats, #sheet-friends, #sheet-songs {
  max-height: 235px;
}

/* Friends and songs lists sit a touch taller than the chart panels above (which
   keep 235px) - overriding just these two, later + equal specificity wins. */
#sheet-friends, #sheet-songs {
  max-height: 265px;
}

/* Sheet friends panel sizes to its actual content rather than filling the parent
   vertically (the shared \`height: calc(100% - 40px)\` from a few rules below was
   leaving a gap below the AVATARS list when fairies hadn't been collected yet).
   Capped by max-height above when the list is long. */
#sheet-friends {
  height: auto;
}

/* Strip the trailing 6px margin-bottom from the LAST VISIBLE child in the
   friends list — applies to ANY element type (section header li, section ul, etc.).
   The 6px exists to space items from each other; on the last visible one it's
   just dead space. Covers: collapsed sections (header visible, ul hidden),
   single-section panels, and future critter sections — all generic, no JS. */
#sheet-friends > ul > *:not(:has(~ *:not([style*="display: none"]))) {
  margin-bottom: 0;
}

#board-video ul, #chart-rankings ul, #chart-stats ul, #sheet-friends ul, #sheet-songs ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  width: calc(100% - 0.05vmin);
}

#sheet-friends ul {
  margin-bottom: 6px;
}

#chart-rankings li {
  line-height: 15px;
}

#board-video li, #chart-rankings li, #chart-stats li, #sheet-friends li, #sheet-songs li {
  background: linear-gradient(to bottom, rgba(200, 180, 180, 0.4) -100%, rgba(50, 45, 45, 0.4) 125%);
  border-radius: 4px;
  box-shadow: 0.15vmin 0.15vmin rgba(10, 9, 9, 0.25);
  color: rgb(250, 225, 225);
  display: flex;
  font-family: Archivo, sans-serif;
  font-size: 14px;
  font-weight: 550;
  margin-bottom: 6px;
  padding: 4px 5px;
  position: relative;
  text-shadow: 0.125vmin 0.125vmin rgba(10, 9, 9, 0.5);
}

#chart-stats li.grade-header, #sheet-friends li.friends-header {
  cursor: pointer;
  font-size: 12.5px;
  font-weight: 700;
  justify-content: space-between;
  width: calc(100% - 10px);
}

#board-video li:last-child, #chart-rankings li:last-child, #chart-stats ul:first-child li, #chart-stats ul:last-child li:last-child, #sheet-friends li:last-child, #sheet-friends ul:last-child, #sheet-songs li:last-child {
  margin-bottom: 0;
}

#chart-rankings li span, #chart-stats li span {
  align-items: center;
  display: flex;
}

#chart-rankings li span:first-child svg {
  height: 15px;
  margin-right: 5px;
  width: 15px;
}

#chart-rankings p {
  color: rgb(250, 225, 225);
  font-family: 'Archivo';
  font-size: 14px;
  font-weight: 550;
  line-height: 15px;
  text-shadow: 0.125vmin 0.125vmin rgba(10, 9, 9, 0.5);
}

#chart-stats a {
  color: unset;
  text-decoration: none;
}

#chart-stats li span:first-child svg {
  height: 11px;
  margin-right: 4px;
  width: 12px;
}

#chart-rankings li span:nth-child(2) {
  font-family: 'Unifont', monospace;
  line-height: 0;
  margin-bottom: 1px;
}

#chart-rankings li span:nth-child(2), #chart-stats li span:nth-child(1) {
  width: 100%;
}

#chart-rankings li span:nth-child(3) svg, #chart-stats li span:nth-child(2) svg {
  height: 10px;
  padding: 1px;
  width: 10px;
}

.panel-button.friend-button, .panel-button.song-button {
  font-size: 10.5px;
  font-weight: 550;
  margin-left: 6px;
  outline: none;
  padding: 1px 40px;
  width: 68px;
}

.panel-expand-button {
  background: none;
  border: none;
  height: 11px;
  padding: 0 6px;
  pointer-events: none;
  text-align: end;
}

.panel-expand-button svg {
  height: 12px;
  padding: 0.5px 0 0 0;
  transform: scaleX(2.5);
  width: 12px;
}

.friend-canvas {
  height: 22px;
  image-rendering: pixelated;
  width: 32px;
}

.friend-entry-left, .song-entry-left, .video-step-left {
  align-items: center;
  display: flex;
  height: 31px;
  justify-content: center;
  margin-right: 6px;
  width: 32px;
}

.friend-entry-name-span {
  margin-right: 6px;
}

.friend-entry-heart-span {
  align-items: center;
  display: flex;
  flex: 1;
}

.friend-entry-heart-span svg {
  margin-left: 3px;
  height: 12px;
  width: 12px;
}

.friend-entry-right, .song-entry-right, .video-step-right {
  width: calc(100% - 32px);
}

.friend-entry-right-top, .song-entry-right-top, .video-step-right-top {
  display: flex;
  flex-direction: row;
  height: 15.5px;
}

.panel {
  backdrop-filter: blur(10px);
  border: none;
  border-radius: 4px;
  box-shadow: 0.15vmin 0.15vmin rgba(10, 9, 9, 0.5);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  letter-spacing: normal;
  opacity: 0;
  position: absolute;
  text-align: left;
  transform: scale(var(--session-scale-x), var(--session-scale-y));
  top: 0;
  z-index: -1;
}

.slide-div .panel {
  opacity: 0.95;
  z-index: 3;
}

.slide-div.video #board-div:not(:hover), .slide-div.video #chart-div:not(:hover) {
  opacity: 0.25;
}

/* Fade the chart and the sheet whenever they aren't moused over - the same idea the video
   layout uses, at half its intensity (video drops to 0.25, this stops at 0.5). Scoped to the
   GAME only - these panels sit over the world and are wanted only when looked at, whereas in a
   lesson the chart is reference material beside the work. Applies in every state, expanded or
   minimized.
   Two guards matter. \`:not(.galaxy):not(.rainbow) >\` keeps this away from the game's
   galaxy/rainbow modes, which hide these panels outright with \`opacity: 0\` - without it these
   rules would outrank that and make a deliberately hidden panel visible again.
   \`html:not(.dash)\` keeps it off dashboard tiles, where nothing is ever hovered, so the panels
   would sit permanently faded on every tile. */
/* ON HOLD (Aug 2026) - commented out at the user's request, not deleted, so the reasoning
   above survives if it comes back. */
/*
html:not(.dash) .game-div:not(.galaxy):not(.rainbow) > #chart-div:not(:hover),
html:not(.dash) .game-div:not(.galaxy):not(.rainbow) > #sheet-div:not(:hover) {
  opacity: 0.5;
}
*/

.panel .header {
  height: 36px;
  padding: 6px;
}

.panel .header-center {
  flex: 0 1 55%;
}

.panel .header-left {
  margin-right: 6px;
}

.panel .header-left button svg {
  height: 11px;
  width: 11px;
}

.panel .header-right {
  margin-left: 6px;
}

.panel .header-title {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0%);
}

.panel-button {
  align-items: center;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) -100%, rgba(20, 18, 18, 0.5) 150%);
  border: none;
  border-radius: 4px;
  box-shadow: 0.05vmin 0.05vmin rgba(10, 9, 9, 0.5);
  color: rgb(250, 225, 225);
  cursor: pointer;
  display: flex;
  height: 100%;
  justify-content: center;
  transition: background-color 25ms ease-in-out;
  width: 100%;
}

.panel-button:not(.friend-button):not(.song-button):disabled {
  opacity: 1 !important;
}

.panel-button:disabled span, .panel-button:disabled svg {
  opacity: 0.25;
}

/* A video button with nothing to play: greyed like :disabled, but still clickable so the click
   can say why (a dialog, event.js); the global button:disabled rule kills pointer events. */
#video-button.empty span, #video-button.empty svg {
  opacity: 0.25;
}

.panel-button.glow {
  background-color: var(--student-color-mid);
  filter: drop-shadow(0 0 25px var(--student-color-mid));
}

.color-pulse {
  animation: color-pulse 120s infinite;
}

@keyframes color-pulse {
  0%, 1%, 100% {
    background-color: transparent;
    filter: drop-shadow(0 0 0 transparent);
  }
  0.25% {
    background-color: var(--student-color-mid);
    filter: drop-shadow(0 0 3vmin var(--student-color-mid));
  }
}

.panel-label {
  font-family: Archivo, sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.025em;
  pointer-events: none;
  text-shadow: 0.125vmin 0.125vmin rgba(10, 9, 9, 0.5);
  text-transform: uppercase;
}

#board-div, #sheet-div {
  max-width: 100vw;
  opacity: 1;
  right: 0.2vmin;
  transform-origin: top right;
  transition: opacity 250ms ease-in-out;
  width: 325px;
  z-index: 2;
}

#board-instructions, #board-facts, #board-video, #chart-rankings, #chart-stats, #sheet-friends, #sheet-songs {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: calc(100% - 40px);
  padding: 0 6px 2px 6.5px;
}

#board-instructions h2 {
  font-size: 18px;
  margin: 5px 0px 10px 0px;
  text-align: center;
}

#board-instructions ol, #board-instructions ul {
  align-self: stretch;
  font-size: 13px;
  line-height: 18px;
  list-style: none;
  margin: 0;
  padding: 0 0 3.5px 1px;
}

#board-instructions ol ol, #board-instructions ul ul {
  padding-left: 0;
}

#board-instructions li {
  padding-left: 17px;
  position: relative;
}

#board-instructions .ins-row {
  transition: opacity 0.15s;
}

#board-instructions li.checked > .ins-row {
  opacity: 0.4;
}

#board-instructions li.checked > .ins-row:hover {
  opacity: 1;
}

#board-instructions .ins-mark {
  display: inline-block;
  min-width: 14px;
}

#board-instructions .ins-check {
  background: rgb(250, 225, 225);
  border: none;
  border-radius: 2px;
  cursor: pointer;
  height: 11px;
  left: 0;
  position: absolute;
  text-shadow: none;
  top: 3px;
  width: 11px;
}

#board-instructions li.checked .ins-check::after {
  color: rgb(10, 9, 9);
  content: '\\2713';
  font-size: 10px;
  font-weight: bold;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

/* Facts Panel Styles */
#board-facts {
  flex-direction: column;
  font-family: 'Archivo';
  justify-content: center;
  overflow-y: auto;
  position: relative;
}

/* Fact Div Styles (shared between game and board) */
#fact-background,
#power-background {
  background: linear-gradient(to top, #73e6d2 0%, #ff80bf 50%, #ffe666 100%);
  border-radius: 4px;
  bottom: 0;
  height: 0%;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  transition: background-color 175ms;
  width: 100%;
}

/* Only BATTLE takes the avatar's colour: harvesting shares the fire skills (the pink) and keeps it.
   Without .battle the two variables are cleared, so every var() below falls back to the pink. */
#fact-div:not(.battle) {
  --avatar-color: initial;
  --avatar-color-dark: initial;
}

#fact-div.fire #fact-background {
  background: linear-gradient(to top, transparent 75%, rgb(250, 225, 225) 100%);
  background-color: var(--avatar-color, #ff80bf);
}
#fact-div.water #fact-background {
  background: linear-gradient(to top, transparent 75%, rgb(250, 225, 225) 100%);
  background-color: #73e6d2;
}
#fact-div.wind #fact-background {
  background: linear-gradient(to top, transparent 75%, rgb(250, 225, 225) 100%);
  background-color: #ffe666;
}

#fact-div.loading-skills #fact-background {
  filter: grayscale(1);
  opacity: 0.75;
}

#fact-bottom {
  display: flex;
  flex-direction: row;
  width: 100%;
}

#board-facts #fact-bottom {
  margin-bottom: 5.5px;
}

#board-facts .fact-button {
  width: 100%;
}

#board-facts #fact-center, #board-facts #fact-left, #board-facts #fact-right {
  width: 33.33%;
}

#fact-div.loading-skills #fact-bottom {
  filter: grayscale(1);
  opacity: 0.75;
}

.fact-button, .song-note-button {
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) -100%, rgba(20, 18, 18, 0.5) 150%);
  border: none;
  border-radius: 4px;
  box-shadow: 1px 1px rgba(10, 9, 9, 0.25);
  box-sizing: border-box;
  color: rgb(250, 225, 225);
  cursor: pointer;
  font-family: Archivo, sans-serif;
  font-size: 16px;
  font-weight: 600;
  height: 40px;
  opacity: 1;
  /* 4px sides, not 6: the distributive-property option 5x + 20 is 43px at the button font
     and wrapped onto two lines inside a 40px content box (Sep 2026). Shrinking the text was
     rejected as too small, 2px sides as gaudy; 4px is the room that still reads as a margin. */
  padding: 4px 4px;
  position: relative;
  width: 52px;
}

/* Never wrap an answer: a two-line option is unreadable at this size. */
.fact-button .katex {
  white-space: nowrap;
}

.fact-button:focus, .song-note-button:focus {
  outline: none;
}

#fact-div.skills .fact-button {
  cursor: pointer;
  opacity: 1;
}

#fact-div.skills.bonding .fact-button-tooltip, #fact-div.skills.bonding #power-background-cost {
  color: #ff80bf;
  filter: drop-shadow(2px 4px 6px rgb(10, 9, 10));
}

#fact-div.skills.bonding .fact-button-tooltip svg path, #fact-div.skills.bonding #power-background-cost svg path {
  fill: #ff80bf;
}

.fact-button.incorrect {
  opacity: 0;
  transition: opacity 500ms ease-in-out;
}

/* Children must not intercept pointer events — on iPad, fingers land on the inner
   KaTeX/span content, which makes event.target the span (not the button) and the
   document-level pointerDown dispatcher falls through to the drag branch instead
   of the fact-button branch. */
.fact-button > * { pointer-events: none; }

.fact-button-span {
  padding-top: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
/* Two-line value+unit answers (geometry/conversion skills). Plain HTML flex
   stack — KaTeX's substack didn't center reliably inside the button. The
   value is rendered via KaTeX (inherits font from button at 0.8em); unit
   label uses KaTeX_Main serif so its font matches the math content. */
.fact-button-span .unit-answer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1.05;
  font-size: 0.8em;
}
.fact-button-span .unit-answer .unit-label {
  font-family: KaTeX_Main, 'Times New Roman', serif;
  font-size: 0.72em;
  opacity: 0.8;
  margin-top: 1px;
}
/* Two-line stacked answer (both lines equal weight, e.g., elapsed-time
   "6 hr / 40 min"). Lines stay close vertically so they share the button
   space without either needing to shrink. */
.fact-button-span .stacked-answer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 1.05;
  font-size: 0.78em;
}

#board-facts .fact-button-span {
  scale: 1.125;
}

#fact-div.right .fact-button-span.fraction {
  font-size: 1.15em;
}

/* Override the generic \`.fraction { margin-right: 0.35em }\` from app.css —
   inside an answer button, the span is a flex container that fills the
   button and should not have trailing margin, otherwise its content visually
   veers left. */
.fact-button-span.fraction {
  margin-right: 0;
}

#fact-div.right .fact-button-span.chars-4 {
  font-size: 0.85em;
}

#fact-div.right .fact-button-span.chars-5 {
  font-size: 0.8em;
}

#fact-div.right .fact-button-span.chars-6 {
  font-size: 0.75em;
}

#fact-div.right .fact-button-span.chars-7 {
  font-size: 0.7em;
}

#fact-div.right .fact-button-span.chars-8 {
  font-size: 0.65em;
}

/* Word-only answers (aro/tc/qc classifications) — text in body font is wider
   than digits at the same point size, so use a smaller scale + allow wrap so
   long classifications like "Parallelogram" fit. Scoped to .fact-button-span
   without the #fact-div.right parent so it works in both skills and right modes. */
.fact-button-span.chars-text {
  font-size: 0.7em;
  line-height: 1.05;
  white-space: normal;
  padding: 0 2px;
}

.fact-button-span svg {
  height: 90%;
  width: 90%;
}

.fact-button-tooltip, .item-count-tooltip, #power-background-cost, .song-note-button-tooltip {
  background-color: rgba(10, 9, 10, 0.5);
  border-radius: 4px;
  bottom: 1.5px;
  color: rgba(250, 225, 225, 0.9);
  display: flex;
  flex-direction: row;
  font-size: 8.5px;
  font-weight: 500;
  left: 2.5px;
  padding: 2px 4px 2px 4.5px;
  position: absolute;
}

.item-count-tooltip {
  bottom: 2.5px;
  font-family: Archivo, sans-serif;
  left: auto;
  right: 2.5px;
}

#fact-div:not(.skills) .fact-button-tooltip {
  opacity: 0;
}

#fact-div:not(.skills):hover .fact-button-tooltip {
  opacity: 1;
}

.fact-button-tooltip svg, #power-background-cost svg {
  height: 7.5px;
  margin: 0 2px 0 -1px;
  padding-top: 1px;
  width: 7.5px;
}

#fact-center {
  margin: 0 6px;
}

#fact-div, #song-div {
  color: rgb(250, 225, 225);
  display: flex;
  font-family: Archivo, sans-serif;
  font-weight: 650;
  flex-direction: column;
  text-shadow: 1px 1px rgb(10, 9, 9);
  transition: opacity 250ms ease-in-out;
  width: 100%;
}

/* Game context styles */
#fact-div.right, #song-div {
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.35) -100%, rgba(20, 18, 18, 0.7) 200%);
  backdrop-filter: blur(12.5px);
  border-radius: 4px;
  box-shadow: 0.15vmin 0.15vmin rgba(10, 9, 9, 0.5);
  box-sizing: border-box;
  filter: brightness(1.25);
  height: 120px;
  padding: 6px;
  position: absolute;
  right: calc(25% - 90px);
  top: calc(50% - 60px);
  width: 180px;
}

#fact-div.right.visible, #song-div-overlay.visible {
  opacity: 1;
}

#fact-div.right:not(.visible), #song-div-overlay:not(.visible) {
  opacity: 0;
  z-index: -1;
}

/* a fact already shown stays faded while hidden (event.js, the fact echo): still draggable, but a press
   on it answers nothing (event.js pointerDown) */
#fact-div.right.revealed:not(.visible):not(.skills):not(.loading-skills):not(.powering-up) {
  opacity: 0.35;
  z-index: 1;
}

#fact-div.right.answered:not(.visible):not(.skills) {
  opacity: 1;
  z-index: 1;
}

#fact-div svg path.skill-type {
  transition: fill 175ms;
}

#fact-div.fire svg path.skill-type {
  fill: var(--avatar-color, #ff80bf) !important;
  filter: brightness(0.8);
}

#fact-div.water svg path.skill-type {
  fill: #73e6d2 !important;
  filter: brightness(0.8);
}
#fact-div.wind svg path.skill-type {
  fill: #ffe666 !important;
  filter: brightness(0.8);
}

#fact-question, #song-header, #song-staff {
  align-items: center;
  background: linear-gradient(to bottom, rgba(200, 180, 180, 0.2) -100%, rgba(50, 45, 45, 0.2) 125%);
  border-radius: 4px;
  box-shadow: 1px 1px rgba(10, 9, 9, 0.25);
  display: flex;
  height: 68px;
  justify-content: center;
  margin-bottom: 6px;
  width: 100%;
}

#fact-div.skills #fact-question {
  background: linear-gradient(to bottom, rgba(200, 180, 180, 0.6) -100%, rgba(50, 45, 45, 0.6) 125%);
}

/* Use the \`translate\` property (not \`transform\`) so the question-scaling code's
   inline \`transform: scale(...)\` composes with the nudge instead of overriding it. */
#fact-question[data-skill="r"] > span, #fact-question[data-skill="dr"] > span,
#fact-question[data-skill="ef"] > span {
  translate: 0 2.5px;
}
/* pc (percent change) copies the rounding layout but not rounding's 0.95em digits, so at
   rounding's 2.5px it still sat ~2.8px high (measured live, Sep 2026); at 4px it lands where
   ca/sa/ae/et do. */
/* New gathered-format skills sit slightly higher visually because their second
   line uses scriptstyle (smaller than rounding's). Larger translateY (4px) to
   compensate so the 2-line content sits centered in the 68px question box. */
#fact-question[data-skill="ca"] > span, #fact-question[data-skill="sa"] > span,
#fact-question[data-skill="ae"] > span, #fact-question[data-skill="et"] > span,
#fact-question[data-skill="pc"] > span {
  translate: 0 4px;
}

#fact-question[data-skill="lfa"] > span, #fact-question[data-skill="lfs"] > span,
#fact-question[data-skill="fm"] > span, #fact-question[data-skill="fd"] > span,
#fact-question[data-skill="fc"] > span, #fact-question[data-skill="fs"] > span,
#fact-question[data-skill="ifc"] > span, #fact-question[data-skill="mnc"] > span,
#fact-question[data-skill="ef"] > span, #fact-question[data-skill="ufa"] > span,
#fact-question[data-skill="ufs"] > span, #fact-question[data-skill="fdc"] > span,
#fact-question[data-skill="fpc"] > span {
  font-size: 1.15em;
}

/* Equivalent fractions: the boxed blank adds height to whichever side it is on, and a KaTeX
   fraction's inline box does not cover that, so the ink sits ~5px low with the blank in a
   numerator and ~5px high with it in a denominator (measured live, Sep 2026). The slot is
   already on the question as data-a (x_a / x_c numerators, x_b / x_d denominators), so the
   nudge is decided from the generated problem, before render, with no measuring. */
#fact-question[data-skill="ef"][data-a="x_a"] > span, #fact-question[data-skill="ef"][data-a="x_c"] > span {
  translate: 0 -5px;
}

#fact-question[data-skill="ef"][data-a="x_b"] > span, #fact-question[data-skill="ef"][data-a="x_d"] > span {
  translate: 0 5px;
}
/* Geometry skills (verb + SVG): scale the verb's KaTeX block down so the
   \`\\text{Verb: }\` rendering visually matches old fs's "Simplify fully:".
   Using descendant selector (not direct child) for resilience. */
#fact-question[data-skill="ar"] .katex,
#fact-question[data-skill="pr"] .katex,
#fact-question[data-skill="vrp"] .katex,
#fact-question[data-skill="at"] .katex,
#fact-question[data-skill="aro"] .katex,
#fact-question[data-skill="ac"] .katex,
#fact-question[data-skill="cc"] .katex {
  font-size: 0.85em;
}

#fact-question[data-skill="r"] .mord, #fact-question[data-skill="dr"] .mord {
  font-size: 0.95em;
}

#board-facts #fact-question > span {
  scale: 1.125;
}

#fact-question span.amsrm {
  text-shadow: none;
}

#fact-question span.fbox {
  background: linear-gradient(to bottom, rgba(200, 180, 180, 0.1) -100%, rgba(50, 45, 45, 0.1) 125%);
  border-radius: 4px;
  box-shadow: 0.15vmin 0.15vmin rgba(10, 9, 9, 0.5);
  scale: 0.85;
}

/* Generic icon SVGs (speaker, alert, etc.) — fixed 16px. Geometry/diagram SVGs
   carry the \`.geo\` class to opt out and render at their declared dimensions. */
#fact-question svg:not(.geo), #song-staff svg {
  height: 16px;
  margin-right: 4.5px;
  width: 16px;
}
#fact-question svg.geo {
  vertical-align: middle;
  margin-left: 4px;
}
/* Polygon-type shapes (rectangles, triangles, prisms, circles) sit slightly
   higher than ideal — nudge down 3px. aro's angle drawing is already
   vertically centered via its own <g transform> so it skips this. Use the
   \`translate\` property so it composes with the inline \`transform: scale(...)\`
   the question-scaling code applies when content overflows. */
#fact-question[data-skill="ar"] svg.geo,
#fact-question[data-skill="pr"] svg.geo,
#fact-question[data-skill="vrp"] svg.geo,
#fact-question[data-skill="at"] svg.geo,
#fact-question[data-skill="ac"] svg.geo,
#fact-question[data-skill="cc"] svg.geo {
  translate: 0 3px;
}
/* SVG text labels match KaTeX's main font (Computer Modern serif). Thin dark
   stroke + dark drop-shadow gives labels a tight outline plus a soft halo so
   they stay legible against shape strokes and the panel background. SVG renders
   in document order — labels are written after the shape and paint above. */
#fact-question svg.geo text {
  font-family: KaTeX_Main, 'Times New Roman', serif;
  font-weight: normal; /* parent inherits 650 which made labels look bold */
  paint-order: stroke fill;
  stroke: rgb(10, 9, 9);
  stroke-width: 0.6px;
  stroke-linejoin: round;
  filter: drop-shadow(0 0 2px rgb(10, 9, 9));
}

#fact-div.powering-up #fact-bottom, 
#fact-div.powering-up #fact-question {
  opacity: 0;
}

#power-background {
  align-items: center;
  display: flex;
  justify-content: center;
  opacity: 1;
  overflow: hidden;
  scale: 0.99;
  text-shadow: 1px 1px rgba(10, 9, 9, 0.5);
  transform: translateX(-1px);
}

#power-background circle.color {
  fill: #ff409f;
}

/* In battle the power-up circle takes the avatar's own colour (set on the game div by drawAvatar). */
#fact-div.fire #power-background circle.color {
  fill: var(--avatar-color-dark, #ff409f);
}

/* In battle the starry power-up background is the darkened avatar colour, not the shared
   teal-pink-yellow gradient, with the same pale wash at the top the fact background has. */
#fact-div.fire.battle #power-background {
  background: linear-gradient(to top, transparent 75%, rgba(250, 225, 225, 0.5) 100%);
  background-color: var(--avatar-color-dark, #ff80bf);
}

#fact-div:not(.powering-up) #power-background {
  border: none !important;
}

#power-background-cost {
  left: 50%;
  transform: scale(1.5) translate(-33.33%, -1.5px);
  transform-origin: bottom center;
}

#power-background-span {
  display: flex;
  filter: drop-shadow(0 0 10px rgba(10, 9, 9, 0.5));
  opacity: 0;
  transition: opacity 1000ms ease-in-out;
}

#fact-div.powering-up #power-background-span {
  opacity: 1;
}

#power-background-span svg {
  height: 16px;
  margin-right: 4px;
  transform: translateY(1px);
  width: 16px;
}

.power-background-star {
  opacity: var(--power-percent, 0%);
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: -1;
}

#fact-div:not(.powering-up) .power-background-star {
  opacity: 0;
}

#record-stop-button {
  margin-left: 0.75vmin;
}

.video-icon {
  display: flex;
  padding-right: 3px;
}
/* #endregion */
/* #region #avatar-div */
#avatar-style-div {
  display: flex;
  flex-direction: row;
}

#avatar-preview-div {
  align-items: center;
  background: rgba(250, 225, 225, 0.25);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  margin-left: 6px;
  width: 120px;
}

#avatar-preview-div canvas {
  height: 80px;
  width: 80px;
}

.avatar-select-button {
  height: 27.5px !important;
  width: 32px !important;
}

.avatar-select-button svg {
  height: 14px;
  width: 14px;
}

.avatar-select-div {
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 128px;
}

.avatar-select-label {
  font-size: 14px;
}

.avatar-select-span {
  font-size: 14px;
  font-stretch: 95%;
  padding: 6px;
}

#avatar-settings-div {
  width: 224px;
}

.avatar-setting-div {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.avatar-setting-div:not(:last-child) {
  margin-bottom: 5px;
}

#enter-button:hover {
  background: linear-gradient(45deg, #73e6d2 0%, #ff80bf 50%, #ffe666 100%);
  color: rgb(10, 9, 9);
  text-shadow: 0.05vmin 0.05vmin rgba(250, 225, 225, 0.5);
}

#enter-button, #enter-div {
  width: 100%;
}

#enter-div {
  margin-top: 6px;
}

#nickname-div {
  align-items: center;
  display: flex;
  margin-bottom: 6px;
}

#nickname-input {
  font-family: 'Unifont', monospace;
  height: 42px;
  margin: 0 6px 0 11px;
  width: 170.8px;
}

#avatar-div {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 362px;
  z-index: 2;
}

.ui button.trait-button {
  font-size: 15px;
  height: 28px;
  margin: 0 3px 3px 0;
}

.ui button.trait-button.selected {
  background: var(--student-color-dark);
}

.ui button.trait-button.selected:hover {
  background: var(--student-color-mid) !important;
}

#traits-div {
  width: 350px;
}

#traits-grid {
  background: rgba(250, 225, 225, 0.25);
  border-radius: 4px;
  padding: 3px 3px 0 3px;
}

#traits-header {
  align-items: center;
  display: flex;
  height: 37.5px;
}

#traits-header-left {
  font-size: 16px;
  width: 50%;
}

#traits-header-right {
  font-size: 14px;
  text-align: end;
  width: 50%;
}

.video-step.locked {
  opacity: 0.4;
  pointer-events: none;
}

.video-step.locked .video-step-title-span,
.video-step.title-hidden .video-step-title-span {
  background: linear-gradient(rgba(200, 180, 180, 0.5) -150%, rgba(100, 90, 90, 0.5) 125%);
  border-radius: 4px;
  color: transparent;
  text-shadow: none;
}

.video-step-button {
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  transition: filter 100ms ease-in-out;
}

.video-step-button:hover {
  filter: drop-shadow(0 0 25px var(--student-color-mid));
}

.video-step-button:hover .circle {
  fill: var(--student-color-mid) !important;
  fill-opacity: 0.125;
}

.video-step-button.playing {
  filter: drop-shadow(0 0 25px var(--student-color-value));
}

.video-step-button.playing .circle {
  fill: var(--student-color-value) !important;
  fill-opacity: 0.5;
  stroke: var(--student-color-value) !important;
  stroke-opacity: 0.5;
}

.video-step-button.paused {
  filter: drop-shadow(0 0 15px var(--student-color-mid));
}

/* A step's progress bar can be pressed to play from that point, over what has been played. */
.video-step:not(.locked) .video-step-bar,
.video-step:not(.locked) .video-step-progress-bar {
  cursor: pointer;
}

.video-step-button.paused .circle {
  fill: var(--student-color-mid) !important;
  fill-opacity: 0.3;
}

.video-step-button.paused:hover .video-step-label {
  opacity: 0;
}

.video-step-button.paused:hover::after {
  content: '';
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 13px 13px;
  background-repeat: no-repeat;
  background-position: center;
  height: 13px;
  width: 13px;
  pointer-events: none;
}

.video-step-button.loading {
  animation: video-load-pulse 1.5s infinite;
}

@keyframes video-load-pulse {
  0%, 100% {
    filter: drop-shadow(0 0 8px var(--student-color-mid));
  }
  50% {
    filter: drop-shadow(0 0 20px var(--student-color-value));
  }
}

.video-step-button.initial-emphasis {
  animation: video-initial-emphasis 1.5s infinite;
}

@keyframes video-initial-emphasis {
  0%, 100% {
    filter: drop-shadow(0 0 20px var(--student-color-value)) drop-shadow(0 0 10px var(--student-color-value));
  }
  50% {
    filter: drop-shadow(0 0 40px var(--student-color-value)) drop-shadow(0 0 20px var(--student-color-value));
  }
}

/* Show play icon when hovering over non-playing, non-paused steps */
.video-step-button:not(.playing):not(.paused):not(.initial-emphasis):hover .video-step-label {
  opacity: 0;
}

.video-step-button:not(.playing):not(.paused):not(.initial-emphasis):hover::after {
  content: '';
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 13px 13px;
  background-repeat: no-repeat;
  background-position: center;
  height: 13px;
  width: 13px;
  pointer-events: none;
}

.video-step-label {
  font-size: 12px;
  pointer-events: none;
  position: absolute;
}

.video-step-label svg {
  height: 13px !important;
  padding: 2px 0 0 1px;
  width: 13px !important;
}

.video-step-left svg {
  height: 32px;
  width: 32px;
}
/* #endregion */
/* #region .toolbar */
.toolbar {
  align-items: center;
  backdrop-filter: blur(10px);
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.1) -100%, rgba(20, 18, 18, 0.65) 200%);
  background-color: rgb(55, 50, 50, 0.5);
  border: none;
  box-sizing: border-box; 
  color: rgb(250, 225, 225);
  display: inline-flex;
  font-family: Archivo, sans-serif;
  font-size: 16px;
  font-stretch: 95%;
  height: 36px;
  left: 0px;
  letter-spacing: 0.025em;
  padding: 1.5px 3px 2px 3px;
  position: fixed;
  top: 0px;
  transition: background-color 100ms ease-in-out, border-bottom 100ms ease-in-out, box-shadow 100ms ease-in-out;
  width: 100%;
  z-index: 1;
}

.toolbar button {
  outline: none;
}

.toolbar-center {
  align-items: center;
  display: flex;
  flex: 1 0;
  font-family: Archivo, sans-serif;
  font-size: 13px;
  font-stretch: 75%;
  height: 30px;
  justify-content: center;
  letter-spacing: 0.025em;
  margin: 0px 3px;
  overflow: hidden;
  padding-bottom: 1px;
  text-align: center;
  text-transform: uppercase;
}

#toolbar-close-button {
  opacity: 0.5;
  width: 50px;
}

#toolbar-close-button svg {
  height: 15px;
  padding-top: 0.5px;
  width: 15px;
}

#toolbar-galaxy-button, #toolbar-sound-button {
  display: none;
}

.toolbar-left, .toolbar-right {
  display: flex;
  flex: 0 1;
}

/* Accumulated reward/damage boxes must CLIP, not shove the close button off-screen: pin the right
   cluster so it never shrinks, let the left cluster shrink + hide its overflow, and keep the points
   counter itself pinned so only the boxes clip. */
.toolbar-left {
  flex: 0 1 auto; /* content-sized basis (NOT 0%), so it stays visible; only shrinks under overflow */
  min-width: 0;
  overflow: hidden;
}

/* When reward/damage boxes are present, fade the right edge so a clipped box trails off softly instead of
   a hard cut. :has() scopes it so the bare score (no boxes) is never faded. toolbar-left grows to fill the
   bar (and toolbar-center yields its grow) so the fade sits at a FIXED right edge — over empty trailing
   space when the boxes fit (invisible), over the clipped box only when they overflow — never on the last
   box itself. */
.toolbar-left:has(.toolbar-score-update-span) {
  flex-grow: 1;
  -webkit-mask-image: linear-gradient(to right, #000 calc(100% - 20px), transparent);
  mask-image: linear-gradient(to right, #000 calc(100% - 20px), transparent);
}
.toolbar:has(.toolbar-score-update-span) .toolbar-center {
  flex-grow: 0;
}
.toolbar-right {
  flex-shrink: 0;
}
#toolbar-score {
  flex-shrink: 0;
}

.toolbar.help.student .toolbar-center:hover #toolbar-number-box, .toolbar-right {
  display: flex;
}

#toolbar-help-span {
  display: none;
  color: rgb(250, 225, 225);
  overflow: hidden;
  text-shadow: 0.05vmin 0.05vmin var(--student-color-dark);
  white-space: nowrap;
}

#toolbar-navigation {
  display: flex;
  font-family: Archivo, sans-serif;
  font-size: 12px;
  font-stretch: 95%;
  letter-spacing: 0.025em;
  padding: 5px;
}

#toolbar-navigation button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  height: 26px;
  padding: 6px;
  width: 26px;
}

.toolbar-right button {
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) -300%, rgba(20, 18, 18, 0.5) 300%);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  height: 30px;
  margin-left: 3px;
  padding: 7px 7px 7px 7.5px;
  width: 30px;
}

#toolbar-score, .toolbar-score-update-span {
  align-items: center;
  background: linear-gradient(to bottom, rgba(200, 180, 180, 0.4) -100%, rgba(50, 45, 45, 0.4) 125%);
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  font-size: 12px;
  font-weight: 550;
  height: 30px;
  letter-spacing: 0.025em;
  margin: 0px 3px 0px 3px;
  padding: 6px 8px 7px 4px;
  text-shadow: 0.05vmin 0.05vmin rgba(10, 9, 9, 0.5);
}

#toolbar-score-unit {
  display: flex;
}

#toolbar-score-unit svg {
  height: 11px;
  padding: 1px;
  width: auto;
}

/* Offline mode: hide / disable UI that doesn't make sense without a session.
   The \`offline\` class is applied to <html> by bootOffline() — anything scoped
   under it only renders when the URL hash is \`#offline\`. */

/* Hide score, toolbox, notes button, chart panel (Stats/Rankings/Join) —
   nothing persists past the session and there's no teacher dashboard to
   receive interactions. The .toolbar prefix on the notes-button selector
   matches the specificity of the existing \`.toolbar.slide #toolbar-notes-button
   { display: block }\` rule in app.css that would otherwise override us. */
html.offline #toolbar-score,
html.offline #toolbar-score-update,
html.offline .toolbar-score-update-span,
html.offline .toolbox,
html.offline .toolbar #toolbar-scaffold-button,
html.offline #chart-div {
  display: none;
}

/* Nametag — non-interactive in offline (no avatar / friends / panel to open). */
html.offline .nametag {
  cursor: default;
}

/* Board panel: hide Video, Facts, record-stop entirely in offline mode —
   they depend on write-back / network machinery that doesn't run here.
   Only Instructions remains; when the slide has no instructions content
   (panel.js sets \`disabled\`), de-emphasize it visually. */
html.offline #video-button,
html.offline #facts-button,
html.offline #record-stop-button {
  display: none;
}
html.offline #instructions-button:disabled {
  cursor: default;
  pointer-events: none;
}
html.offline #instructions-button:disabled span,
html.offline #instructions-button:disabled svg {
  opacity: 0.25;
}
/* With the side buttons hidden, collapse the now-empty header-left/right
   and let header-center (which holds Instructions) fill the panel width. */
html.offline #board-div .header-left,
html.offline #board-div .header-right {
  display: none;
}
html.offline #board-div .header-center {
  flex: 1;
}

#toolbar-score-update {
  display: flex;
  flex-direction: row;
  min-width: 0;
  /* Clip horizontal squeeze only — plain \`overflow: hidden\` also clipped the
     bonus-detail popup, which hangs below the span at top: 125%. */
  overflow-x: clip;
  overflow-y: visible;
}

.toolbar-score-update-popup {
  background: linear-gradient(to bottom, rgb(40, 40, 40) -100%, rgba(20, 20, 20) 125%);
  border: 1px solid rgb(30, 30, 30);
  border-radius: 4px;
  font-size: 12px;
  left: 50%;
  line-height: 14px;
  padding: 3px 6px 5px 6px;
  position: absolute;
  text-shadow: 0.05vmin 0.05vmin rgba(10, 10, 10);
  top: 125%;
  transform: translateX(-50%);
  width: max-content;
}

.toolbar-score-update-popup::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid rgb(30, 30, 30); /* Match the bubble's background color */
}

.toolbar-score-update-popup b {
  font-weight: 750;
}

.toolbar-score-update-span {
  background: linear-gradient(to bottom, rgba(200, 180, 180, 0.3) -100%, rgba(50, 45, 45, 0.5) 125%);
  filter: saturate(2);
  margin: 0px 3px 0px 0px;
  padding: 6px 7px 7px 7px;
  position: relative;
  transition: opacity 750ms ease-in-out;
}

.toolbar-score-update-span.correct {
  background-color: rgb(34, 77, 41);
}

.toolbar-score-update-span.correct .toolbar-score-update-popup {
  color: rgb(73, 166, 88);
}

.toolbar-score-update-span.damage {
  background-color: rgb(77, 19, 19, 0.625);
}

.toolbar-score-update-span.expense {
  background-color: rgba(25, 23, 25, 0.25);
}

.toolbar-score-update-span.fairy {
  background-color: rgba(255, 128, 191, 0.25);
}

.toolbar-score-update-span.reward {
  background-color: rgba(255, 172, 51, 0.25);
}

.toolbar-score-update-span.reward .toolbar-score-update-popup {
  color: rgb(255, 172, 51);
}

#toolbar-title {
  display: none;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
}
/* #endregion */
/* #region .toolbox */
.toolbox {
  bottom: 3px;
  bottom: calc(env(safe-area-inset-bottom) + 3px);
  display: flex;
  max-width: 100vmin;
  opacity: 1;
  position: fixed;
  transition: opacity 250ms ease-in-out;
  /* Ten 32px buttons (see --b below): 10 x 32 + 58px of padding and margins. */
  width: 378px;
  /* Above every panel (.visible is 2), so a tool's options row is never under the expanded
     notepad, whichever was added to the slide last (user directive, Oct 2026). */
  z-index: 3;
}

.slide-div.video .toolbox:not(:hover) {
  opacity: 0.25;
}

/* Two 32px buttons (emote, controller), 4px apart, inside the section's 4px padding: the lesson
   toolbox's button size, so the two match (they went from 35.8px together, Oct 2026). */
.toolbox.game {
  width: 76px;
}

#toolbox-control-section {
  grid-template-columns: 1fr 1fr;
}

/* The emote row: the lesson subtoolbox's 24px buttons, centred on the emote button
   (4px padding + half of 32px from the toolbox's left edge). */
.toolbox.game .subtoolbox {
  left: 20px;
  transform: translateX(-50%);
  width: calc(var(--count) * 24px + (var(--count) - 1) * 4px);
}

/* Bigger emotes in the same buttons (user request, Sep 2026): the padding gives way so the
   13-unit pixel icon draws at 19.5px, exactly 1.5px a pixel (3 device px at 2x) where the
   lesson padding left it at an uneven 1.12. The buttons, and so the row's centring above the
   emote button, are unchanged. (24px buttons since Oct 2026: the padding is what keeps the icon
   at 19.5px, (24 - 19.5) / 2.) */
.toolbox.game .subtoolbox button {
  padding: 2.25px;
}

html.dash.student .toolbox {
  opacity: 0.5;
}

html.dash.student .toolbox:hover {
  opacity: 1;
}

.toolbox button {
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) -300%, rgba(20, 18, 18, 0.3) 300%);
  border: none;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  outline: none;
  padding: 7px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.toolbox button.selected {
  background: linear-gradient(to bottom, rgba(200, 180, 180, 0.4) -100%, rgba(50, 45, 45, 0.4) 125%);
}

.toolbox.game button.selected {
  background: linear-gradient(to bottom, rgba(200, 180, 180, 0.2) -100%, rgba(50, 45, 45, 0.2) 125%);
}

.toolbox button svg {
  height: 100%;
  width: 100%;
}

/* Ten buttons: undo and redo, the five drawing tools, and the calculator, chart and notes (notes
   joined in Oct 2026; the buttons went from 35.8px to 32px to make room, user pick). With --b one button, the sections hold 2b + 4px, 5b + 16px
   and 3b + 8px; with their 8px of padding each and the two 3px margins that is 10b + 58px, the
   whole toolbox, so b is (100% - 58px) / 10 of it. Sized exactly rather than by flex bases, so every
   button is the same width at any toolbox width. */
.toolbox {
  --b: calc((100% - 58px) / 10);
}

#toolbox-command-section {
  flex: none;
  grid-template-columns: 1fr 1fr;
  margin-right: 3px;
  width: calc(var(--b) * 2 + 4px);
}

#toolbox-draw-section {
  flex: none;
  grid-template-columns: repeat(5, 1fr);
  margin-right: 3px;
  width: calc(var(--b) * 5 + 16px);
}

#toolbox-math-section {
  flex: none;
  grid-template-columns: repeat(3, 1fr);
  width: calc(var(--b) * 3 + 8px);
}

.toolbox-section {
  backdrop-filter: blur(10px);
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.1) -100%, rgba(20, 18, 18, 0.5) 200%);
  border-radius: 4px;
  display: grid;
  gap: 4px;
  padding: 4px;
}

/* A tool's options: a row of 2/3-size toolbox buttons sitting 3px above the toolbox, centred on
   its tool's button (user directive, Sep 2026; it was left-aligned with the draw section). With
   --b one button (see #toolbox-command-section), the draw section starts after the command
   section's 2b + 12px and its 3px margin, and its buttons after its own 4px padding, 4px apart:
   button --index is centred at 2.5b + 19px + index * (b + 4px). Three quarters of b per option
   button, 24px at the full 32px (half was too small, then two thirds, 21.33px, raised to 24px on
   request, Oct 2026), plus this row's 4px gaps, is the content width below, and the
   row's full width (plus its 8px of padding) halved comes off that centre. The option padding is
   4px (it was 2/3 of 7px; trimmed so the icons are a little bigger in the same buttons, user
   directive Oct 2026). */
.subtoolbox {
  bottom: calc(100% + 3px);
  display: none;
  grid-template-columns: repeat(var(--count), 1fr);
  left: calc(var(--b) * 2.5 + 19px + var(--index, 0) * (var(--b) + 4px) - (var(--count) * (var(--b) * 3 / 4 + 4px) + 4px) / 2);
  position: absolute;
  width: calc(var(--count) * (var(--b) * 3 / 4 + 4px) - 4px);
}

.subtoolbox.visible {
  display: grid;
}

.subtoolbox button {
  padding: 4px;
}

/* An eraser option: the eraser icon with the tool's icon over it at FULL size, MIRRORED so it
   points northeast and the two cross (the eraser runs northwest). A smaller icon on the eraser's
   face was too small to make out, and a quarter turn was replaced by the mirror (user choice).
   The T is symmetrical, so it stays upright. */
.subtoolbox-stack {
  display: block;
  position: relative;
  width: 100%;
}

/* Block, so no inline descender gap stretches the stack taller than the square icon. */
.subtoolbox-stack svg {
  display: block;
}

.subtoolbox-overlay {
  inset: 0;
  position: absolute;
  transform: scaleX(-1);
}
/* #endregion */
/* #region index.js */
body {
  align-items: center;
  background: linear-gradient(33deg, #211a1e 0%, #19211e 100%);
  background-color: rgb(30, 27, 27);
  display: flex;
  justify-content: center;
  margin: 0px auto;
  transition: background-color 350ms ease-in-out;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

/* #region .audio-button */
.audio-button {
  /* Match the active-button gradient shape (same one used by
     \`.toolbag-button.active\`) but driven by the student color scheme
     rather than the toolbag palette — brighter, better contrast against
     the narration-outline, and consistent with other per-student
     activated surfaces across the slide. */
  background: linear-gradient(var(--student-color-mid) -150%, var(--student-color-dark) 125%);
  border: none;
  border-radius: 4px 0 4px 0;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  height: 26px;
  /* Semi-transparent so if the button happens to sit over a bit of text
     (top-left of a tightly-packed text block), the text remains readable
     underneath. Full opacity on hover/focus so it's clear when active. */
  opacity: 0.5;
  outline: none;
  padding: 5px;
  pointer-events: auto;
  position: absolute;
  transition: opacity 150ms ease-in-out;
  width: 26px;
  z-index: 6;
}

.audio-button:hover,
.audio-button:focus-visible {
  opacity: 1;
}

.audio-button svg {
  height: 100%;
  width: 100%;
}

.audio-button svg path {
  fill: rgb(250, 225, 225) !important;
  stroke: none;
}

html.dash:not(.focused-session) .audio-button {
  display: none;
}

/* Mobile's \`.canvas-div\` gets \`transform: scale(2)\` to enlarge slide content
   (index.css:165). Everything nested inside — including the audio button —
   inherits that 2× scale. Counter-scale from the top-left so the button
   renders at its intended 24px size while staying pinned to the text-div's
   top-left corner where we placed it. */
html.mobile .audio-button {
  transform: scale(0.5);
  transform-origin: top left;
}

/* Gentle semi-transparent outline around any .text-div that has an audio
   button, so the teacher can see exactly which block the narration covers.
   \`outline\` (with offset) sits 3px outside the text-div without taking
   layout space — unlike a border it doesn't add width/height/padding.
   Hidden in unfocused dash tiles to match .audio-button. */
/* Narration outline — unified overlay system. slide.js inserts a
   .narration-outline absolutely-positioned sibling of the narrated text-div(s)
   inside .content-div and sizes it imperatively from their offset rects.
   Works for solo (wraps one text-div) and merged text0+text1 (wraps both).
   Text-divs themselves carry no narration class, so their per-problem
   margins/layout are never touched. */
.narration-outline {
  border-radius: 2px;
  outline: 1px solid color-mix(in srgb, var(--student-color-mid) 50%, transparent);
  outline-offset: 3px;
  pointer-events: none;
  position: absolute;
}

/* Short outlines (≤ 20px tall) — typical for single-line narrated
   text — can't fully contain the 26px audio button. The .compact
   class is toggled on the button by the narration positioner in
   slide.js based on the measured outline height. Round the LEFT side
   of the button so it reads as a tab extending left from the narration
   region rather than an overflowing diamond. */
.audio-button.compact {
  border-radius: 4px 0 0 4px;
}

html.dash:not(.focused-session) .narration-outline {
  outline: none;
}

.text-div {
  position: relative;
}
/* #endregion */

#body {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: calc(100% - 50px);
  justify-content: center;
}

button:disabled {
  opacity: 0.25 !important;
  pointer-events: none !important;
}

button * {
  pointer-events: none !important;
}

.color-button {
  background-clip: content-box;
  background-size: cover;
  box-shadow: 0.05vmin 0.05vmin rgba(10, 9, 9, 0.5) !important;
  color: rgb(250, 225, 225);
  font-size: 12.5px !important;
  opacity: 0.75;
  padding: 0px !important;
  text-shadow: 0.125vmin 0.125vmin rgba(10, 9, 9, 0.5);
  width: 72px;
}

[contenteditable] {
  user-select: text;
  -webkit-user-select: text;
}

.email-input, .name-input, .password-input {
  margin-bottom: 6px;
  width: 100%;
}

.emoji-button {
  height: 40.75px !important;
  padding: 6px !important;
  width: 40.75px;
}

.emoji-button svg {
  height: 28.75px;
  width: 28.75px;
}

#emoji-table {
  display: none;
}

#emoji-table button[disabled] svg {
  opacity: 0;
}

#footer {
  align-items: center;
  bottom: 0px;
  bottom: env(safe-area-inset-bottom);
  color: rgba(250, 225, 225, 0.5);
  display: flex;
  flex-direction: column;
  font-family: Archivo, sans-serif;
  font-size: 13px;
  font-stretch: 102%;
  font-weight: 500;
  left: 50%;
  letter-spacing: 0.025em;
  margin-bottom: 3px;
  position: fixed;
  transform: translateX(-50%);
  transition: opacity 350ms ease-in-out;
  width: 320px;
  z-index: 0;
}

#footer-home-div {
  text-align: center;
}

#footer-home-button {
  background: none;
  border: none;
  padding: 0;
  width: 130px;
}

#footer-home-button:disabled {
  opacity: 1 !important;
}

#footer-home-button path {
  fill: rgba(220, 198, 198, 0.4);
}

#footer-home-button svg {
  display: block;
  height: 20px;
  width: 130px;
}

.footer-button {
  background-color: rgba(220, 198, 198, 0.325);
  border: none;
  border-radius: 4px;
  color: rgb(10, 9, 9);
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  margin: 3px;
  padding: 3px 7px;
  transition: opacity 350ms ease-in-out;
}

.grade-separator {
  border: 1px solid rgba(10, 9, 9, 0.2);
}

#header {
  align-items: end;
  box-sizing: border-box;
  display: flex;
  height: 160px;
  padding-bottom: 6px;
  position: fixed;
  top: 6px;
  transition: opacity 350ms ease-in-out;
  width: 180px;
  z-index: 0;
}

#header path {
  fill: rgba(220, 198, 198, 0.4);
}

#home {
  display: flex;
  flex-direction: column;
  height: 90%;
  width: 320px;
}

#home div.ui, #schedule div.ui {
  display: block;
  margin-top: 6px;
  width: 320px;
}

#home .text {
  font-size: 14px;
  margin: -6px 0px 3px 0px;
  text-align: center;
}

#home video {
  border-radius: 4px;
  box-shadow: 0.15vmin 0.15vmin rgba(10, 9, 9, 0.5)
}

#home-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  mask-image: linear-gradient(rgba(0, 0, 0, calc(1 - var(--scroll))) 0%, rgba(0, 0, 0, calc(0.75 * (1 / var(--scroll)))) 5%, rgba(0, 0, 0, 1) 10%, rgba(0, 0, 0, 1) 90%, rgba(0, 0, 0, calc(0.75 * (1 / (1 - var(--scroll))))) 95%, rgba(0, 0, 0, var(--scroll)) 100%);
  overflow: scroll;
}

#home-button {
  width: 100%;
}

#home-classes-div {
  line-height: 17px;
  padding: 6px;
}

#home-classes-div, #home-curriculum-div {
  background-color: rgba(250, 225, 225, 0.05);
  border: 2px solid rgba(115, 104, 104);
  border-radius: 0px 4px 4px 4px;
  box-sizing: border-box;
  font-size: 14px;
  text-align: center;
  width: 100%;
}

#home-classes-tabs, #home-curriculum-tabs, #schedule-tabs {
  display: flex;
  margin-top: 3px;
  width: 100%;
}

#home-classes-tabs button, #home-curriculum-tabs button, #schedule-tabs button {
  background-color: transparent;
  border-radius: 4px 3px 0 0;
  color: rgb(10, 9, 9, 0.3);
  font-size: 14px;
  height: 30.6px;
  margin-left: 0;
  width: 100%;
}

#home-classes-tabs button.selected, #home-curriculum-tabs button.selected, #schedule-tabs button.selected {
  background-color: rgb(10, 9, 9, 0.2);
	color: rgb(250, 225, 250);
}

#home-classes-tabs button:not(.selected):hover, #home-curriculum-tabs button:not(.selected):hover, #schedule-tabs button:not(.selected):hover {
  background: rgba(135, 122, 122, 0.25);
}

#home-footer, #schedule-footer {
  padding: 6px;
  width: 320px;
}

#home-footer button, #schedule-footer button {
  width: calc(50% - 3px);
}

#home-footer button:last-child, #schedule-footer button:last-child {
  margin-left: 6px;
}

#home-video {
  height: 180px;
}

html, body {
  height: 100%;
  overflow: hidden;
  width: 100%;
}

html.teacher .app-div *, html.teacher .toolbar * {
  animation: none !important;
}

#page {
  bottom: 0px;
  bottom: env(safe-area-inset-bottom);
  display: flex;
  flex-direction: column;
  height: calc(100% - 3px);
  height: calc(100% - env(safe-area-inset-top) - env(safe-area-inset-bottom));
  position: fixed;
}

#page * {
  touch-action: pan-y;
}

#privacy-policy {
  height: 600px;
  overflow: scroll;
  position: fixed;
  width: 600px;
  z-index: 1;
}

@keyframes raindrop {
  0% {
    transform: translateY(-50px);
  }
  100% {
    transform: translateY(calc(100vh + 50px));
  }
}

.raindrop {
  animation: raindrop linear infinite;
  color: #ffc44d;
  font-family: Archivo, sans-serif;
  font-size: 36px;
  font-stretch: 75%;
  font-weight: bold;
  opacity: 0;
  position: fixed;
  text-shadow: 0.125vmin 0.125vmin rgba(10, 9, 9, 0.5);
  top: -50px;
  transition: opacity 500ms ease-in-out;
}

.song-entry.active {
  background-color: var(--student-color-darker) !important;
}

.song-entry.active .song-button {
  background-color: var(--student-color-value);
  filter: drop-shadow(0 0 25px var(--student-color-value));
}

.song-entry-left svg {
  height: 22px;
  width: 22px;
}

.song-entry-name-span {
  width: 100%;
}

.song-entry-right-bottom {
  font-size: 12px;
  line-height: 14px;
  margin-top: 2px;
}

.song-locked-overlay {
  align-items: center;
  backdrop-filter: blur(2px);
  background: rgba(50, 45, 45, 0.75);
  border-radius: 4px;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.song-locked-content {
  align-items: center;
  color: rgb(250, 225, 225);
  display: flex;
  font-size: 11px;
  font-weight: 600;
  gap: 2px;
  text-shadow: 0.125vmin 0.125vmin rgba(10, 9, 9, 0.5);
}

.song-locked-fairy-canvas {
  height: 22px;
  image-rendering: pixelated;
  width: 32px;
}

#sound-settings {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 280px;
}

/* Rows as in the dashboard's student settings (dash.css .settings-row): a fixed label
   column and the control filling the rest. */
.sound-setting-row {
  align-items: center;
  display: flex;
  flex-basis: 100%;
  gap: 8px;
  height: 38px;
}

.sound-setting-label {
  flex: 0 0 100px;
  font-size: 14px;
  text-align: left;
}

/* The volume control is shaped like the settings text boxes (32px, 4px radius), filled
   to the volume in the darker warm grey over the lighter one, percentage centred on top. */
.sound-setting-bar {
  flex: 1 1 0;
  height: 32px;
  min-width: 0;
  position: relative;
}

.sound-setting-value {
  align-items: center;
  color: rgb(250, 225, 225);
  display: flex;
  font-size: 14px;
  inset: 0;
  justify-content: center;
  pointer-events: none;
  position: absolute;
}

/* Beats \`.ui input\` (index.css), which would make the slider a 42px text field. */
#sound-settings input.sound-setting-slider {
  -webkit-appearance: none;
  appearance: none;
  background: linear-gradient(to right, rgb(114, 103, 103) var(--fill, 0%), rgb(160, 144, 144) var(--fill, 0%));
  border: 1px solid rgb(114, 103, 103);
  border-radius: 4px;
  cursor: pointer;
  display: block;
  height: 100%;
  margin: 0;
  padding: 0;
  width: 100%;
}

/* No knob: the edge of the fill is the position. */
#sound-settings input.sound-setting-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  height: 30px;
  width: 1px;
}

#sound-settings input.sound-setting-slider::-moz-range-thumb {
  background: transparent;
  border: none;
  height: 30px;
  width: 1px;
}

.star {
  position: fixed;
}

.star.twinkling, .power-background-star.twinkling {
  animation: star-pulse 6000ms infinite;
  transition: opacity 500ms ease-in-out;
}

@keyframes star-pulse {
  0% {
    filter: brightness(1);
  }

  50% {
    filter: brightness(1.25) drop-shadow(0 0 var(--glow-size, 50px) rgba(255, 225, 225, 0.75));
  }

  100% {
    filter: brightness(1);
  }
}

.star-pulse {
  animation: star-pulse 625ms 1;
}

.points-pulsing {
  animation: star-pulse 625ms infinite;
}

table {
  border-collapse: collapse;
}

.back-button {
  flex-basis: calc(50% - 3px);
  margin: 6px 6px 0px 0px;
}

#holidays-link {
  color: rgb(25, 22, 22);
  cursor: pointer;
  text-decoration: underline rgb(10, 9, 9) dashed;
}

.log-in-button {
  flex-basis: 100%;
}

#name-input:focus::placeholder {
  opacity: 0;
}

#name-input.error {
  background-color: rgb(40, 36, 36);
  margin: 0px;
}

#parent-form .log-in-button {
  flex-basis: calc(50% - 3px);
}

#parent-register-form .email-input {
  margin-top: 6px;
}

#parent-register-form .password-input {
  margin-bottom: 0px;
}

.register-button {
  flex-basis: calc(50% - 3px);
  margin-top: 6px;
}

.register-form-button {
  flex-basis: calc(50% - 3px);
  margin: 0px 0px 0px 6px;
}

#schedule-form-button {
  flex-basis: 100%;
  margin-top: 6px;
}

.student-color-value {
  fill: var(--student-color-value) !important;
}

.student-color-mid {
  fill: var(--student-color-mid) !important;
}

.student-color-dark {
  fill: var(--student-color-dark) !important;
}

#student-form, #parent-form, #parent-register-form, #schedule-body, #subscriptions-form, #teacher-form, #teacher-register-form {
  margin-top: 54.29px;
}

#schedule-body button, #subscriptions-form button {
  font-size: 14px;
  font-stretch: 100%;
  height: 36px;
  width: 132px;
}

#schedule-body .grade-header {
  background-color: rgba(250, 225, 225, 0.25);
  border-radius: 4px;
  font-size: 14px;
  font-weight: 650;
  height: 28px;
  padding: 2px;
  width: 100%;
}

#schedule-body td {
  font-size: 14px;
  font-weight: 600;
  padding: 2px;
  text-align: center;
}

#schedule-info-div, #schedule-info-div-2 {
  font-size: 12px;
  margin: -6px 0px 9px 0px;
  text-align: center;
  width: 100%;
}

#seats-div {
  align-items: center;
  background-color: rgba(250, 225, 225, 0.25);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  font-size: 13px;
  font-stretch: 90%;
  height: 36px;
  justify-content: center;
  width: 28px;
}

#seats-div svg {
  height: 8.5px;
  margin-bottom: 1.5px;
  width: 8.5px;
}

#sections-div {
  background: rgba(250, 225, 225, 0.05);
  border: 2px solid rgba(115, 104, 104);
  padding: 2px;
}

.stop-button {
  background-color: #a62121 !important;
  font-size: 12px !important;
  font-stretch: 80% !important;
  height: 25px !important;
  width: 40px !important;
}

#student-form .name-input {
  margin-bottom: 6px;
}

/* Locked on the emoji step (setEmojiStep): the light informational box, dark text, no browser grey. */
#student-form .name-input:disabled:not(.error) {
  background-color: rgba(250, 225, 225, 0.25);
  color: rgb(10, 9, 9);
  -webkit-text-fill-color: rgb(10, 9, 9);
}

#student-form .name-note {
  background: rgb(50, 45, 45);
  border-radius: 4px;
  color: rgb(250, 225, 225);
  flex-basis: 100%;
  font-size: 13px;
  margin-bottom: 6px;
  padding: 6px 10px;
  text-align: center;
}

#subscriptions-div {
  border: 3px solid rgba(10, 9, 9, 0.2);
  border-radius: 3px;
  font-size: 14px;
  width: 100%;
}

#subscriptions-form {
  width: 320px;
}

#subscriptions-table {
  width: 100%;
}

#subscriptions-table td, #subscriptions-table td:first-child {
  background-color: rgb(160, 144, 144);
  height: 20px;
  padding: 3px 6px;
  text-align: center;
}

#subscriptions-table td:last-child, #subscriptions-table th:last-child {
  padding-bottom: 3px;
  padding-right: 3px;
  width: 0px;
}

#subscriptions-table th {
  background-color: rgb(160, 144, 144);
  border-bottom: 2px solid rgba(10, 9, 9 0.2);
  padding: 6px;
  text-align: center;
}

#subscriptions-table tr:not(:first-child) {
  border-bottom: 1px solid rgb(135, 122, 122);
}

#subscriptions-table tr:last-child {
  border-bottom: none;
}

#time-div {
  align-items: center;
  background-color: rgba(250, 225, 225, 0.25);
  border-radius: 4px;
  display: flex;
  font-size: 13px;
  font-stretch: 90%;
  height: 36px;
  justify-content: center;
  width: 128px;
}

#topic-div {
  background-color: rgba(250, 225, 225, 0.25);
  border-radius: 4px;
  font-size: 13px;
  font-weight: 650;
  padding: 6px;
}

#topics-table {
  width: 100%;
}

#topics-table td, #topics-table td:first-child {
  background-color: rgba(135, 122, 122, 0.25);
  font-size: 14px;
  height: 20px;
  padding: 3px 0px;
  text-align: center;
}

#topics-table tr:not(:last-child) {
  border-bottom: 1px solid rgb(10, 9, 9, 0.2);
}

.void-pulsing {
  animation: void-pulse 625ms infinite;
}

@keyframes void-pulse {
  0% {
    filter: brightness(1);
  }

  50% {
    filter: brightness(0.75) drop-shadow(0 0 50px rgba(10, 9, 10, 0.5));
  }

  100% {
    filter: brightness(1);
  }
}

::-webkit-scrollbar {
  display: none;
}
/* #endregion */
/* #region script.js */
/* Center the inner dialog box. Scoped to .dialog.ui specifically — the
   .overlay backdrop also carries class="overlay dialog" (used by event-target
   selectors), and we must NOT translate it: it is pinned to the screen's
   four edges already, so a translate(-50%, -50%) would shift its
   bottom-right to ≈ viewport center and leave the top-left off-screen. */
.dialog.ui {
  left: 50%;
  position: fixed;
  top: 50%;
  /* A dashboard tile shows a student's screen at its own size, so the dialog is scaled by the tile's
     --session-scale like every panel (dash.js resizeSession); everywhere else the variable is unset. */
  transform: translate(-50%, -50%) scale(var(--session-scale-x, 1), var(--session-scale-y, 1));
}

.dialog button {
  flex-basis: 100%;
}

.dialog.option button {
  flex-basis: calc(50% - 3px);
}

.dialog.option .dialog-yes-button {
  margin-right: 6px;
}

/* Two options that are choices rather than yes and no (the rabbit's "as soon as you can" and
   "tomorrow") stand in rows, the same 6px apart the side by side pair is. */
.dialog.option.stack button {
  flex-basis: 100%;
}

.dialog.option.stack .dialog-yes-button {
  margin-bottom: 6px;
  margin-right: 0;
}

/* The video generation dialog's two instruction boxes (script, annotation). Scoped under .ui to
   outrank \`.ui input, .ui select, .ui textarea\` (0,1,1), which fixes every control at 42px. The
   placeholder IS the label — there is no text outside the box — so it stays legible against the
   beige field and does not vanish on focus the way #name-input's does. */
.ui .video-prompt-input {
  font-size: 15px;
  height: 72px;
  padding: 8px 6px;
  resize: none;
}

.ui .video-prompt-input + .video-prompt-input {
  margin-top: 6px;
}

.ui .video-prompt-input::placeholder {
  color: rgb(140, 126, 126);
  opacity: 1;
}

.dialog button svg {
  height: 10px;
  margin-right: 1px;
  width: 10px;
}

.dialog-check {
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-basis: 100%;
  gap: 6px;
  justify-content: center;
  margin-top: 6px;
  user-select: none;
}

/* Scoped under .ui to outrank \`.ui input, .ui select, .ui textarea\` (0,1,1),
   which styles every dialog control as a full-width 42px text field. */
.ui .dialog-checkbox {
  accent-color: rgb(140, 126, 126);
  background-color: transparent;
  border: none;
  border-radius: 0;
  cursor: pointer;
  flex: 0 0 auto;
  height: 14px;
  margin: 0;
  padding: 0;
  width: 14px;
}

.dialog-check-text {
  font-size: 13px;
}

.dialog-progress-bar {
  background: linear-gradient(to right, #73e6d2 -15%, #ff80bf 50%, #ffe666 115%);
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  height: 6px;
  left: 0px;
  max-width: 100%;
  position: absolute;
  top: 0px;
}

.dialog-progress-div {
  background-color: rgba(100, 90, 100, 0.5);
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  margin-top: 6px;
  position: relative;
  height: 6px;
  width: 268px;
}

.dialog-text {
  flex-basis: 100%;
  font-size: 14px;
  margin-bottom: 6px;
  overflow-y: scroll;
  text-align: center;
  transform: translateY(-4px);
}

/* A dialog with no button below the text - the locked-account block, "Nothing noteworthy",
   any message-only dialog - was noticeably bottom-heavy. .dialog-text's 6px bottom margin
   exists to separate it from a button, so with no button it is dead space stacked on the
   dialog's own 6px bottom padding.
   Measured on the locked dialog: 12.3px above the title glyphs, 16px below the body glyphs.
   The excess is only 3.7px rather than the full 6, because .dialog-text's transform pulls
   the glyphs up 4px and that lift is already part of the gap below them - so zeroing the
   margin would overshoot to 10px and make the TOP read heavy instead. 2px lands it at 12px.
   :last-child is the test for "nothing follows the text", which covers buttons, checkboxes
   and inputs alike without enumerating them. */
.dialog .dialog-text:last-child {
  margin-bottom: 2px;
}

.dialog-text span svg {
  height: 10px;
  margin-right: 1px;
  width: auto;
}

.drag-bottom {
  bottom: 0px;
  height: 6px;
  left: -0.5%;
  position: absolute;
  width: 101%;
  z-index: 3;
}

.drag-top {
  align-items: center;
  background-position-x: center;
  background-repeat: no-repeat;
  border-radius: 8px 8px 0px 0px;
  display: inline-flex;
  height: 8px;
  justify-content: center;
  left: -0.5%;
  position: absolute;
  top: 0px;
  width: 101%;
}

.drag-top svg {
  height: 6px;
  width: 6px;
}

.focused {
  align-self: stretch !important;
  aspect-ratio: auto !important;
  grid-column-end: span 3;
  grid-row-end: span 3;
  max-height: none !important;
  max-width: 100% !important;
  overflow: hidden;
}


.green-pulse {
  animation: green-pulse 120s 1;
}

/* Structural only: these two exist so the Facts and grade sections can rebuild from
   independent listeners without one wiping the other's innerHTML. #chart-stats is a flex
   container, so a plain div child becomes a flex ITEM and the rows stop filling the panel -
   which pushed them in from both edges, away from the panel buttons above. display: contents
   removes the wrappers from layout entirely, leaving the rows direct flex children exactly as
   they were before the split, while CSS structural selectors (ul:last-child and friends) go
   on matching against the DOM tree unchanged. */
#chart-facts, #chart-notes, #chart-codes {
  display: contents;
}

/* ...but the shared \`#chart-stats ul:last-child li:last-child\` rule zeroes the bottom margin
   of the last row in EVERY ul, and with the sections split each wrapper now has its own last
   ul - so the Facts section lost the 6px that separates it from the grade header below.
   Restore it for any section that is not the final one in the panel. */
#chart-stats > *:not(:last-child) ul:last-child li:last-child {
  margin-bottom: 6px;
}

/* One extra pixel of headroom on the data rows. The shared \`#chart-stats li\` padding is 4px
   top, which reads a touch tight above the label - so the top gap goes to 5px, matching the
   5px on the left and right. Scoped to the chart's own rows so the shared rule (and the
   friends panel that leans on it) is untouched, and :not(.panel-header) keeps the section
   headers on their original spacing. */
#chart-facts li:not(.panel-header),
#chart-codes li:not(.panel-header) {
  padding-top: 5px;
}

/* The next tier's payout, dressed as a REWARD rather than a plain figure. Gold, gradient and
   saturate copied from the toolbar's reward span (.toolbar-score-update-span.reward) - the
   two-declaration form matters: the shorthand sets the gradient as background-IMAGE and clears
   the colour, then background-color paints the gold behind it, and saturate(2) is what gives
   that gold its actual hue. Points read as points everywhere in the app, so the number uses the
   score font rather than the row's condensed 75%: #toolbar-score computes to 95% stretch at
   12px, MEASURED not assumed (it sets no font-stretch of its own and inherits it). Height
   matches the friends panel's TELEPORT button, the other small chip that rides a row like this;
   the box-shadow is the panel's small-element value, the same one the progress bars carry. */
.task-reward {
  align-items: center;
  background: linear-gradient(to bottom, rgba(200, 180, 180, 0.4) -100%, rgba(50, 45, 45, 0.4) 125%);
  background-color: rgba(255, 172, 51, 0.25);
  border-radius: 4px;
  box-shadow: 0.05vmin 0.05vmin rgb(10, 9, 9);
  display: flex;
  filter: saturate(2);
  font-size: 12px;
  font-stretch: 95%;
  font-weight: 550;
  height: 15.5px;
  letter-spacing: 0.025em;
  padding: 0 4px 0 2px;
  text-shadow: 0.05vmin 0.05vmin rgba(10, 9, 9, 0.5);
}

/* The MASTERY row's chip: the toolbar's correct-answer green (its span's background), not the
   reward gold — the tier bonus multiplies fact points, never rewards (user directive, Sep 2026). */
.task-reward.task-bonus {
  background-color: rgb(34, 77, 41);
}

/* The plus sign's ink centre sits 0.75px below the digits' (measured with canvas
   actualBoundingBox at the chip's own font: + is 7px tall on the baseline, the digits 9 over 1),
   so it is lifted by that much to read as centred on the number. */
.task-bonus .task-bonus-plus {
  /* …plus the height of the chip's text shadow (0.05vmin, the same measure the shadow uses),
     which reads as weight under the glyph and made the measured centre still look low. */
  transform: translateY(calc(-0.75px - 0.05vmin));
}

/* The Notes rows' chip: what mastering the tier heals the note's fairy by, behind a white cross. Its
   background is that fairy's health bar gradient, set inline per row (panel.js NOTE_SHADE); it was the
   song-completion rainbow until the user asked for each fairy's own colour (Oct 2026). */
.task-reward.task-heal {
  filter: none;
  /* The row's tier caption is an absolutely placed span across the whole row (panel.js taskRow), so it
     paints over any chip that is not itself lifted. The other chips are lifted by their saturate()
     filter (a filter paints in the positioned layer); without one, this chip sat under the caption
     and its tooltip never showed. */
  position: relative;
}

.task-reward svg {
  height: 10px;
  padding: 1px;
  width: auto;
}

/* The completion flash inside a Facts row, matching the fact box's own "Correct!" exactly
   (#fact-question plus its icon rule) so the two celebrations read as the same event: Archivo
   16px/650 at 100% stretch, the hard 1px shadow, and a 16px icon with 4.5px of gap. No amount
   here on purpose - the points land in the toolbar span like any other award, and repeating
   them in the row would say the same thing twice. */
.task-flash {
  align-items: center;
  color: rgb(250, 225, 225);
  display: flex;
  font-family: Archivo, sans-serif;
  font-size: 16px;
  font-stretch: 100%;
  font-weight: 650;
  height: 100%;
  justify-content: center;
  letter-spacing: normal;
  text-shadow: 1px 1px rgb(10, 9, 9);
  white-space: nowrap;
  width: 100%;
}

/* \`#chart-stats li span:first-child svg\` sizes row icons at 11x12 and outranks a bare
   \`.task-flash svg\`, so this matches its specificity - id + one class + three elements - and
   wins on order instead. Without it the check mark came out 11x12 beside 16px text. */
#chart-stats li span.task-flash svg {
  height: 16px;
  margin-right: 4.5px;
  width: 16px;
}

/* .correct too: a solved graph repainted quietly (updateInputTheme's \`quiet\`) gets no pulse.
   Only the rings of the points NOT chosen go: \`svg.correct\` outranks svg.css's \`.point-color.selected\`,
   so without :not(.selected) the student's own placed points vanished once the line was right. */
.green-pulse .point-color:not(.selected), svg.correct .point-color:not(.selected) {
  opacity: 0;
}

.green-pulse .line-select, .green-pulse .point-select {
  animation: gray-pulse 120s 1;
}

@keyframes gray-pulse {
  0%, 1%, 100% {
    filter: grayscale(0);
  }
  0.25% {
    filter: grayscale(1);
  }
}

@keyframes green-pulse {
  0%, 1%, 100% {
    background-color: transparent;
    filter: drop-shadow(0 0 0 transparent);
  }
  0.25% {
    background-color: rgb(34, 77, 41);
    filter: drop-shadow(0 0 15vmin rgba(16, 38, 20, 0.5));
  }
}

.header {
  align-items: center;
  box-sizing: border-box;
  display: inline-flex;
  height: 44px;
  padding: 0;
  position: relative;
  width: 100%;
  z-index: 1;
}

.header button svg {
  height: 18px;
  width: 18px;
}

.header-center {
  align-items: center;
  display: flex;
  flex: 0 1 100%;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  pointer-events: none;
}

.header-center button, .header-left button, .header-right button {
  outline: none;
  pointer-events: auto;
}

.header-left, .header-right {
  align-items: center;
  display: flex;
  flex: 0 0 25%;
  height: 100%;
  pointer-events: none;
}

.ui .header .header-left, .ui .header .header-right {
  flex: 0 0 30.6px;
}

.ui .header-left button, .ui .header-right button {
  height: 32px;
  width: 32px;
}

.header-title {
  pointer-events: none;
  text-align: center;
  text-shadow: none;
  width: 100%;
}

.nametag {
  align-items: center;
  background-clip: content-box;
  background-size: cover;
  border-radius: 4px;
  box-sizing: border-box;
  color: rgb(250, 225, 225);
  cursor: pointer;
  display: flex;
  font-family: Archivo, sans-serif;
  font-size: 15px;
  font-stretch: 100%;
  font-weight: 550;
  height: 30px;
  letter-spacing: 0.025em;
  padding: 5px 7px 6px 7px;
  text-shadow: 1px 1px rgba(10, 9, 9, 0.5);
  white-space: nowrap;
}

.nametag.small {
  font-size: 13px;
  transform: scale(0.85);
}

.nametag svg {
  height: 18px;
  margin-left: 4px;
  width: 18px;
}

.nametag.small svg {
  margin: 0 5px 0 0;
}

.overlay {
  background: linear-gradient(rgba(10, 9, 9, 0.75) -50%, rgba(50, 45, 45, 0.5) 100%);
  /* Exactly the screen: a fixed box pinned to all four edges follows the screen as a phone's address bar
     comes and goes, so anything centred by the overlay sits in the screen's true middle */
  inset: 0;
  pointer-events: none;
  position: fixed;
  /* Above every in-app layer (toolbars, panels, menus all sit at 1-6).
     Keep dialogs covering the entire viewport, including the top toolbar. */
  z-index: 1000;
}

.overlay.dialog {
  pointer-events: auto;
}

.overlay.paused {
  background: none;
}

html.dash .overlay {
  pointer-events: auto;
}

.overlay * {
  pointer-events: auto;
}

.popup,
#popup-warning {
  align-items: center;
  backdrop-filter: blur(12.5px);
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.1) -100%, rgba(20, 18, 18, 0.5) 200%);
  border-radius: 10vmin;
  box-shadow: 0.05vmin 0.05vmin rgba(10, 9, 9, 0.5);
  color: rgb(250, 225, 225);
  display: none;
  font-family: Archivo, sans-serif;
  font-size: 1.5vmin;
  font-stretch: 102.5%;
  font-weight: 550;
  height: 1.5vmin;
  justify-content: center;
  letter-spacing: 0.065em;
  padding: 1vmin 1.375vmin;
  position: absolute;
  left: 50%;
  text-shadow: 0.125vmin 0.125vmin rgba(10, 9, 9, 0.5);
  transform: translateX(-50%);
  transition: opacity 1000ms ease-in-out;
  white-space: nowrap;
}

.popup svg .color {
  fill: rgb(250, 225, 225) !important;
}

#popup {
  top: calc(100% + 2.5vmin);
}

.answer-div #popup {
  top: calc(100% + 2vmin);
}

.math-div #popup {
  top: calc(100% + 0.75vmin);
}

/* A question whose box rows end in a spacer line (.br, 4.75vmin) with another question right after
   it: the popup goes in the middle of the gap between the last boxes and the next question's text,
   not under the spacer, where it sat on that text (mat710's inequalities; measured live). */
.text-div:has(+ .text-div) > .br + #popup {
  top: calc(100% - 2.875vmin);
}

#popup svg {
  height: 1.75vmin;
  margin: 0 0.75vmin 0 -0.35vmin;
  padding: 0.2vmin 0 0.3vmin 0;
  vertical-align: middle;
  width: 1.75vmin;
}

.popup-timer-bar {
  animation: induction var(--timer) linear infinite alternate;
  background: linear-gradient(to right, #73e6d2 -15%, #ff80bf 50%, #ffe666 115%);
  border-radius: 10vmin;
  height: 100%;
  left: 0;
  mask-image: linear-gradient(to right, black, black);
  mask-position: left;
  mask-repeat: no-repeat;
  mask-size: 0% 100%;
  opacity: 0.5;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;
}

@keyframes induction {
  from {
    mask-size: 0% 100%;
  }
  to {
    mask-size: 102.5% 100%;
  }
}

.preview {
  display: none;
  font-family: Archivo, sans-serif;
  width: 400px;
}

/* The sparkle and Copy belong to the CARD, so the card is what they measure from. Without this
   the nearest positioned ancestor is .preview-container, and every button offset below was
   really a measurement from the bottom of the whole stack - so adding the descriptor box
   between the card and the page count pushed both buttons 36px down, out of the card's corner
   and onto the descriptor. Scoped with :has so the canvas preview's own buttons, which are
   still tuned to the container, are left alone. */
.preview:has(.memo) {
  position: relative;
}

.preview .copy-button {
  bottom: 213px;
  position: absolute;
  right: 92px;
}

/* See-through: the button sits over the card's bottom corner, and on a card that scrolls there
   is text passing underneath it. */
.preview .copy-text-button {
  background-color: rgba(135, 122, 122, 0.6);
  border: none;
  border-radius: 4px;
  bottom: 7px;
  box-sizing: border-box;
  box-shadow: none;
  color: rgb(250, 225, 225);
  cursor: pointer;
  font-family: Archivo, sans-serif;
  font-size: 14px;
  font-stretch: 95%;
  font-weight: 600;
  height: 24px;
  justify-content: center;
  letter-spacing: 0.025em;
  padding: 3px 6.5px;
  position: absolute;
  right: 8px;
  z-index: 1;
}

/* Copy confirmation: the same pulse the sparkle uses while generating. A label swap to
   "Copied!" was wider than the button, so it spread leftwards across the sparkle; the
   animation says the same thing without moving anything. ONE beat: the sparkle's infinite
   loop reads as ongoing work, a single blink reads as done. */
.preview .copy-text-button.copied {
  animation: memo-generating 0.5s ease-in-out;
}

/* Sparkles, sitting immediately left of Copy. Same geometry so the pair reads as one control
   group; \`right\` clears Copy's width plus the gap. */
.preview .preview-ai-button {
  align-items: center;
  background-color: rgba(135, 122, 122);
  border: none;
  border-radius: 4px;
  bottom: 7px;
  box-shadow: none;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  height: 24px;
  justify-content: center;
  padding: 3px 6px;
  position: absolute;
  /* Copy's own right offset (8px) + its rendered width (47px) + the 4px gap Copy itself keeps
     from the memo's inner border edge. Measured rather than guessed: the memo card carries a
     4px border, so Copy's \`right: 8px\` reads as 4px of visible space, and an 8px gap here
     looked wider than the one beside it. */
  right: calc(8px + 47px + 4px);
  width: 28px;
  z-index: 1;
}

/* The icon ships with its own fill and a drop shadow. Paint it white and drop the shadow, per
   the button's flat treatment. */
.preview .preview-ai-button svg {
  filter: none;
  height: 15px;
  width: 15px;
}

.preview .preview-ai-button svg * {
  fill: rgb(250, 225, 225);
  filter: none;
}

/* Nothing noteworthy: the same greyed-out reading as :disabled, but hoverable. The global
   \`button:disabled\` rule kills pointer events, and Chrome gives a disabled control no hover
   at all, so the button's title — the teacher's read-out of the figures behind the empty
   result — could never be seen. The click is guarded in script.js instead. */
.preview .preview-ai-button.empty {
  cursor: default;
  opacity: 0.25;
}

/* Generating: the sparkle pulses in place rather than swapping in an orbit, which would
   resize the button and shift Copy beside it. */
.preview .preview-ai-button.generating {
  pointer-events: none;
}

.preview .preview-ai-button.generating svg {
  animation: memo-generating 1s ease-in-out infinite;
}

@keyframes memo-generating {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.35; }
}

.preview .download-button {
  bottom: 213px;
  position: absolute;
  right: 12px;
}

.preview canvas {
  height: 300px;
  width: 400px;
}

.preview div {
  background-color: rgb(168, 150, 150);
  border: 4px solid rgb(135, 122, 122);
  border-radius: 4px;
  font-size: 14.5px;
  font-weight: 600;
  line-height: 18px;
  padding: 5px 7px;
  width: 100%;
}

/* A memo is a run of text and <br>s, not a flex layout. \`.ui\` makes it a flex container, which
   blockifies every child — so the editable name span became a flex ITEM on its own line
   instead of sitting in the sentence (computed display: inline -> block). Normal block flow
   restores an inline formatting context for the text, which is all a memo ever needed. */
.preview .memo {
  display: block;
}

/* A long memo (a bonus code's, one line per problem) scrolls inside its card instead of running
   off both ends of the screen, with the same top and bottom fade as the other scrolling lists.
   The container is centred 50px below the middle of the window and also holds the caption and
   the page count, which is what the 220px leaves room for. --scroll is set by dash.js only
   while the list overflows, so without it the mask is invalid and nothing is faded. */
.preview .memo-scroll {
  display: block;
  mask-image: linear-gradient(rgba(0, 0, 0, calc(1 - var(--scroll))) 0%, rgba(0, 0, 0, calc(0.75 * (1 / var(--scroll)))) 5%, rgba(0, 0, 0, 1) 10%, rgba(0, 0, 0, 1) 90%, rgba(0, 0, 0, calc(0.75 * (1 / (1 - var(--scroll))))) 95%, rgba(0, 0, 0, var(--scroll)) 100%);
  max-height: calc(100vh - 220px);
  overflow-y: auto;
}

/* The memo's editable name. Deliberately weightless: inline so it shrink-wraps its text,
   inheriting every font property, with no padding, border or background to shift the
   sentence around it. The only always-on affordance is a faint dotted underline, which
   occupies no layout space; the field fills in on hover/focus so it reads as editable
   without turning the memo into a form. min-width keeps an emptied name clickable. */
.memo-name {
  border-bottom: 1px dotted rgba(10, 9, 9, 0.35);
  cursor: text;
  display: inline;
  min-width: 12px;
  outline: none;
}

.memo-name:hover,
.memo-name:focus {
  background-color: rgba(250, 225, 225, 0.35);
  border-bottom-color: rgba(10, 9, 9, 0.7);
  border-radius: 2px;
}

.preview-container {
  align-items: center;
  display: flex;
  flex-direction: column;
  left: 50vw;
  position: relative;
  top: calc(50vh + 50px);
  transform: translate(-50%, -50%);
  width: 400px;
}

.preview-count {
  background-color: rgba(135, 122, 122, 0.8);
  margin-top: 8px;
  padding: 6px 12px;
  width: auto;
}

/* What the card measures, in the page count's own box, sitting between the card and the count.
   It has to live outside the card: everything inside one is lifted by Copy and sent home, and
   this is a label for whoever is flipping through the pages. Same rule as the count so the two
   read as one stack - a step down in size, since it is a caption and the count is the control,
   and centred because it wraps to two lines on the longer descriptors where the count never
   wraps at all. */
.preview-header {
  background-color: rgba(135, 122, 122, 0.8);
  font-size: 14px;
  margin-top: 8px;
  padding: 6px 12px;
  text-align: center;
  width: auto;
}

.preview-navigation {
  display: flex;
  left: 50%;
  position: fixed;
  top: 50%;
  transform: translate(-50%, 104px);
}

.preview-next {
  left: calc(50% + 210px);
}

.preview-next, .preview-previous {
  background-color: rgba(135, 122, 122, 0.8);
  border: none;
  border-radius: 100px;
  cursor: pointer;
  box-shadow: 0.15vmin 0.15vmin rgba(10, 9, 9, 0.5);
  font-family: 'Archivo';
  font-size: 28px;
  font-weight: bold;
  height: 45px;
  padding: 8px 13px;
  position: absolute;
  top: 50%;
  transform: translateY(-315%);
  width: 45px;
}

.preview-previous {
  left: calc(50% - 255px);
}

.red-pulse {
  animation: red-pulse 120s 1;
}

@keyframes red-pulse {
  0%, 1%, 100% {
    background-color: transparent;
    filter: drop-shadow(0 0 0 transparent);
  }
  0.25% {
    background-color: rgb(77, 19, 19);
    filter: drop-shadow(0 0 15vmin rgba(38, 9, 9, 0.5));
  }
}

/* The fairy low-health popup at "very low": three quick flashes over its 3s display, in the
   wrong-answer red-pulse colours at a cadence that fits a popup instead of a 120s answer lock. The
   warning is its own element (#popup-warning, styled like .popup but WITHOUT the class — getPopup finds the
   regular popup by that class and would otherwise reuse the warning as it). */
#popup-warning.red-pulse {
  animation: popup-red-pulse 1s 3;
}

@keyframes popup-red-pulse {
  0%, 100% {
    background-color: transparent;
    filter: drop-shadow(0 0 0 transparent);
  }
  50% {
    background-color: rgb(77, 19, 19);
    filter: drop-shadow(0 0 2vmin rgba(77, 19, 19, 0.6));
  }
}

#refresh-button {
  flex-basis: 100%;
}
/* #endregion */

/* #region cursor */
#cursor {
  background: rgb(250, 225, 225);
  border: 5px solid var(--student-color-value);
  border-radius: 100px;
  height: 5px;
  opacity: 0.75;
  position: fixed;
  transform: translate(-50%, -10%);
  width: 5px;
  z-index: 3;
}

html.dash #cursor {
  pointer-events: none;
}

html.dash:not(.focused-session) #cursor {
  display: none;
}

/* Class announcements that stay out of the way (script.js showAnnouncement): banners stacked under
   the toolbar, each closed with its x, the page usable underneath. A blocking one is a dialog. */
#announcements {
  display: flex;
  flex-direction: column;
  gap: 6px;
  /* the page's full width less the standard 6px each side: a message wraps only on a narrow screen.
     On a dashboard tile it is scaled by the tile's --session-scale like every panel, and made wider
     by the inverse first so it still spans the tile and wraps where the student's screen does. */
  left: 50%;
  pointer-events: none;
  position: fixed;
  top: 42px;
  transform: translateX(-50%) scale(var(--session-scale-x, 1), var(--session-scale-y, 1));
  transform-origin: top center;
  width: calc((100% - 12px) * var(--session-scale-x-inv, 1));
  z-index: 1000;
}

/* As wide as its text (.ui would fix it at 240px), the standard sizes otherwise: the .ui font, a
   6px inset all round (a .ui box with no header has no top inset of its own), and the close x
   every panel and dialog header uses, 32px with an 18px icon (.ui .header-right button). */
#announcements {
  align-items: center;
}

#announcements .announcement {
  flex-wrap: nowrap;
  gap: 6px;
  max-width: 100%;
  padding: 6px;
  pointer-events: auto;
  width: fit-content;
}

/* Bare text is padded as if it sat in a box of its own (6px inside, like any boxed text), on both sides,
   so it is 12px from the banner's left edge and 12px from the close button */
#announcements .announcement-text {
  padding: 0 6px;
}

#announcements .announcement-close {
  flex: none;
  height: 32px;
  width: 32px;
}

#announcements .announcement-close svg {
  height: 18px;
  width: 18px;
}
/* #endregion */`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,aAAa;AACf;AACA,eAAe;;AAEf,gBAAgB;AAChB;EACE,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,iDAAiD;EACjD,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;EACxB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA,eAAe;AACf,mBAAmB;AACnB;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;AACA,eAAe;AACf,kBAAkB;AAClB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,4DAAyE;AAC3E;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,+DAA0D;AAC5D;AACA,eAAe;AACf,uBAAuB;AACvB;EACE,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,yEAAyE;EACzE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,4DAA4D;EAC5D,4BAA4B;EAC5B,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,0EAA0E;EAC1E,YAAY;EACZ,SAAS;EACT,eAAe;EACf,+BAA+B;EAC/B,WAAW;AACb;;AAEA,4DAA4D;;AAE5D,eAAe;AACf,qBAAqB;AACrB;EACE,OAAO;EACP,UAAU;EACV,0BAA0B;EAC1B,qCAAqC;EACrC,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB;qGACmG;EACnG,oQAAoQ;EACpQ,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;6EAC6E;AAC7E;EACE,iBAAiB;AACnB;;AAEA;;;sDAGsD;AACtD;EACE,YAAY;AACd;;AAEA;;;;6EAI6E;AAC7E;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kGAAkG;EAClG,kBAAkB;EAClB,kDAAkD;EAClD,yBAAyB;EACzB,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,iDAAiD;EACjD,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,gEAAgE;EAChE,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;;;;+CAS+C;AAC/C;qCACqC;AACrC;;;;;CAKC;;AAED;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,0FAA0F;EAC1F,YAAY;EACZ,kBAAkB;EAClB,iDAAiD;EACjD,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;4FAC4F;AAC5F;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,sDAAsD;AACxD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,6BAA6B;IAC7B,sCAAsC;EACxC;EACA;IACE,0CAA0C;IAC1C,uDAAuD;EACzD;AACF;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,2BAA2B;EAC3B,qCAAqC;EACrC,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;AAClC;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oDAAoD;AACpD;;EAEE,0EAA0E;EAC1E,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,OAAO;EACP,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;AACb;;AAEA;gGACgG;AAChG;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,6EAA6E;EAC7E,8CAA8C;AAChD;AACA;EACE,6EAA6E;EAC7E,yBAAyB;AAC3B;AACA;EACE,6EAA6E;EAC7E,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,0FAA0F;EAC1F,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV;;+FAE6F;EAC7F,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA,wEAAwE;AACxE;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,qCAAqC;AACvC;;AAEA;;;+BAG+B;AAC/B,mBAAmB,oBAAoB,EAAE;;AAEzC;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;AACA;;;sEAGsE;AACtE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iDAAiD;EACjD,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;AACA;;4CAE4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;gBAGgB;AAChB;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;mFAGmF;AACnF;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;EAClC,qCAAqC;EACrC,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,6FAA6F;EAC7F,6BAA6B;EAC7B,kBAAkB;EAClB,iDAAiD;EACjD,sBAAsB;EACtB,wBAAwB;EACxB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;iDACiD;AACjD;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;EAC7C,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kGAAkG;EAClG,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kGAAkG;AACpG;;AAEA;qFACqF;AACrF;;EAEE,kBAAkB;AACpB;AACA;;oBAEoB;AACpB;;6EAE6E;AAC7E;;;EAGE,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,iBAAiB;AACnB;;AAEA;;;;mFAImF;AACnF;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;;iEAEiE;AACjE;;;;;;;EAOE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kGAAkG;EAClG,kBAAkB;EAClB,iDAAiD;EACjD,WAAW;AACb;;AAEA;+EAC+E;AAC/E;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;;;;8DAI8D;AAC9D;;;;;;EAME,gBAAgB;AAClB;AACA;;;4EAG4E;AAC5E;EACE,iDAAiD;EACjD,mBAAmB,EAAE,oDAAoD;EACzE,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA,qGAAqG;AACrG;EACE,uCAAuC;AACzC;;AAEA;2FAC2F;AAC3F;EACE,mFAAmF;EACnF,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,gDAAgD;EAChD,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA,eAAe;AACf,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yEAAyE;EACzE,oBAAoB;EACpB,uDAAuD;AACzD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;EAEE,wFAAwF;EACxF,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,2CAA2C;EAC3C,iBAAiB;EACjB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,sDAAsD;AACxD;;AAEA,6FAA6F;AAC7F;;EAEE,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yDAA+M;EAC/M,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,qDAAqD;EACvD;EACA;IACE,wDAAwD;EAC1D;AACF;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE;IACE,yGAAyG;EAC3G;EACA;IACE,yGAAyG;EAC3G;AACF;;AAEA,oEAAoE;AACpE;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yDAA+M;EAC/M,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;AACA,eAAe;AACf,qBAAqB;AACrB;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6FAA6F;EAC7F,sCAAsC;EACtC,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,QAAQ;EACR,6GAA6G;EAC7G,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;kDAEkD;AAClD;EACE,cAAc,EAAE,mFAAmF;EACnG,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;;gBAIgB;AAChB;EACE,YAAY;EACZ,kFAAkF;EAClF,0EAA0E;AAC5E;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,wDAAwD;EACxD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,0FAA0F;EAC1F,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kGAAkG;EAClG,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,kDAAkD;AACpD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;;2DAE2D;;AAE3D;;;;0EAI0E;AAC1E;;;;;;EAME,aAAa;AACf;;AAEA,gFAAgF;AAChF;EACE,eAAe;AACjB;;AAEA;;;0DAG0D;AAC1D;;;EAGE,aAAa;AACf;AACA;EACE,eAAe;EACf,oBAAoB;AACtB;AACA;;EAEE,aAAa;AACf;AACA;2EAC2E;AAC3E;;EAEE,aAAa;AACf;AACA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ;mEACiE;EACjE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oFAAoF;EACpF,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,+CAA+C;EAC/C,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,wCAAwC,EAAE,wCAAwC;AACpF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kGAAkG;EAClG,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;AACA,eAAe;AACf,qBAAqB;AACrB;EACE,WAAW;EACX,+CAA+C;EAC/C,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,qCAAqC;EACrC,6EAA6E;EAC7E,YAAY;EACZ;iFAC+E;EAC/E,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;wFACwF;AACxF;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;+DAC+D;AAC/D;EACE,UAAU;EACV,2BAA2B;EAC3B,2DAA2D;AAC7D;;AAEA;;;;iCAIiC;AACjC;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0FAA0F;EAC1F,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kGAAkG;AACpG;;AAEA;EACE,kGAAkG;AACpG;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;;;mDAImD;AACnD;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,8BAA8B;EAC9B,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,qCAAqC;EACrC,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,4FAA4F;EAC5F,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,YAAY;AACd;;AAEA;;;;;;;;;yBASyB;AACzB;EACE,wBAAwB;EACxB,aAAa;EACb,gDAAgD;EAChD,4HAA4H;EAC5H,kBAAkB;EAClB,0DAA0D;AAC5D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;;;+CAG+C;AAC/C;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA,uFAAuF;AACvF;EACE,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,qBAAqB;AACvB;AACA,eAAe;AACf,qBAAqB;AACrB;EACE,mBAAmB;EACnB,4DAA4D;EAC5D,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,8CAA8C;EAC9C,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE;;;;2CAIyC;EACzC,2FAA2F;EAC3F,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,YAAY;EACZ;;yEAEuE;EACvE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;;;wCAIwC;AACxC;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;;;;2DAI2D;AAC3D;;;;;sCAKsC;AACtC;EACE,kBAAkB;EAClB,gFAAgF;EAChF,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;;;;+CAK+C;AAC/C;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;AACA,eAAe;;AAEf;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,4DAA4D;EAC5D,yBAAyB;EACzB,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,oDAAoD;EACpD,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mCAAmC;EACnC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,qCAAqC;EACrC,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oQAAoQ;EACpQ,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,cAAc;EACd,WAAW;AACb;;AAEA;EACE,oCAAoC;CACrC,yBAAyB;AAC1B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,2EAA2E;EAC3E,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,eAAe;EACf,oDAAoD;EACpD,UAAU;EACV,qCAAqC;AACvC;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,4CAA4C;EAC5C,wDAAwD;AAC1D;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kCAAkC;EAClC,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,oDAAoD;AACtD;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,YAAY;AACd;;AAEA;6CAC6C;AAC7C;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;2FAC2F;AAC3F;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,kFAAkF;AAClF;EACE,wBAAwB;EACxB,gBAAgB;EAChB,6GAA6G;EAC7G,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA,mDAAmD;AACnD;EACE,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,0FAA0F;EAC5F;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,4BAA4B;EAC5B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sGAAsG;AACtG;EACE,2CAA2C;EAC3C,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,mEAAmE;EACrE;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,aAAa;AACf;AACA,eAAe;AACf,sBAAsB;AACtB;;;;yEAIyE;AACzE;EACE,SAAS;EACT,eAAe;EACf,QAAQ;EACR;uGACqG;EACrG,4FAA4F;AAC9F;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;4EAC4E;AAC5E;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;yEAGyE;AACzE;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,QAAQ;EACR,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;uEACuE;AACvE;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8EAA8E;EAC9E,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;;;;;;;;;+CAS+C;AAC/C;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;EAC5B,8BAA8B;EAC9B,oBAAoB;EACpB,WAAW;EACX,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;AAClB;;;AAGA;EACE,6BAA6B;AAC/B;;AAEA;;;;;;gDAMgD;AAChD;EACE,iBAAiB;AACnB;;AAEA;;;uEAGuE;AACvE;EACE,kBAAkB;AACpB;;AAEA;;;;uCAIuC;AACvC;;EAEE,gBAAgB;AAClB;;AAEA;;;;;;;;6FAQ6F;AAC7F;EACE,mBAAmB;EACnB,kGAAkG;EAClG,0CAA0C;EAC1C,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;mGACmG;AACnG;EACE,iCAAiC;AACnC;;AAEA;;mEAEmE;AACnE;EACE;yFACuF;EACvF,+CAA+C;AACjD;;AAEA;;yFAEyF;AACzF;EACE,YAAY;EACZ;;;oCAGkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;;;;oDAIoD;AACpD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,kCAAkC;EAClC,mBAAmB;EACnB,WAAW;AACb;;AAEA;;sFAEsF;AACtF;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;;iGAEiG;AACjG;EACE,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,sCAAsC;EACxC;EACA;IACE,iCAAiC;IACjC,qDAAqD;EACvD;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kFAAkF;EAClF;0FACwF;EACxF,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf;4EAC0E;EAC1E,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,6BAA6B;EAC7B,4FAA4F;EAC5F,qBAAqB;EACrB,iDAAiD;EACjD,yBAAyB;EACzB,aAAa;EACb,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,SAAS;EACT,oDAAoD;EACpD,2BAA2B;EAC3B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;4FAE4F;AAC5F;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,4BAA4B;EAC5B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,2DAA2D;EAC3D,8EAA8E;EAC9E,qBAAqB;EACrB,YAAY;EACZ,OAAO;EACP,mDAAmD;EACnD,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;AACb;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,YAAY;AACd;;AAEA;;;;;kDAKkD;AAClD;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;mCACmC;AACnC;EACE,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;;;8DAG8D;AAC9D;EACE,2CAA2C;AAC7C;;AAEA;qDACqD;AACrD;EACE,mBAAmB;EACnB,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB;;;2CAGyC;EACzC,6BAA6B;EAC7B,WAAW;EACX,UAAU;AACZ;;AAEA;iCACiC;AACjC;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA;;;6EAG6E;AAC7E;EACE,eAAe;EACf,aAAa;AACf;;AAEA;gDACgD;AAChD;EACE,oBAAoB;AACtB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,aAAa,EAAE;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;yFAGyF;AACzF;EACE,cAAc;AAChB;;AAEA;;;;sFAIsF;AACtF;EACE,cAAc;EACd,oQAAoQ;EACpQ,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;;;qFAIqF;AACrF;EACE,8CAA8C;EAC9C,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,2CAA2C;EAC3C,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;;;;;kBAKkB;AAClB;EACE,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,iDAAiD;EACjD,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,6BAA6B;IAC7B,sCAAsC;EACxC;EACA;IACE,iCAAiC;IACjC,mDAAmD;EACrD;AACF;;AAEA;;;8EAG8E;AAC9E;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,6BAA6B;IAC7B,sCAAsC;EACxC;EACA;IACE,iCAAiC;IACjC,oDAAoD;EACtD;AACF;;AAEA;EACE,gBAAgB;AAClB;AACA,eAAe;;AAEf,mBAAmB;AACnB;EACE,8BAA8B;EAC9B,4CAA4C;EAC5C,oBAAoB;EACpB,WAAW;EACX,aAAa;EACb,eAAe;EACf,gCAAgC;EAChC,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;iGACiG;AACjG;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR;;iGAE+F;EAC/F,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,SAAS;EACT,uFAAuF;EACvF,4BAA4B;EAC5B,0DAA0D;EAC1D,aAAa;AACf;;AAEA;;2FAE2F;AAC3F;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;6EAC6E;AAC7E;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;AACA,eAAe","sourcesContent":["/* #region tap highlight disable */\r\n* {\r\n  -webkit-tap-highlight-color: transparent;\r\n  -webkit-touch-callout: none;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\nhtml {\r\n  touch-action: pan-x pan-y;\r\n}\r\n\r\n*:focus {\r\n  outline: none;\r\n}\r\n\r\nbutton, a, input, select, textarea {\r\n  -webkit-tap-highlight-color: transparent;\r\n  outline: none;\r\n}\r\n/* #endregion */\r\n\r\n/* #region .ui */\r\n.ui {\r\n  align-items: center;\r\n  background-color: rgb(140, 126, 126);\r\n  border-radius: 4px;\r\n  box-shadow: 0.15vmin 0.15vmin rgba(10, 9, 9, 0.5);\r\n  box-sizing: border-box;\r\n  color: rgb(10, 9, 9);\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  font-family: Archivo, sans-serif;\r\n  font-size: 16px;\r\n  font-stretch: 100%;\r\n  font-weight: 650;\r\n  letter-spacing: 0.025em;\r\n  padding: 0px 6px 6px 6px;\r\n  width: 240px;\r\n  z-index: 1;\r\n}\r\n\r\n.ui button {\r\n  align-items: center;\r\n  background-color: rgba(10, 9, 9, 0.2);\r\n  border: none;\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n  box-shadow: none;\r\n  color: rgb(250, 225, 225);\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  font-family: Archivo, sans-serif;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  height: 42px;\r\n  justify-content: center;\r\n  letter-spacing: 0.025em;\r\n  padding: 6.5px;\r\n}\r\n\r\n.ui button:not(.dpad-button):not(.tab):hover {\r\n  background-color: rgba(10, 9, 9, 0.22);\r\n}\r\n\r\n.ui h1 {\r\n  align-items: center;\r\n  box-sizing: border-box;\r\n  display: inline-flex;\r\n  flex-basis: 100%;\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  height: 42px;\r\n  justify-content: center;\r\n  margin: 0px;\r\n  text-align: center;\r\n}\r\n\r\n.ui input, .ui select, .ui textarea {\r\n  background-color: rgb(250, 225, 225);\r\n  border: 1px solid rgb(140, 126, 126);\r\n  border-radius: 4px;\r\n  box-shadow: none;\r\n  box-sizing: border-box;\r\n  flex-basis: 100%;\r\n  font-family: Archivo, sans-serif;\r\n  font-size: 18px;\r\n  font-weight: 550;\r\n  height: 42px;\r\n  letter-spacing: 0.025em;\r\n  padding: 8px 0px;\r\n  text-align: center;\r\n}\r\n\r\n.ui li {\r\n  background-color: rgba(250, 225, 225, 0.25);\r\n  border-radius: 4px;\r\n  display: flex;\r\n  flex-basis: 100%;\r\n  flex-direction: column;\r\n  font-weight: 550;\r\n  justify-content: space-between;\r\n  letter-spacing: 0.025em;\r\n  margin: 0px 0px 6px 0px;\r\n  padding: 3px;\r\n}\r\n\r\n.ui li:last-child {\r\n  margin: 0px;\r\n}\r\n\r\n.ui li button {\r\n  font-size: 24px;\r\n  font-weight: bold;\r\n  height: 30.6px;\r\n  margin-left: 3px;\r\n  width: 30.6px;\r\n}\r\n\r\n.ui ol {\r\n  display: flex;\r\n  flex-basis: 100%;\r\n  flex-direction: column;\r\n  list-style-type: none;\r\n  margin: 0px;\r\n  overflow: auto;\r\n  padding: 0px;\r\n}\r\n\r\n.ui td {\r\n  flex-grow: 1;\r\n  padding: 3px;\r\n}\r\n\r\n.ui td:first-child {\r\n  padding-left: 0px;\r\n}\r\n\r\n.ui tr:first-child td {\r\n  padding-top: 0px;\r\n}\r\n\r\n.ui td:last-child {\r\n  padding-right: 0px;\r\n}\r\n\r\n.ui tr:last-child td {\r\n  padding-bottom: 0px;\r\n}\r\n\r\n.visible {\r\n  opacity: 0.75;\r\n  z-index: 2 !important;\r\n}\r\n/* #endregion */\r\n/* #region mobile */\r\nhtml.mobile #board-div, html.mobile  #chart-div, html.mobile .game-div #sheet-div {\r\n  right: 0 !important;\r\n  transform: none !important;\r\n  width: 100vmin !important;\r\n}\r\n\r\nhtml.mobile .canvas-div:not(.slide-div[data-type=\"review\"] .canvas-div) {\r\n  transform: scale(2) translateY(-25%) !important;\r\n}\r\n\r\nhtml.mobile #carat {\r\n  transform: scale(2) translate(2px, -3px) !important;\r\n}\r\n\r\nhtml.mobile #keyboard {\r\n  transform: none !important;\r\n  width: 100vmin !important;\r\n}\r\n\r\nhtml.mobile .slide-div #chart-div, html.mobile .game-div #chart-div {\r\n  display: none;\r\n}\r\n\r\nhtml.mobile #toolbar-print-button {\r\n  display: none !important;\r\n}\r\n\r\nhtml.mobile .game-div .popup {\r\n  font-size: 3vmin;\r\n  height: 3vmin;\r\n  padding: 2vmin 2.75vmin;\r\n}\r\n\r\nhtml.mobile .game-div #popup svg {\r\n  height: 3.5vmin;\r\n  margin: 0 1.5vmin 0 -0.7vmin;\r\n  width: 3.5vmin;\r\n}\r\n/* #endregion */\r\n/* #region fonts */\r\n@font-face {\r\n  font-family: 'Archivo';\r\n  font-style: normal;\r\n  font-stretch: 62% 125%;\r\n  font-weight: 100 900;\r\n  src: url('./fonts/Archivo-VariableFont_wdth\\,wght.woff2') format('woff2');\r\n}\r\n\r\n@font-face {\r\n  font-family: 'KaTeX_Z';\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  src: url('./fonts/KaTeX_Z-Regular.otf') format('opentype');\r\n}\r\n/* #endregion */\r\n/* #region index.html */\r\n#background {\r\n  bottom: 0;\r\n  left: 0;\r\n  overflow: hidden;\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n  transition: background-color 350ms ease-in-out, opacity 200ms ease-in-out;\r\n  z-index: -1;\r\n}\r\n\r\n#background.blur * {\r\n  opacity: 0.15 !important;\r\n}\r\n\r\n#background.rain {\r\n  background: none;\r\n  opacity: 1;\r\n}\r\n\r\nbody {\r\n  background: linear-gradient(33deg, #211a1e 0%, #19211e 100%);\r\n  background-attachment: fixed;\r\n  background-color: rgb(30, 27, 27);\r\n  filter: saturate(0.875);\r\n}\r\n\r\n.br {\r\n  height: 4.75vmin;\r\n}\r\n\r\n#loading {\r\n  background: none;\r\n  bottom: 50%;\r\n  bottom: calc(50% - env(safe-area-inset-top) - env(safe-area-inset-bottom));\r\n  height: 80px;\r\n  left: 50%;\r\n  position: fixed;\r\n  transform: translate(-50%, 50%);\r\n  width: 80px;\r\n}\r\n\r\n/* Orbit spinner styling lives in getOrbit() and orbit.svg */\r\n\r\n/* #endregion */\r\n/* #region panel.js */\r\n#chart-div {\r\n  left: 0;\r\n  opacity: 1;\r\n  transform-origin: top left;\r\n  transition: opacity 250ms ease-in-out;\r\n  width: 275px;\r\n  z-index: 2;\r\n}\r\n\r\n#board-video, #chart-rankings, #chart-stats, #sheet-friends, #sheet-songs {\r\n  align-items: start;\r\n  margin-bottom: 5.25px;\r\n  /* The app's scroll fade (dash.css lists, the memo, the toolbag): --scroll is set by fadeScroll\r\n     (script.js) only while the list overflows, so otherwise the mask is invalid and nothing fades. */\r\n  mask-image: linear-gradient(rgba(0, 0, 0, calc(1 - var(--scroll))) 0%, rgba(0, 0, 0, calc(0.75 * (1 / var(--scroll)))) 5%, rgba(0, 0, 0, 1) 10%, rgba(0, 0, 0, 1) 90%, rgba(0, 0, 0, calc(0.75 * (1 / (1 - var(--scroll))))) 95%, rgba(0, 0, 0, var(--scroll)) 100%);\r\n  overflow-x: hidden;\r\n  overflow-y: scroll;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n#board-video, #chart-rankings, #chart-stats, #sheet-friends, #sheet-songs {\r\n  max-height: 235px;\r\n}\r\n\r\n/* Friends and songs lists sit a touch taller than the chart panels above (which\r\n   keep 235px) - overriding just these two, later + equal specificity wins. */\r\n#sheet-friends, #sheet-songs {\r\n  max-height: 265px;\r\n}\r\n\r\n/* Sheet friends panel sizes to its actual content rather than filling the parent\r\n   vertically (the shared `height: calc(100% - 40px)` from a few rules below was\r\n   leaving a gap below the AVATARS list when fairies hadn't been collected yet).\r\n   Capped by max-height above when the list is long. */\r\n#sheet-friends {\r\n  height: auto;\r\n}\r\n\r\n/* Strip the trailing 6px margin-bottom from the LAST VISIBLE child in the\r\n   friends list — applies to ANY element type (section header li, section ul, etc.).\r\n   The 6px exists to space items from each other; on the last visible one it's\r\n   just dead space. Covers: collapsed sections (header visible, ul hidden),\r\n   single-section panels, and future critter sections — all generic, no JS. */\r\n#sheet-friends > ul > *:not(:has(~ *:not([style*=\"display: none\"]))) {\r\n  margin-bottom: 0;\r\n}\r\n\r\n#board-video ul, #chart-rankings ul, #chart-stats ul, #sheet-friends ul, #sheet-songs ul {\r\n  list-style-type: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  width: calc(100% - 0.05vmin);\r\n}\r\n\r\n#sheet-friends ul {\r\n  margin-bottom: 6px;\r\n}\r\n\r\n#chart-rankings li {\r\n  line-height: 15px;\r\n}\r\n\r\n#board-video li, #chart-rankings li, #chart-stats li, #sheet-friends li, #sheet-songs li {\r\n  background: linear-gradient(to bottom, rgba(200, 180, 180, 0.4) -100%, rgba(50, 45, 45, 0.4) 125%);\r\n  border-radius: 4px;\r\n  box-shadow: 0.15vmin 0.15vmin rgba(10, 9, 9, 0.25);\r\n  color: rgb(250, 225, 225);\r\n  display: flex;\r\n  font-family: Archivo, sans-serif;\r\n  font-size: 14px;\r\n  font-weight: 550;\r\n  margin-bottom: 6px;\r\n  padding: 4px 5px;\r\n  position: relative;\r\n  text-shadow: 0.125vmin 0.125vmin rgba(10, 9, 9, 0.5);\r\n}\r\n\r\n#chart-stats li.grade-header, #sheet-friends li.friends-header {\r\n  cursor: pointer;\r\n  font-size: 12.5px;\r\n  font-weight: 700;\r\n  justify-content: space-between;\r\n  width: calc(100% - 10px);\r\n}\r\n\r\n#board-video li:last-child, #chart-rankings li:last-child, #chart-stats ul:first-child li, #chart-stats ul:last-child li:last-child, #sheet-friends li:last-child, #sheet-friends ul:last-child, #sheet-songs li:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n#chart-rankings li span, #chart-stats li span {\r\n  align-items: center;\r\n  display: flex;\r\n}\r\n\r\n#chart-rankings li span:first-child svg {\r\n  height: 15px;\r\n  margin-right: 5px;\r\n  width: 15px;\r\n}\r\n\r\n#chart-rankings p {\r\n  color: rgb(250, 225, 225);\r\n  font-family: 'Archivo';\r\n  font-size: 14px;\r\n  font-weight: 550;\r\n  line-height: 15px;\r\n  text-shadow: 0.125vmin 0.125vmin rgba(10, 9, 9, 0.5);\r\n}\r\n\r\n#chart-stats a {\r\n  color: unset;\r\n  text-decoration: none;\r\n}\r\n\r\n#chart-stats li span:first-child svg {\r\n  height: 11px;\r\n  margin-right: 4px;\r\n  width: 12px;\r\n}\r\n\r\n#chart-rankings li span:nth-child(2) {\r\n  font-family: 'Unifont', monospace;\r\n  line-height: 0;\r\n  margin-bottom: 1px;\r\n}\r\n\r\n#chart-rankings li span:nth-child(2), #chart-stats li span:nth-child(1) {\r\n  width: 100%;\r\n}\r\n\r\n#chart-rankings li span:nth-child(3) svg, #chart-stats li span:nth-child(2) svg {\r\n  height: 10px;\r\n  padding: 1px;\r\n  width: 10px;\r\n}\r\n\r\n.panel-button.friend-button, .panel-button.song-button {\r\n  font-size: 10.5px;\r\n  font-weight: 550;\r\n  margin-left: 6px;\r\n  outline: none;\r\n  padding: 1px 40px;\r\n  width: 68px;\r\n}\r\n\r\n.panel-expand-button {\r\n  background: none;\r\n  border: none;\r\n  height: 11px;\r\n  padding: 0 6px;\r\n  pointer-events: none;\r\n  text-align: end;\r\n}\r\n\r\n.panel-expand-button svg {\r\n  height: 12px;\r\n  padding: 0.5px 0 0 0;\r\n  transform: scaleX(2.5);\r\n  width: 12px;\r\n}\r\n\r\n.friend-canvas {\r\n  height: 22px;\r\n  image-rendering: pixelated;\r\n  width: 32px;\r\n}\r\n\r\n.friend-entry-left, .song-entry-left, .video-step-left {\r\n  align-items: center;\r\n  display: flex;\r\n  height: 31px;\r\n  justify-content: center;\r\n  margin-right: 6px;\r\n  width: 32px;\r\n}\r\n\r\n.friend-entry-name-span {\r\n  margin-right: 6px;\r\n}\r\n\r\n.friend-entry-heart-span {\r\n  align-items: center;\r\n  display: flex;\r\n  flex: 1;\r\n}\r\n\r\n.friend-entry-heart-span svg {\r\n  margin-left: 3px;\r\n  height: 12px;\r\n  width: 12px;\r\n}\r\n\r\n.friend-entry-right, .song-entry-right, .video-step-right {\r\n  width: calc(100% - 32px);\r\n}\r\n\r\n.friend-entry-right-top, .song-entry-right-top, .video-step-right-top {\r\n  display: flex;\r\n  flex-direction: row;\r\n  height: 15.5px;\r\n}\r\n\r\n.panel {\r\n  backdrop-filter: blur(10px);\r\n  border: none;\r\n  border-radius: 4px;\r\n  box-shadow: 0.15vmin 0.15vmin rgba(10, 9, 9, 0.5);\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  flex-direction: column;\r\n  letter-spacing: normal;\r\n  opacity: 0;\r\n  position: absolute;\r\n  text-align: left;\r\n  transform: scale(var(--session-scale-x), var(--session-scale-y));\r\n  top: 0;\r\n  z-index: -1;\r\n}\r\n\r\n.slide-div .panel {\r\n  opacity: 0.95;\r\n  z-index: 3;\r\n}\r\n\r\n.slide-div.video #board-div:not(:hover), .slide-div.video #chart-div:not(:hover) {\r\n  opacity: 0.25;\r\n}\r\n\r\n/* Fade the chart and the sheet whenever they aren't moused over - the same idea the video\r\n   layout uses, at half its intensity (video drops to 0.25, this stops at 0.5). Scoped to the\r\n   GAME only - these panels sit over the world and are wanted only when looked at, whereas in a\r\n   lesson the chart is reference material beside the work. Applies in every state, expanded or\r\n   minimized.\r\n   Two guards matter. `:not(.galaxy):not(.rainbow) >` keeps this away from the game's\r\n   galaxy/rainbow modes, which hide these panels outright with `opacity: 0` - without it these\r\n   rules would outrank that and make a deliberately hidden panel visible again.\r\n   `html:not(.dash)` keeps it off dashboard tiles, where nothing is ever hovered, so the panels\r\n   would sit permanently faded on every tile. */\r\n/* ON HOLD (Aug 2026) - commented out at the user's request, not deleted, so the reasoning\r\n   above survives if it comes back. */\r\n/*\r\nhtml:not(.dash) .game-div:not(.galaxy):not(.rainbow) > #chart-div:not(:hover),\r\nhtml:not(.dash) .game-div:not(.galaxy):not(.rainbow) > #sheet-div:not(:hover) {\r\n  opacity: 0.5;\r\n}\r\n*/\r\n\r\n.panel .header {\r\n  height: 36px;\r\n  padding: 6px;\r\n}\r\n\r\n.panel .header-center {\r\n  flex: 0 1 55%;\r\n}\r\n\r\n.panel .header-left {\r\n  margin-right: 6px;\r\n}\r\n\r\n.panel .header-left button svg {\r\n  height: 11px;\r\n  width: 11px;\r\n}\r\n\r\n.panel .header-right {\r\n  margin-left: 6px;\r\n}\r\n\r\n.panel .header-title {\r\n  position: absolute;\r\n  left: 50%;\r\n  transform: translate(-50%, 0%);\r\n}\r\n\r\n.panel-button {\r\n  align-items: center;\r\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) -100%, rgba(20, 18, 18, 0.5) 150%);\r\n  border: none;\r\n  border-radius: 4px;\r\n  box-shadow: 0.05vmin 0.05vmin rgba(10, 9, 9, 0.5);\r\n  color: rgb(250, 225, 225);\r\n  cursor: pointer;\r\n  display: flex;\r\n  height: 100%;\r\n  justify-content: center;\r\n  transition: background-color 25ms ease-in-out;\r\n  width: 100%;\r\n}\r\n\r\n.panel-button:not(.friend-button):not(.song-button):disabled {\r\n  opacity: 1 !important;\r\n}\r\n\r\n.panel-button:disabled span, .panel-button:disabled svg {\r\n  opacity: 0.25;\r\n}\r\n\r\n/* A video button with nothing to play: greyed like :disabled, but still clickable so the click\r\n   can say why (a dialog, event.js); the global button:disabled rule kills pointer events. */\r\n#video-button.empty span, #video-button.empty svg {\r\n  opacity: 0.25;\r\n}\r\n\r\n.panel-button.glow {\r\n  background-color: var(--student-color-mid);\r\n  filter: drop-shadow(0 0 25px var(--student-color-mid));\r\n}\r\n\r\n.color-pulse {\r\n  animation: color-pulse 120s infinite;\r\n}\r\n\r\n@keyframes color-pulse {\r\n  0%, 1%, 100% {\r\n    background-color: transparent;\r\n    filter: drop-shadow(0 0 0 transparent);\r\n  }\r\n  0.25% {\r\n    background-color: var(--student-color-mid);\r\n    filter: drop-shadow(0 0 3vmin var(--student-color-mid));\r\n  }\r\n}\r\n\r\n.panel-label {\r\n  font-family: Archivo, sans-serif;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.025em;\r\n  pointer-events: none;\r\n  text-shadow: 0.125vmin 0.125vmin rgba(10, 9, 9, 0.5);\r\n  text-transform: uppercase;\r\n}\r\n\r\n#board-div, #sheet-div {\r\n  max-width: 100vw;\r\n  opacity: 1;\r\n  right: 0.2vmin;\r\n  transform-origin: top right;\r\n  transition: opacity 250ms ease-in-out;\r\n  width: 325px;\r\n  z-index: 2;\r\n}\r\n\r\n#board-instructions, #board-facts, #board-video, #chart-rankings, #chart-stats, #sheet-friends, #sheet-songs {\r\n  align-items: center;\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: calc(100% - 40px);\r\n  padding: 0 6px 2px 6.5px;\r\n}\r\n\r\n#board-instructions h2 {\r\n  font-size: 18px;\r\n  margin: 5px 0px 10px 0px;\r\n  text-align: center;\r\n}\r\n\r\n#board-instructions ol, #board-instructions ul {\r\n  align-self: stretch;\r\n  font-size: 13px;\r\n  line-height: 18px;\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0 0 3.5px 1px;\r\n}\r\n\r\n#board-instructions ol ol, #board-instructions ul ul {\r\n  padding-left: 0;\r\n}\r\n\r\n#board-instructions li {\r\n  padding-left: 17px;\r\n  position: relative;\r\n}\r\n\r\n#board-instructions .ins-row {\r\n  transition: opacity 0.15s;\r\n}\r\n\r\n#board-instructions li.checked > .ins-row {\r\n  opacity: 0.4;\r\n}\r\n\r\n#board-instructions li.checked > .ins-row:hover {\r\n  opacity: 1;\r\n}\r\n\r\n#board-instructions .ins-mark {\r\n  display: inline-block;\r\n  min-width: 14px;\r\n}\r\n\r\n#board-instructions .ins-check {\r\n  background: rgb(250, 225, 225);\r\n  border: none;\r\n  border-radius: 2px;\r\n  cursor: pointer;\r\n  height: 11px;\r\n  left: 0;\r\n  position: absolute;\r\n  text-shadow: none;\r\n  top: 3px;\r\n  width: 11px;\r\n}\r\n\r\n#board-instructions li.checked .ins-check::after {\r\n  color: rgb(10, 9, 9);\r\n  content: '\\2713';\r\n  font-size: 10px;\r\n  font-weight: bold;\r\n  left: 50%;\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n/* Facts Panel Styles */\r\n#board-facts {\r\n  flex-direction: column;\r\n  font-family: 'Archivo';\r\n  justify-content: center;\r\n  overflow-y: auto;\r\n  position: relative;\r\n}\r\n\r\n/* Fact Div Styles (shared between game and board) */\r\n#fact-background,\r\n#power-background {\r\n  background: linear-gradient(to top, #73e6d2 0%, #ff80bf 50%, #ffe666 100%);\r\n  border-radius: 4px;\r\n  bottom: 0;\r\n  height: 0%;\r\n  left: 0;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  position: absolute;\r\n  transition: background-color 175ms;\r\n  width: 100%;\r\n}\r\n\r\n/* Only BATTLE takes the avatar's colour: harvesting shares the fire skills (the pink) and keeps it.\r\n   Without .battle the two variables are cleared, so every var() below falls back to the pink. */\r\n#fact-div:not(.battle) {\r\n  --avatar-color: initial;\r\n  --avatar-color-dark: initial;\r\n}\r\n\r\n#fact-div.fire #fact-background {\r\n  background: linear-gradient(to top, transparent 75%, rgb(250, 225, 225) 100%);\r\n  background-color: var(--avatar-color, #ff80bf);\r\n}\r\n#fact-div.water #fact-background {\r\n  background: linear-gradient(to top, transparent 75%, rgb(250, 225, 225) 100%);\r\n  background-color: #73e6d2;\r\n}\r\n#fact-div.wind #fact-background {\r\n  background: linear-gradient(to top, transparent 75%, rgb(250, 225, 225) 100%);\r\n  background-color: #ffe666;\r\n}\r\n\r\n#fact-div.loading-skills #fact-background {\r\n  filter: grayscale(1);\r\n  opacity: 0.75;\r\n}\r\n\r\n#fact-bottom {\r\n  display: flex;\r\n  flex-direction: row;\r\n  width: 100%;\r\n}\r\n\r\n#board-facts #fact-bottom {\r\n  margin-bottom: 5.5px;\r\n}\r\n\r\n#board-facts .fact-button {\r\n  width: 100%;\r\n}\r\n\r\n#board-facts #fact-center, #board-facts #fact-left, #board-facts #fact-right {\r\n  width: 33.33%;\r\n}\r\n\r\n#fact-div.loading-skills #fact-bottom {\r\n  filter: grayscale(1);\r\n  opacity: 0.75;\r\n}\r\n\r\n.fact-button, .song-note-button {\r\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) -100%, rgba(20, 18, 18, 0.5) 150%);\r\n  border: none;\r\n  border-radius: 4px;\r\n  box-shadow: 1px 1px rgba(10, 9, 9, 0.25);\r\n  box-sizing: border-box;\r\n  color: rgb(250, 225, 225);\r\n  cursor: pointer;\r\n  font-family: Archivo, sans-serif;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  height: 40px;\r\n  opacity: 1;\r\n  /* 4px sides, not 6: the distributive-property option 5x + 20 is 43px at the button font\r\n     and wrapped onto two lines inside a 40px content box (Sep 2026). Shrinking the text was\r\n     rejected as too small, 2px sides as gaudy; 4px is the room that still reads as a margin. */\r\n  padding: 4px 4px;\r\n  position: relative;\r\n  width: 52px;\r\n}\r\n\r\n/* Never wrap an answer: a two-line option is unreadable at this size. */\r\n.fact-button .katex {\r\n  white-space: nowrap;\r\n}\r\n\r\n.fact-button:focus, .song-note-button:focus {\r\n  outline: none;\r\n}\r\n\r\n#fact-div.skills .fact-button {\r\n  cursor: pointer;\r\n  opacity: 1;\r\n}\r\n\r\n#fact-div.skills.bonding .fact-button-tooltip, #fact-div.skills.bonding #power-background-cost {\r\n  color: #ff80bf;\r\n  filter: drop-shadow(2px 4px 6px rgb(10, 9, 10));\r\n}\r\n\r\n#fact-div.skills.bonding .fact-button-tooltip svg path, #fact-div.skills.bonding #power-background-cost svg path {\r\n  fill: #ff80bf;\r\n}\r\n\r\n.fact-button.incorrect {\r\n  opacity: 0;\r\n  transition: opacity 500ms ease-in-out;\r\n}\r\n\r\n/* Children must not intercept pointer events — on iPad, fingers land on the inner\r\n   KaTeX/span content, which makes event.target the span (not the button) and the\r\n   document-level pointerDown dispatcher falls through to the drag branch instead\r\n   of the fact-button branch. */\r\n.fact-button > * { pointer-events: none; }\r\n\r\n.fact-button-span {\r\n  padding-top: 0px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n}\r\n/* Two-line value+unit answers (geometry/conversion skills). Plain HTML flex\r\n   stack — KaTeX's substack didn't center reliably inside the button. The\r\n   value is rendered via KaTeX (inherits font from button at 0.8em); unit\r\n   label uses KaTeX_Main serif so its font matches the math content. */\r\n.fact-button-span .unit-answer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  line-height: 1.05;\r\n  font-size: 0.8em;\r\n}\r\n.fact-button-span .unit-answer .unit-label {\r\n  font-family: KaTeX_Main, 'Times New Roman', serif;\r\n  font-size: 0.72em;\r\n  opacity: 0.8;\r\n  margin-top: 1px;\r\n}\r\n/* Two-line stacked answer (both lines equal weight, e.g., elapsed-time\r\n   \"6 hr / 40 min\"). Lines stay close vertically so they share the button\r\n   space without either needing to shrink. */\r\n.fact-button-span .stacked-answer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  line-height: 1.05;\r\n  font-size: 0.78em;\r\n}\r\n\r\n#board-facts .fact-button-span {\r\n  scale: 1.125;\r\n}\r\n\r\n#fact-div.right .fact-button-span.fraction {\r\n  font-size: 1.15em;\r\n}\r\n\r\n/* Override the generic `.fraction { margin-right: 0.35em }` from app.css —\r\n   inside an answer button, the span is a flex container that fills the\r\n   button and should not have trailing margin, otherwise its content visually\r\n   veers left. */\r\n.fact-button-span.fraction {\r\n  margin-right: 0;\r\n}\r\n\r\n#fact-div.right .fact-button-span.chars-4 {\r\n  font-size: 0.85em;\r\n}\r\n\r\n#fact-div.right .fact-button-span.chars-5 {\r\n  font-size: 0.8em;\r\n}\r\n\r\n#fact-div.right .fact-button-span.chars-6 {\r\n  font-size: 0.75em;\r\n}\r\n\r\n#fact-div.right .fact-button-span.chars-7 {\r\n  font-size: 0.7em;\r\n}\r\n\r\n#fact-div.right .fact-button-span.chars-8 {\r\n  font-size: 0.65em;\r\n}\r\n\r\n/* Word-only answers (aro/tc/qc classifications) — text in body font is wider\r\n   than digits at the same point size, so use a smaller scale + allow wrap so\r\n   long classifications like \"Parallelogram\" fit. Scoped to .fact-button-span\r\n   without the #fact-div.right parent so it works in both skills and right modes. */\r\n.fact-button-span.chars-text {\r\n  font-size: 0.7em;\r\n  line-height: 1.05;\r\n  white-space: normal;\r\n  padding: 0 2px;\r\n}\r\n\r\n.fact-button-span svg {\r\n  height: 90%;\r\n  width: 90%;\r\n}\r\n\r\n.fact-button-tooltip, .item-count-tooltip, #power-background-cost, .song-note-button-tooltip {\r\n  background-color: rgba(10, 9, 10, 0.5);\r\n  border-radius: 4px;\r\n  bottom: 1.5px;\r\n  color: rgba(250, 225, 225, 0.9);\r\n  display: flex;\r\n  flex-direction: row;\r\n  font-size: 8.5px;\r\n  font-weight: 500;\r\n  left: 2.5px;\r\n  padding: 2px 4px 2px 4.5px;\r\n  position: absolute;\r\n}\r\n\r\n.item-count-tooltip {\r\n  bottom: 2.5px;\r\n  font-family: Archivo, sans-serif;\r\n  left: auto;\r\n  right: 2.5px;\r\n}\r\n\r\n#fact-div:not(.skills) .fact-button-tooltip {\r\n  opacity: 0;\r\n}\r\n\r\n#fact-div:not(.skills):hover .fact-button-tooltip {\r\n  opacity: 1;\r\n}\r\n\r\n.fact-button-tooltip svg, #power-background-cost svg {\r\n  height: 7.5px;\r\n  margin: 0 2px 0 -1px;\r\n  padding-top: 1px;\r\n  width: 7.5px;\r\n}\r\n\r\n#fact-center {\r\n  margin: 0 6px;\r\n}\r\n\r\n#fact-div, #song-div {\r\n  color: rgb(250, 225, 225);\r\n  display: flex;\r\n  font-family: Archivo, sans-serif;\r\n  font-weight: 650;\r\n  flex-direction: column;\r\n  text-shadow: 1px 1px rgb(10, 9, 9);\r\n  transition: opacity 250ms ease-in-out;\r\n  width: 100%;\r\n}\r\n\r\n/* Game context styles */\r\n#fact-div.right, #song-div {\r\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.35) -100%, rgba(20, 18, 18, 0.7) 200%);\r\n  backdrop-filter: blur(12.5px);\r\n  border-radius: 4px;\r\n  box-shadow: 0.15vmin 0.15vmin rgba(10, 9, 9, 0.5);\r\n  box-sizing: border-box;\r\n  filter: brightness(1.25);\r\n  height: 120px;\r\n  padding: 6px;\r\n  position: absolute;\r\n  right: calc(25% - 90px);\r\n  top: calc(50% - 60px);\r\n  width: 180px;\r\n}\r\n\r\n#fact-div.right.visible, #song-div-overlay.visible {\r\n  opacity: 1;\r\n}\r\n\r\n#fact-div.right:not(.visible), #song-div-overlay:not(.visible) {\r\n  opacity: 0;\r\n  z-index: -1;\r\n}\r\n\r\n/* a fact already shown stays faded while hidden (event.js, the fact echo): still draggable, but a press\r\n   on it answers nothing (event.js pointerDown) */\r\n#fact-div.right.revealed:not(.visible):not(.skills):not(.loading-skills):not(.powering-up) {\r\n  opacity: 0.35;\r\n  z-index: 1;\r\n}\r\n\r\n#fact-div.right.answered:not(.visible):not(.skills) {\r\n  opacity: 1;\r\n  z-index: 1;\r\n}\r\n\r\n#fact-div svg path.skill-type {\r\n  transition: fill 175ms;\r\n}\r\n\r\n#fact-div.fire svg path.skill-type {\r\n  fill: var(--avatar-color, #ff80bf) !important;\r\n  filter: brightness(0.8);\r\n}\r\n\r\n#fact-div.water svg path.skill-type {\r\n  fill: #73e6d2 !important;\r\n  filter: brightness(0.8);\r\n}\r\n#fact-div.wind svg path.skill-type {\r\n  fill: #ffe666 !important;\r\n  filter: brightness(0.8);\r\n}\r\n\r\n#fact-question, #song-header, #song-staff {\r\n  align-items: center;\r\n  background: linear-gradient(to bottom, rgba(200, 180, 180, 0.2) -100%, rgba(50, 45, 45, 0.2) 125%);\r\n  border-radius: 4px;\r\n  box-shadow: 1px 1px rgba(10, 9, 9, 0.25);\r\n  display: flex;\r\n  height: 68px;\r\n  justify-content: center;\r\n  margin-bottom: 6px;\r\n  width: 100%;\r\n}\r\n\r\n#fact-div.skills #fact-question {\r\n  background: linear-gradient(to bottom, rgba(200, 180, 180, 0.6) -100%, rgba(50, 45, 45, 0.6) 125%);\r\n}\r\n\r\n/* Use the `translate` property (not `transform`) so the question-scaling code's\r\n   inline `transform: scale(...)` composes with the nudge instead of overriding it. */\r\n#fact-question[data-skill=\"r\"] > span, #fact-question[data-skill=\"dr\"] > span,\r\n#fact-question[data-skill=\"ef\"] > span {\r\n  translate: 0 2.5px;\r\n}\r\n/* pc (percent change) copies the rounding layout but not rounding's 0.95em digits, so at\r\n   rounding's 2.5px it still sat ~2.8px high (measured live, Sep 2026); at 4px it lands where\r\n   ca/sa/ae/et do. */\r\n/* New gathered-format skills sit slightly higher visually because their second\r\n   line uses scriptstyle (smaller than rounding's). Larger translateY (4px) to\r\n   compensate so the 2-line content sits centered in the 68px question box. */\r\n#fact-question[data-skill=\"ca\"] > span, #fact-question[data-skill=\"sa\"] > span,\r\n#fact-question[data-skill=\"ae\"] > span, #fact-question[data-skill=\"et\"] > span,\r\n#fact-question[data-skill=\"pc\"] > span {\r\n  translate: 0 4px;\r\n}\r\n\r\n#fact-question[data-skill=\"lfa\"] > span, #fact-question[data-skill=\"lfs\"] > span,\r\n#fact-question[data-skill=\"fm\"] > span, #fact-question[data-skill=\"fd\"] > span,\r\n#fact-question[data-skill=\"fc\"] > span, #fact-question[data-skill=\"fs\"] > span,\r\n#fact-question[data-skill=\"ifc\"] > span, #fact-question[data-skill=\"mnc\"] > span,\r\n#fact-question[data-skill=\"ef\"] > span, #fact-question[data-skill=\"ufa\"] > span,\r\n#fact-question[data-skill=\"ufs\"] > span, #fact-question[data-skill=\"fdc\"] > span,\r\n#fact-question[data-skill=\"fpc\"] > span {\r\n  font-size: 1.15em;\r\n}\r\n\r\n/* Equivalent fractions: the boxed blank adds height to whichever side it is on, and a KaTeX\r\n   fraction's inline box does not cover that, so the ink sits ~5px low with the blank in a\r\n   numerator and ~5px high with it in a denominator (measured live, Sep 2026). The slot is\r\n   already on the question as data-a (x_a / x_c numerators, x_b / x_d denominators), so the\r\n   nudge is decided from the generated problem, before render, with no measuring. */\r\n#fact-question[data-skill=\"ef\"][data-a=\"x_a\"] > span, #fact-question[data-skill=\"ef\"][data-a=\"x_c\"] > span {\r\n  translate: 0 -5px;\r\n}\r\n\r\n#fact-question[data-skill=\"ef\"][data-a=\"x_b\"] > span, #fact-question[data-skill=\"ef\"][data-a=\"x_d\"] > span {\r\n  translate: 0 5px;\r\n}\r\n/* Geometry skills (verb + SVG): scale the verb's KaTeX block down so the\r\n   `\\text{Verb: }` rendering visually matches old fs's \"Simplify fully:\".\r\n   Using descendant selector (not direct child) for resilience. */\r\n#fact-question[data-skill=\"ar\"] .katex,\r\n#fact-question[data-skill=\"pr\"] .katex,\r\n#fact-question[data-skill=\"vrp\"] .katex,\r\n#fact-question[data-skill=\"at\"] .katex,\r\n#fact-question[data-skill=\"aro\"] .katex,\r\n#fact-question[data-skill=\"ac\"] .katex,\r\n#fact-question[data-skill=\"cc\"] .katex {\r\n  font-size: 0.85em;\r\n}\r\n\r\n#fact-question[data-skill=\"r\"] .mord, #fact-question[data-skill=\"dr\"] .mord {\r\n  font-size: 0.95em;\r\n}\r\n\r\n#board-facts #fact-question > span {\r\n  scale: 1.125;\r\n}\r\n\r\n#fact-question span.amsrm {\r\n  text-shadow: none;\r\n}\r\n\r\n#fact-question span.fbox {\r\n  background: linear-gradient(to bottom, rgba(200, 180, 180, 0.1) -100%, rgba(50, 45, 45, 0.1) 125%);\r\n  border-radius: 4px;\r\n  box-shadow: 0.15vmin 0.15vmin rgba(10, 9, 9, 0.5);\r\n  scale: 0.85;\r\n}\r\n\r\n/* Generic icon SVGs (speaker, alert, etc.) — fixed 16px. Geometry/diagram SVGs\r\n   carry the `.geo` class to opt out and render at their declared dimensions. */\r\n#fact-question svg:not(.geo), #song-staff svg {\r\n  height: 16px;\r\n  margin-right: 4.5px;\r\n  width: 16px;\r\n}\r\n#fact-question svg.geo {\r\n  vertical-align: middle;\r\n  margin-left: 4px;\r\n}\r\n/* Polygon-type shapes (rectangles, triangles, prisms, circles) sit slightly\r\n   higher than ideal — nudge down 3px. aro's angle drawing is already\r\n   vertically centered via its own <g transform> so it skips this. Use the\r\n   `translate` property so it composes with the inline `transform: scale(...)`\r\n   the question-scaling code applies when content overflows. */\r\n#fact-question[data-skill=\"ar\"] svg.geo,\r\n#fact-question[data-skill=\"pr\"] svg.geo,\r\n#fact-question[data-skill=\"vrp\"] svg.geo,\r\n#fact-question[data-skill=\"at\"] svg.geo,\r\n#fact-question[data-skill=\"ac\"] svg.geo,\r\n#fact-question[data-skill=\"cc\"] svg.geo {\r\n  translate: 0 3px;\r\n}\r\n/* SVG text labels match KaTeX's main font (Computer Modern serif). Thin dark\r\n   stroke + dark drop-shadow gives labels a tight outline plus a soft halo so\r\n   they stay legible against shape strokes and the panel background. SVG renders\r\n   in document order — labels are written after the shape and paint above. */\r\n#fact-question svg.geo text {\r\n  font-family: KaTeX_Main, 'Times New Roman', serif;\r\n  font-weight: normal; /* parent inherits 650 which made labels look bold */\r\n  paint-order: stroke fill;\r\n  stroke: rgb(10, 9, 9);\r\n  stroke-width: 0.6px;\r\n  stroke-linejoin: round;\r\n  filter: drop-shadow(0 0 2px rgb(10, 9, 9));\r\n}\r\n\r\n#fact-div.powering-up #fact-bottom, \r\n#fact-div.powering-up #fact-question {\r\n  opacity: 0;\r\n}\r\n\r\n#power-background {\r\n  align-items: center;\r\n  display: flex;\r\n  justify-content: center;\r\n  opacity: 1;\r\n  overflow: hidden;\r\n  scale: 0.99;\r\n  text-shadow: 1px 1px rgba(10, 9, 9, 0.5);\r\n  transform: translateX(-1px);\r\n}\r\n\r\n#power-background circle.color {\r\n  fill: #ff409f;\r\n}\r\n\r\n/* In battle the power-up circle takes the avatar's own colour (set on the game div by drawAvatar). */\r\n#fact-div.fire #power-background circle.color {\r\n  fill: var(--avatar-color-dark, #ff409f);\r\n}\r\n\r\n/* In battle the starry power-up background is the darkened avatar colour, not the shared\r\n   teal-pink-yellow gradient, with the same pale wash at the top the fact background has. */\r\n#fact-div.fire.battle #power-background {\r\n  background: linear-gradient(to top, transparent 75%, rgba(250, 225, 225, 0.5) 100%);\r\n  background-color: var(--avatar-color-dark, #ff80bf);\r\n}\r\n\r\n#fact-div:not(.powering-up) #power-background {\r\n  border: none !important;\r\n}\r\n\r\n#power-background-cost {\r\n  left: 50%;\r\n  transform: scale(1.5) translate(-33.33%, -1.5px);\r\n  transform-origin: bottom center;\r\n}\r\n\r\n#power-background-span {\r\n  display: flex;\r\n  filter: drop-shadow(0 0 10px rgba(10, 9, 9, 0.5));\r\n  opacity: 0;\r\n  transition: opacity 1000ms ease-in-out;\r\n}\r\n\r\n#fact-div.powering-up #power-background-span {\r\n  opacity: 1;\r\n}\r\n\r\n#power-background-span svg {\r\n  height: 16px;\r\n  margin-right: 4px;\r\n  transform: translateY(1px);\r\n  width: 16px;\r\n}\r\n\r\n.power-background-star {\r\n  opacity: var(--power-percent, 0%);\r\n  position: absolute;\r\n  transform: translate(-50%, -50%);\r\n  z-index: -1;\r\n}\r\n\r\n#fact-div:not(.powering-up) .power-background-star {\r\n  opacity: 0;\r\n}\r\n\r\n#record-stop-button {\r\n  margin-left: 0.75vmin;\r\n}\r\n\r\n.video-icon {\r\n  display: flex;\r\n  padding-right: 3px;\r\n}\r\n/* #endregion */\r\n/* #region #avatar-div */\r\n#avatar-style-div {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n#avatar-preview-div {\r\n  align-items: center;\r\n  background: rgba(250, 225, 225, 0.25);\r\n  border-radius: 4px;\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-left: 6px;\r\n  width: 120px;\r\n}\r\n\r\n#avatar-preview-div canvas {\r\n  height: 80px;\r\n  width: 80px;\r\n}\r\n\r\n.avatar-select-button {\r\n  height: 27.5px !important;\r\n  width: 32px !important;\r\n}\r\n\r\n.avatar-select-button svg {\r\n  height: 14px;\r\n  width: 14px;\r\n}\r\n\r\n.avatar-select-div {\r\n  align-items: center;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  width: 128px;\r\n}\r\n\r\n.avatar-select-label {\r\n  font-size: 14px;\r\n}\r\n\r\n.avatar-select-span {\r\n  font-size: 14px;\r\n  font-stretch: 95%;\r\n  padding: 6px;\r\n}\r\n\r\n#avatar-settings-div {\r\n  width: 224px;\r\n}\r\n\r\n.avatar-setting-div {\r\n  align-items: center;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.avatar-setting-div:not(:last-child) {\r\n  margin-bottom: 5px;\r\n}\r\n\r\n#enter-button:hover {\r\n  background: linear-gradient(45deg, #73e6d2 0%, #ff80bf 50%, #ffe666 100%);\r\n  color: rgb(10, 9, 9);\r\n  text-shadow: 0.05vmin 0.05vmin rgba(250, 225, 225, 0.5);\r\n}\r\n\r\n#enter-button, #enter-div {\r\n  width: 100%;\r\n}\r\n\r\n#enter-div {\r\n  margin-top: 6px;\r\n}\r\n\r\n#nickname-div {\r\n  align-items: center;\r\n  display: flex;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n#nickname-input {\r\n  font-family: 'Unifont', monospace;\r\n  height: 42px;\r\n  margin: 0 6px 0 11px;\r\n  width: 170.8px;\r\n}\r\n\r\n#avatar-div {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 362px;\r\n  z-index: 2;\r\n}\r\n\r\n.ui button.trait-button {\r\n  font-size: 15px;\r\n  height: 28px;\r\n  margin: 0 3px 3px 0;\r\n}\r\n\r\n.ui button.trait-button.selected {\r\n  background: var(--student-color-dark);\r\n}\r\n\r\n.ui button.trait-button.selected:hover {\r\n  background: var(--student-color-mid) !important;\r\n}\r\n\r\n#traits-div {\r\n  width: 350px;\r\n}\r\n\r\n#traits-grid {\r\n  background: rgba(250, 225, 225, 0.25);\r\n  border-radius: 4px;\r\n  padding: 3px 3px 0 3px;\r\n}\r\n\r\n#traits-header {\r\n  align-items: center;\r\n  display: flex;\r\n  height: 37.5px;\r\n}\r\n\r\n#traits-header-left {\r\n  font-size: 16px;\r\n  width: 50%;\r\n}\r\n\r\n#traits-header-right {\r\n  font-size: 14px;\r\n  text-align: end;\r\n  width: 50%;\r\n}\r\n\r\n.video-step.locked {\r\n  opacity: 0.4;\r\n  pointer-events: none;\r\n}\r\n\r\n.video-step.locked .video-step-title-span,\r\n.video-step.title-hidden .video-step-title-span {\r\n  background: linear-gradient(rgba(200, 180, 180, 0.5) -150%, rgba(100, 90, 90, 0.5) 125%);\r\n  border-radius: 4px;\r\n  color: transparent;\r\n  text-shadow: none;\r\n}\r\n\r\n.video-step-button {\r\n  align-items: center;\r\n  cursor: pointer;\r\n  display: flex;\r\n  justify-content: center;\r\n  transition: filter 100ms ease-in-out;\r\n}\r\n\r\n.video-step-button:hover {\r\n  filter: drop-shadow(0 0 25px var(--student-color-mid));\r\n}\r\n\r\n.video-step-button:hover .circle {\r\n  fill: var(--student-color-mid) !important;\r\n  fill-opacity: 0.125;\r\n}\r\n\r\n.video-step-button.playing {\r\n  filter: drop-shadow(0 0 25px var(--student-color-value));\r\n}\r\n\r\n.video-step-button.playing .circle {\r\n  fill: var(--student-color-value) !important;\r\n  fill-opacity: 0.5;\r\n  stroke: var(--student-color-value) !important;\r\n  stroke-opacity: 0.5;\r\n}\r\n\r\n.video-step-button.paused {\r\n  filter: drop-shadow(0 0 15px var(--student-color-mid));\r\n}\r\n\r\n/* A step's progress bar can be pressed to play from that point, over what has been played. */\r\n.video-step:not(.locked) .video-step-bar,\r\n.video-step:not(.locked) .video-step-progress-bar {\r\n  cursor: pointer;\r\n}\r\n\r\n.video-step-button.paused .circle {\r\n  fill: var(--student-color-mid) !important;\r\n  fill-opacity: 0.3;\r\n}\r\n\r\n.video-step-button.paused:hover .video-step-label {\r\n  opacity: 0;\r\n}\r\n\r\n.video-step-button.paused:hover::after {\r\n  content: '';\r\n  position: absolute;\r\n  background-image: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M8 6v14l14-7z\" fill=\"rgb(10, 9, 9)\"/><path d=\"M7 5v14l14-7z\" fill=\"rgb(250, 225, 225)\"/></svg>');\r\n  background-size: 13px 13px;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  height: 13px;\r\n  width: 13px;\r\n  pointer-events: none;\r\n}\r\n\r\n.video-step-button.loading {\r\n  animation: video-load-pulse 1.5s infinite;\r\n}\r\n\r\n@keyframes video-load-pulse {\r\n  0%, 100% {\r\n    filter: drop-shadow(0 0 8px var(--student-color-mid));\r\n  }\r\n  50% {\r\n    filter: drop-shadow(0 0 20px var(--student-color-value));\r\n  }\r\n}\r\n\r\n.video-step-button.initial-emphasis {\r\n  animation: video-initial-emphasis 1.5s infinite;\r\n}\r\n\r\n@keyframes video-initial-emphasis {\r\n  0%, 100% {\r\n    filter: drop-shadow(0 0 20px var(--student-color-value)) drop-shadow(0 0 10px var(--student-color-value));\r\n  }\r\n  50% {\r\n    filter: drop-shadow(0 0 40px var(--student-color-value)) drop-shadow(0 0 20px var(--student-color-value));\r\n  }\r\n}\r\n\r\n/* Show play icon when hovering over non-playing, non-paused steps */\r\n.video-step-button:not(.playing):not(.paused):not(.initial-emphasis):hover .video-step-label {\r\n  opacity: 0;\r\n}\r\n\r\n.video-step-button:not(.playing):not(.paused):not(.initial-emphasis):hover::after {\r\n  content: '';\r\n  position: absolute;\r\n  background-image: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M8 6v14l14-7z\" fill=\"rgb(10, 9, 9)\"/><path d=\"M7 5v14l14-7z\" fill=\"rgb(250, 225, 225)\"/></svg>');\r\n  background-size: 13px 13px;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  height: 13px;\r\n  width: 13px;\r\n  pointer-events: none;\r\n}\r\n\r\n.video-step-label {\r\n  font-size: 12px;\r\n  pointer-events: none;\r\n  position: absolute;\r\n}\r\n\r\n.video-step-label svg {\r\n  height: 13px !important;\r\n  padding: 2px 0 0 1px;\r\n  width: 13px !important;\r\n}\r\n\r\n.video-step-left svg {\r\n  height: 32px;\r\n  width: 32px;\r\n}\r\n/* #endregion */\r\n/* #region .toolbar */\r\n.toolbar {\r\n  align-items: center;\r\n  backdrop-filter: blur(10px);\r\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.1) -100%, rgba(20, 18, 18, 0.65) 200%);\r\n  background-color: rgb(55, 50, 50, 0.5);\r\n  border: none;\r\n  box-sizing: border-box; \r\n  color: rgb(250, 225, 225);\r\n  display: inline-flex;\r\n  font-family: Archivo, sans-serif;\r\n  font-size: 16px;\r\n  font-stretch: 95%;\r\n  height: 36px;\r\n  left: 0px;\r\n  letter-spacing: 0.025em;\r\n  padding: 1.5px 3px 2px 3px;\r\n  position: fixed;\r\n  top: 0px;\r\n  transition: background-color 100ms ease-in-out, border-bottom 100ms ease-in-out, box-shadow 100ms ease-in-out;\r\n  width: 100%;\r\n  z-index: 1;\r\n}\r\n\r\n.toolbar button {\r\n  outline: none;\r\n}\r\n\r\n.toolbar-center {\r\n  align-items: center;\r\n  display: flex;\r\n  flex: 1 0;\r\n  font-family: Archivo, sans-serif;\r\n  font-size: 13px;\r\n  font-stretch: 75%;\r\n  height: 30px;\r\n  justify-content: center;\r\n  letter-spacing: 0.025em;\r\n  margin: 0px 3px;\r\n  overflow: hidden;\r\n  padding-bottom: 1px;\r\n  text-align: center;\r\n  text-transform: uppercase;\r\n}\r\n\r\n#toolbar-close-button {\r\n  opacity: 0.5;\r\n  width: 50px;\r\n}\r\n\r\n#toolbar-close-button svg {\r\n  height: 15px;\r\n  padding-top: 0.5px;\r\n  width: 15px;\r\n}\r\n\r\n#toolbar-galaxy-button, #toolbar-sound-button {\r\n  display: none;\r\n}\r\n\r\n.toolbar-left, .toolbar-right {\r\n  display: flex;\r\n  flex: 0 1;\r\n}\r\n\r\n/* Accumulated reward/damage boxes must CLIP, not shove the close button off-screen: pin the right\r\n   cluster so it never shrinks, let the left cluster shrink + hide its overflow, and keep the points\r\n   counter itself pinned so only the boxes clip. */\r\n.toolbar-left {\r\n  flex: 0 1 auto; /* content-sized basis (NOT 0%), so it stays visible; only shrinks under overflow */\r\n  min-width: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n/* When reward/damage boxes are present, fade the right edge so a clipped box trails off softly instead of\r\n   a hard cut. :has() scopes it so the bare score (no boxes) is never faded. toolbar-left grows to fill the\r\n   bar (and toolbar-center yields its grow) so the fade sits at a FIXED right edge — over empty trailing\r\n   space when the boxes fit (invisible), over the clipped box only when they overflow — never on the last\r\n   box itself. */\r\n.toolbar-left:has(.toolbar-score-update-span) {\r\n  flex-grow: 1;\r\n  -webkit-mask-image: linear-gradient(to right, #000 calc(100% - 20px), transparent);\r\n  mask-image: linear-gradient(to right, #000 calc(100% - 20px), transparent);\r\n}\r\n.toolbar:has(.toolbar-score-update-span) .toolbar-center {\r\n  flex-grow: 0;\r\n}\r\n.toolbar-right {\r\n  flex-shrink: 0;\r\n}\r\n#toolbar-score {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.toolbar.help.student .toolbar-center:hover #toolbar-number-box, .toolbar-right {\r\n  display: flex;\r\n}\r\n\r\n#toolbar-help-span {\r\n  display: none;\r\n  color: rgb(250, 225, 225);\r\n  overflow: hidden;\r\n  text-shadow: 0.05vmin 0.05vmin var(--student-color-dark);\r\n  white-space: nowrap;\r\n}\r\n\r\n#toolbar-navigation {\r\n  display: flex;\r\n  font-family: Archivo, sans-serif;\r\n  font-size: 12px;\r\n  font-stretch: 95%;\r\n  letter-spacing: 0.025em;\r\n  padding: 5px;\r\n}\r\n\r\n#toolbar-navigation button {\r\n  background-color: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  height: 26px;\r\n  padding: 6px;\r\n  width: 26px;\r\n}\r\n\r\n.toolbar-right button {\r\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) -300%, rgba(20, 18, 18, 0.5) 300%);\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  height: 30px;\r\n  margin-left: 3px;\r\n  padding: 7px 7px 7px 7.5px;\r\n  width: 30px;\r\n}\r\n\r\n#toolbar-score, .toolbar-score-update-span {\r\n  align-items: center;\r\n  background: linear-gradient(to bottom, rgba(200, 180, 180, 0.4) -100%, rgba(50, 45, 45, 0.4) 125%);\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  font-size: 12px;\r\n  font-weight: 550;\r\n  height: 30px;\r\n  letter-spacing: 0.025em;\r\n  margin: 0px 3px 0px 3px;\r\n  padding: 6px 8px 7px 4px;\r\n  text-shadow: 0.05vmin 0.05vmin rgba(10, 9, 9, 0.5);\r\n}\r\n\r\n#toolbar-score-unit {\r\n  display: flex;\r\n}\r\n\r\n#toolbar-score-unit svg {\r\n  height: 11px;\r\n  padding: 1px;\r\n  width: auto;\r\n}\r\n\r\n/* Offline mode: hide / disable UI that doesn't make sense without a session.\r\n   The `offline` class is applied to <html> by bootOffline() — anything scoped\r\n   under it only renders when the URL hash is `#offline`. */\r\n\r\n/* Hide score, toolbox, notes button, chart panel (Stats/Rankings/Join) —\r\n   nothing persists past the session and there's no teacher dashboard to\r\n   receive interactions. The .toolbar prefix on the notes-button selector\r\n   matches the specificity of the existing `.toolbar.slide #toolbar-notes-button\r\n   { display: block }` rule in app.css that would otherwise override us. */\r\nhtml.offline #toolbar-score,\r\nhtml.offline #toolbar-score-update,\r\nhtml.offline .toolbar-score-update-span,\r\nhtml.offline .toolbox,\r\nhtml.offline .toolbar #toolbar-scaffold-button,\r\nhtml.offline #chart-div {\r\n  display: none;\r\n}\r\n\r\n/* Nametag — non-interactive in offline (no avatar / friends / panel to open). */\r\nhtml.offline .nametag {\r\n  cursor: default;\r\n}\r\n\r\n/* Board panel: hide Video, Facts, record-stop entirely in offline mode —\r\n   they depend on write-back / network machinery that doesn't run here.\r\n   Only Instructions remains; when the slide has no instructions content\r\n   (panel.js sets `disabled`), de-emphasize it visually. */\r\nhtml.offline #video-button,\r\nhtml.offline #facts-button,\r\nhtml.offline #record-stop-button {\r\n  display: none;\r\n}\r\nhtml.offline #instructions-button:disabled {\r\n  cursor: default;\r\n  pointer-events: none;\r\n}\r\nhtml.offline #instructions-button:disabled span,\r\nhtml.offline #instructions-button:disabled svg {\r\n  opacity: 0.25;\r\n}\r\n/* With the side buttons hidden, collapse the now-empty header-left/right\r\n   and let header-center (which holds Instructions) fill the panel width. */\r\nhtml.offline #board-div .header-left,\r\nhtml.offline #board-div .header-right {\r\n  display: none;\r\n}\r\nhtml.offline #board-div .header-center {\r\n  flex: 1;\r\n}\r\n\r\n#toolbar-score-update {\r\n  display: flex;\r\n  flex-direction: row;\r\n  min-width: 0;\r\n  /* Clip horizontal squeeze only — plain `overflow: hidden` also clipped the\r\n     bonus-detail popup, which hangs below the span at top: 125%. */\r\n  overflow-x: clip;\r\n  overflow-y: visible;\r\n}\r\n\r\n.toolbar-score-update-popup {\r\n  background: linear-gradient(to bottom, rgb(40, 40, 40) -100%, rgba(20, 20, 20) 125%);\r\n  border: 1px solid rgb(30, 30, 30);\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  left: 50%;\r\n  line-height: 14px;\r\n  padding: 3px 6px 5px 6px;\r\n  position: absolute;\r\n  text-shadow: 0.05vmin 0.05vmin rgba(10, 10, 10);\r\n  top: 125%;\r\n  transform: translateX(-50%);\r\n  width: max-content;\r\n}\r\n\r\n.toolbar-score-update-popup::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: 100%;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 6px solid transparent;\r\n  border-right: 6px solid transparent;\r\n  border-bottom: 6px solid rgb(30, 30, 30); /* Match the bubble's background color */\r\n}\r\n\r\n.toolbar-score-update-popup b {\r\n  font-weight: 750;\r\n}\r\n\r\n.toolbar-score-update-span {\r\n  background: linear-gradient(to bottom, rgba(200, 180, 180, 0.3) -100%, rgba(50, 45, 45, 0.5) 125%);\r\n  filter: saturate(2);\r\n  margin: 0px 3px 0px 0px;\r\n  padding: 6px 7px 7px 7px;\r\n  position: relative;\r\n  transition: opacity 750ms ease-in-out;\r\n}\r\n\r\n.toolbar-score-update-span.correct {\r\n  background-color: rgb(34, 77, 41);\r\n}\r\n\r\n.toolbar-score-update-span.correct .toolbar-score-update-popup {\r\n  color: rgb(73, 166, 88);\r\n}\r\n\r\n.toolbar-score-update-span.damage {\r\n  background-color: rgb(77, 19, 19, 0.625);\r\n}\r\n\r\n.toolbar-score-update-span.expense {\r\n  background-color: rgba(25, 23, 25, 0.25);\r\n}\r\n\r\n.toolbar-score-update-span.fairy {\r\n  background-color: rgba(255, 128, 191, 0.25);\r\n}\r\n\r\n.toolbar-score-update-span.reward {\r\n  background-color: rgba(255, 172, 51, 0.25);\r\n}\r\n\r\n.toolbar-score-update-span.reward .toolbar-score-update-popup {\r\n  color: rgb(255, 172, 51);\r\n}\r\n\r\n#toolbar-title {\r\n  display: none;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  width: 100%;\r\n}\r\n/* #endregion */\r\n/* #region .toolbox */\r\n.toolbox {\r\n  bottom: 3px;\r\n  bottom: calc(env(safe-area-inset-bottom) + 3px);\r\n  display: flex;\r\n  max-width: 100vmin;\r\n  opacity: 1;\r\n  position: fixed;\r\n  transition: opacity 250ms ease-in-out;\r\n  /* Ten 32px buttons (see --b below): 10 x 32 + 58px of padding and margins. */\r\n  width: 378px;\r\n  /* Above every panel (.visible is 2), so a tool's options row is never under the expanded\r\n     notepad, whichever was added to the slide last (user directive, Oct 2026). */\r\n  z-index: 3;\r\n}\r\n\r\n.slide-div.video .toolbox:not(:hover) {\r\n  opacity: 0.25;\r\n}\r\n\r\n/* Two 32px buttons (emote, controller), 4px apart, inside the section's 4px padding: the lesson\r\n   toolbox's button size, so the two match (they went from 35.8px together, Oct 2026). */\r\n.toolbox.game {\r\n  width: 76px;\r\n}\r\n\r\n#toolbox-control-section {\r\n  grid-template-columns: 1fr 1fr;\r\n}\r\n\r\n/* The emote row: the lesson subtoolbox's 24px buttons, centred on the emote button\r\n   (4px padding + half of 32px from the toolbox's left edge). */\r\n.toolbox.game .subtoolbox {\r\n  left: 20px;\r\n  transform: translateX(-50%);\r\n  width: calc(var(--count) * 24px + (var(--count) - 1) * 4px);\r\n}\r\n\r\n/* Bigger emotes in the same buttons (user request, Sep 2026): the padding gives way so the\r\n   13-unit pixel icon draws at 19.5px, exactly 1.5px a pixel (3 device px at 2x) where the\r\n   lesson padding left it at an uneven 1.12. The buttons, and so the row's centring above the\r\n   emote button, are unchanged. (24px buttons since Oct 2026: the padding is what keeps the icon\r\n   at 19.5px, (24 - 19.5) / 2.) */\r\n.toolbox.game .subtoolbox button {\r\n  padding: 2.25px;\r\n}\r\n\r\nhtml.dash.student .toolbox {\r\n  opacity: 0.5;\r\n}\r\n\r\nhtml.dash.student .toolbox:hover {\r\n  opacity: 1;\r\n}\r\n\r\n.toolbox button {\r\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) -300%, rgba(20, 18, 18, 0.3) 300%);\r\n  border: none;\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n  cursor: pointer;\r\n  display: flex;\r\n  outline: none;\r\n  padding: 7px;\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n}\r\n\r\n.toolbox button.selected {\r\n  background: linear-gradient(to bottom, rgba(200, 180, 180, 0.4) -100%, rgba(50, 45, 45, 0.4) 125%);\r\n}\r\n\r\n.toolbox.game button.selected {\r\n  background: linear-gradient(to bottom, rgba(200, 180, 180, 0.2) -100%, rgba(50, 45, 45, 0.2) 125%);\r\n}\r\n\r\n.toolbox button svg {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n/* Ten buttons: undo and redo, the five drawing tools, and the calculator, chart and notes (notes\r\n   joined in Oct 2026; the buttons went from 35.8px to 32px to make room, user pick). With --b one button, the sections hold 2b + 4px, 5b + 16px\r\n   and 3b + 8px; with their 8px of padding each and the two 3px margins that is 10b + 58px, the\r\n   whole toolbox, so b is (100% - 58px) / 10 of it. Sized exactly rather than by flex bases, so every\r\n   button is the same width at any toolbox width. */\r\n.toolbox {\r\n  --b: calc((100% - 58px) / 10);\r\n}\r\n\r\n#toolbox-command-section {\r\n  flex: none;\r\n  grid-template-columns: 1fr 1fr;\r\n  margin-right: 3px;\r\n  width: calc(var(--b) * 2 + 4px);\r\n}\r\n\r\n#toolbox-draw-section {\r\n  flex: none;\r\n  grid-template-columns: repeat(5, 1fr);\r\n  margin-right: 3px;\r\n  width: calc(var(--b) * 5 + 16px);\r\n}\r\n\r\n#toolbox-math-section {\r\n  flex: none;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  width: calc(var(--b) * 3 + 8px);\r\n}\r\n\r\n.toolbox-section {\r\n  backdrop-filter: blur(10px);\r\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.1) -100%, rgba(20, 18, 18, 0.5) 200%);\r\n  border-radius: 4px;\r\n  display: grid;\r\n  gap: 4px;\r\n  padding: 4px;\r\n}\r\n\r\n/* A tool's options: a row of 2/3-size toolbox buttons sitting 3px above the toolbox, centred on\r\n   its tool's button (user directive, Sep 2026; it was left-aligned with the draw section). With\r\n   --b one button (see #toolbox-command-section), the draw section starts after the command\r\n   section's 2b + 12px and its 3px margin, and its buttons after its own 4px padding, 4px apart:\r\n   button --index is centred at 2.5b + 19px + index * (b + 4px). Three quarters of b per option\r\n   button, 24px at the full 32px (half was too small, then two thirds, 21.33px, raised to 24px on\r\n   request, Oct 2026), plus this row's 4px gaps, is the content width below, and the\r\n   row's full width (plus its 8px of padding) halved comes off that centre. The option padding is\r\n   4px (it was 2/3 of 7px; trimmed so the icons are a little bigger in the same buttons, user\r\n   directive Oct 2026). */\r\n.subtoolbox {\r\n  bottom: calc(100% + 3px);\r\n  display: none;\r\n  grid-template-columns: repeat(var(--count), 1fr);\r\n  left: calc(var(--b) * 2.5 + 19px + var(--index, 0) * (var(--b) + 4px) - (var(--count) * (var(--b) * 3 / 4 + 4px) + 4px) / 2);\r\n  position: absolute;\r\n  width: calc(var(--count) * (var(--b) * 3 / 4 + 4px) - 4px);\r\n}\r\n\r\n.subtoolbox.visible {\r\n  display: grid;\r\n}\r\n\r\n.subtoolbox button {\r\n  padding: 4px;\r\n}\r\n\r\n/* An eraser option: the eraser icon with the tool's icon over it at FULL size, MIRRORED so it\r\n   points northeast and the two cross (the eraser runs northwest). A smaller icon on the eraser's\r\n   face was too small to make out, and a quarter turn was replaced by the mirror (user choice).\r\n   The T is symmetrical, so it stays upright. */\r\n.subtoolbox-stack {\r\n  display: block;\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n/* Block, so no inline descender gap stretches the stack taller than the square icon. */\r\n.subtoolbox-stack svg {\r\n  display: block;\r\n}\r\n\r\n.subtoolbox-overlay {\r\n  inset: 0;\r\n  position: absolute;\r\n  transform: scaleX(-1);\r\n}\r\n/* #endregion */\r\n/* #region index.js */\r\nbody {\r\n  align-items: center;\r\n  background: linear-gradient(33deg, #211a1e 0%, #19211e 100%);\r\n  background-color: rgb(30, 27, 27);\r\n  display: flex;\r\n  justify-content: center;\r\n  margin: 0px auto;\r\n  transition: background-color 350ms ease-in-out;\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n}\r\n\r\n/* #region .audio-button */\r\n.audio-button {\r\n  /* Match the active-button gradient shape (same one used by\r\n     `.toolbag-button.active`) but driven by the student color scheme\r\n     rather than the toolbag palette — brighter, better contrast against\r\n     the narration-outline, and consistent with other per-student\r\n     activated surfaces across the slide. */\r\n  background: linear-gradient(var(--student-color-mid) -150%, var(--student-color-dark) 125%);\r\n  border: none;\r\n  border-radius: 4px 0 4px 0;\r\n  box-sizing: border-box;\r\n  cursor: pointer;\r\n  display: flex;\r\n  height: 26px;\r\n  /* Semi-transparent so if the button happens to sit over a bit of text\r\n     (top-left of a tightly-packed text block), the text remains readable\r\n     underneath. Full opacity on hover/focus so it's clear when active. */\r\n  opacity: 0.5;\r\n  outline: none;\r\n  padding: 5px;\r\n  pointer-events: auto;\r\n  position: absolute;\r\n  transition: opacity 150ms ease-in-out;\r\n  width: 26px;\r\n  z-index: 6;\r\n}\r\n\r\n.audio-button:hover,\r\n.audio-button:focus-visible {\r\n  opacity: 1;\r\n}\r\n\r\n.audio-button svg {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.audio-button svg path {\r\n  fill: rgb(250, 225, 225) !important;\r\n  stroke: none;\r\n}\r\n\r\nhtml.dash:not(.focused-session) .audio-button {\r\n  display: none;\r\n}\r\n\r\n/* Mobile's `.canvas-div` gets `transform: scale(2)` to enlarge slide content\r\n   (index.css:165). Everything nested inside — including the audio button —\r\n   inherits that 2× scale. Counter-scale from the top-left so the button\r\n   renders at its intended 24px size while staying pinned to the text-div's\r\n   top-left corner where we placed it. */\r\nhtml.mobile .audio-button {\r\n  transform: scale(0.5);\r\n  transform-origin: top left;\r\n}\r\n\r\n/* Gentle semi-transparent outline around any .text-div that has an audio\r\n   button, so the teacher can see exactly which block the narration covers.\r\n   `outline` (with offset) sits 3px outside the text-div without taking\r\n   layout space — unlike a border it doesn't add width/height/padding.\r\n   Hidden in unfocused dash tiles to match .audio-button. */\r\n/* Narration outline — unified overlay system. slide.js inserts a\r\n   .narration-outline absolutely-positioned sibling of the narrated text-div(s)\r\n   inside .content-div and sizes it imperatively from their offset rects.\r\n   Works for solo (wraps one text-div) and merged text0+text1 (wraps both).\r\n   Text-divs themselves carry no narration class, so their per-problem\r\n   margins/layout are never touched. */\r\n.narration-outline {\r\n  border-radius: 2px;\r\n  outline: 1px solid color-mix(in srgb, var(--student-color-mid) 50%, transparent);\r\n  outline-offset: 3px;\r\n  pointer-events: none;\r\n  position: absolute;\r\n}\r\n\r\n/* Short outlines (≤ 20px tall) — typical for single-line narrated\r\n   text — can't fully contain the 26px audio button. The .compact\r\n   class is toggled on the button by the narration positioner in\r\n   slide.js based on the measured outline height. Round the LEFT side\r\n   of the button so it reads as a tab extending left from the narration\r\n   region rather than an overflowing diamond. */\r\n.audio-button.compact {\r\n  border-radius: 4px 0 0 4px;\r\n}\r\n\r\nhtml.dash:not(.focused-session) .narration-outline {\r\n  outline: none;\r\n}\r\n\r\n.text-div {\r\n  position: relative;\r\n}\r\n/* #endregion */\r\n\r\n#body {\r\n  align-items: center;\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: calc(100% - 50px);\r\n  justify-content: center;\r\n}\r\n\r\nbutton:disabled {\r\n  opacity: 0.25 !important;\r\n  pointer-events: none !important;\r\n}\r\n\r\nbutton * {\r\n  pointer-events: none !important;\r\n}\r\n\r\n.color-button {\r\n  background-clip: content-box;\r\n  background-size: cover;\r\n  box-shadow: 0.05vmin 0.05vmin rgba(10, 9, 9, 0.5) !important;\r\n  color: rgb(250, 225, 225);\r\n  font-size: 12.5px !important;\r\n  opacity: 0.75;\r\n  padding: 0px !important;\r\n  text-shadow: 0.125vmin 0.125vmin rgba(10, 9, 9, 0.5);\r\n  width: 72px;\r\n}\r\n\r\n[contenteditable] {\r\n  user-select: text;\r\n  -webkit-user-select: text;\r\n}\r\n\r\n.email-input, .name-input, .password-input {\r\n  margin-bottom: 6px;\r\n  width: 100%;\r\n}\r\n\r\n.emoji-button {\r\n  height: 40.75px !important;\r\n  padding: 6px !important;\r\n  width: 40.75px;\r\n}\r\n\r\n.emoji-button svg {\r\n  height: 28.75px;\r\n  width: 28.75px;\r\n}\r\n\r\n#emoji-table {\r\n  display: none;\r\n}\r\n\r\n#emoji-table button[disabled] svg {\r\n  opacity: 0;\r\n}\r\n\r\n#footer {\r\n  align-items: center;\r\n  bottom: 0px;\r\n  bottom: env(safe-area-inset-bottom);\r\n  color: rgba(250, 225, 225, 0.5);\r\n  display: flex;\r\n  flex-direction: column;\r\n  font-family: Archivo, sans-serif;\r\n  font-size: 13px;\r\n  font-stretch: 102%;\r\n  font-weight: 500;\r\n  left: 50%;\r\n  letter-spacing: 0.025em;\r\n  margin-bottom: 3px;\r\n  position: fixed;\r\n  transform: translateX(-50%);\r\n  transition: opacity 350ms ease-in-out;\r\n  width: 320px;\r\n  z-index: 0;\r\n}\r\n\r\n#footer-home-div {\r\n  text-align: center;\r\n}\r\n\r\n#footer-home-button {\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  width: 130px;\r\n}\r\n\r\n#footer-home-button:disabled {\r\n  opacity: 1 !important;\r\n}\r\n\r\n#footer-home-button path {\r\n  fill: rgba(220, 198, 198, 0.4);\r\n}\r\n\r\n#footer-home-button svg {\r\n  display: block;\r\n  height: 20px;\r\n  width: 130px;\r\n}\r\n\r\n.footer-button {\r\n  background-color: rgba(220, 198, 198, 0.325);\r\n  border: none;\r\n  border-radius: 4px;\r\n  color: rgb(10, 9, 9);\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  margin: 3px;\r\n  padding: 3px 7px;\r\n  transition: opacity 350ms ease-in-out;\r\n}\r\n\r\n.grade-separator {\r\n  border: 1px solid rgba(10, 9, 9, 0.2);\r\n}\r\n\r\n#header {\r\n  align-items: end;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  height: 160px;\r\n  padding-bottom: 6px;\r\n  position: fixed;\r\n  top: 6px;\r\n  transition: opacity 350ms ease-in-out;\r\n  width: 180px;\r\n  z-index: 0;\r\n}\r\n\r\n#header path {\r\n  fill: rgba(220, 198, 198, 0.4);\r\n}\r\n\r\n#home {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 90%;\r\n  width: 320px;\r\n}\r\n\r\n#home div.ui, #schedule div.ui {\r\n  display: block;\r\n  margin-top: 6px;\r\n  width: 320px;\r\n}\r\n\r\n#home .text {\r\n  font-size: 14px;\r\n  margin: -6px 0px 3px 0px;\r\n  text-align: center;\r\n}\r\n\r\n#home video {\r\n  border-radius: 4px;\r\n  box-shadow: 0.15vmin 0.15vmin rgba(10, 9, 9, 0.5)\r\n}\r\n\r\n#home-body {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  mask-image: linear-gradient(rgba(0, 0, 0, calc(1 - var(--scroll))) 0%, rgba(0, 0, 0, calc(0.75 * (1 / var(--scroll)))) 5%, rgba(0, 0, 0, 1) 10%, rgba(0, 0, 0, 1) 90%, rgba(0, 0, 0, calc(0.75 * (1 / (1 - var(--scroll))))) 95%, rgba(0, 0, 0, var(--scroll)) 100%);\r\n  overflow: scroll;\r\n}\r\n\r\n#home-button {\r\n  width: 100%;\r\n}\r\n\r\n#home-classes-div {\r\n  line-height: 17px;\r\n  padding: 6px;\r\n}\r\n\r\n#home-classes-div, #home-curriculum-div {\r\n  background-color: rgba(250, 225, 225, 0.05);\r\n  border: 2px solid rgba(115, 104, 104);\r\n  border-radius: 0px 4px 4px 4px;\r\n  box-sizing: border-box;\r\n  font-size: 14px;\r\n  text-align: center;\r\n  width: 100%;\r\n}\r\n\r\n#home-classes-tabs, #home-curriculum-tabs, #schedule-tabs {\r\n  display: flex;\r\n  margin-top: 3px;\r\n  width: 100%;\r\n}\r\n\r\n#home-classes-tabs button, #home-curriculum-tabs button, #schedule-tabs button {\r\n  background-color: transparent;\r\n  border-radius: 4px 3px 0 0;\r\n  color: rgb(10, 9, 9, 0.3);\r\n  font-size: 14px;\r\n  height: 30.6px;\r\n  margin-left: 0;\r\n  width: 100%;\r\n}\r\n\r\n#home-classes-tabs button.selected, #home-curriculum-tabs button.selected, #schedule-tabs button.selected {\r\n  background-color: rgb(10, 9, 9, 0.2);\r\n\tcolor: rgb(250, 225, 250);\r\n}\r\n\r\n#home-classes-tabs button:not(.selected):hover, #home-curriculum-tabs button:not(.selected):hover, #schedule-tabs button:not(.selected):hover {\r\n  background: rgba(135, 122, 122, 0.25);\r\n}\r\n\r\n#home-footer, #schedule-footer {\r\n  padding: 6px;\r\n  width: 320px;\r\n}\r\n\r\n#home-footer button, #schedule-footer button {\r\n  width: calc(50% - 3px);\r\n}\r\n\r\n#home-footer button:last-child, #schedule-footer button:last-child {\r\n  margin-left: 6px;\r\n}\r\n\r\n#home-video {\r\n  height: 180px;\r\n}\r\n\r\nhtml, body {\r\n  height: 100%;\r\n  overflow: hidden;\r\n  width: 100%;\r\n}\r\n\r\nhtml.teacher .app-div *, html.teacher .toolbar * {\r\n  animation: none !important;\r\n}\r\n\r\n#page {\r\n  bottom: 0px;\r\n  bottom: env(safe-area-inset-bottom);\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: calc(100% - 3px);\r\n  height: calc(100% - env(safe-area-inset-top) - env(safe-area-inset-bottom));\r\n  position: fixed;\r\n}\r\n\r\n#page * {\r\n  touch-action: pan-y;\r\n}\r\n\r\n#privacy-policy {\r\n  height: 600px;\r\n  overflow: scroll;\r\n  position: fixed;\r\n  width: 600px;\r\n  z-index: 1;\r\n}\r\n\r\n@keyframes raindrop {\r\n  0% {\r\n    transform: translateY(-50px);\r\n  }\r\n  100% {\r\n    transform: translateY(calc(100vh + 50px));\r\n  }\r\n}\r\n\r\n.raindrop {\r\n  animation: raindrop linear infinite;\r\n  color: #ffc44d;\r\n  font-family: Archivo, sans-serif;\r\n  font-size: 36px;\r\n  font-stretch: 75%;\r\n  font-weight: bold;\r\n  opacity: 0;\r\n  position: fixed;\r\n  text-shadow: 0.125vmin 0.125vmin rgba(10, 9, 9, 0.5);\r\n  top: -50px;\r\n  transition: opacity 500ms ease-in-out;\r\n}\r\n\r\n.song-entry.active {\r\n  background-color: var(--student-color-darker) !important;\r\n}\r\n\r\n.song-entry.active .song-button {\r\n  background-color: var(--student-color-value);\r\n  filter: drop-shadow(0 0 25px var(--student-color-value));\r\n}\r\n\r\n.song-entry-left svg {\r\n  height: 22px;\r\n  width: 22px;\r\n}\r\n\r\n.song-entry-name-span {\r\n  width: 100%;\r\n}\r\n\r\n.song-entry-right-bottom {\r\n  font-size: 12px;\r\n  line-height: 14px;\r\n  margin-top: 2px;\r\n}\r\n\r\n.song-locked-overlay {\r\n  align-items: center;\r\n  backdrop-filter: blur(2px);\r\n  background: rgba(50, 45, 45, 0.75);\r\n  border-radius: 4px;\r\n  bottom: 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  left: 0;\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n}\r\n\r\n.song-locked-content {\r\n  align-items: center;\r\n  color: rgb(250, 225, 225);\r\n  display: flex;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  gap: 2px;\r\n  text-shadow: 0.125vmin 0.125vmin rgba(10, 9, 9, 0.5);\r\n}\r\n\r\n.song-locked-fairy-canvas {\r\n  height: 22px;\r\n  image-rendering: pixelated;\r\n  width: 32px;\r\n}\r\n\r\n#sound-settings {\r\n  left: 50%;\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 280px;\r\n}\r\n\r\n/* Rows as in the dashboard's student settings (dash.css .settings-row): a fixed label\r\n   column and the control filling the rest. */\r\n.sound-setting-row {\r\n  align-items: center;\r\n  display: flex;\r\n  flex-basis: 100%;\r\n  gap: 8px;\r\n  height: 38px;\r\n}\r\n\r\n.sound-setting-label {\r\n  flex: 0 0 100px;\r\n  font-size: 14px;\r\n  text-align: left;\r\n}\r\n\r\n/* The volume control is shaped like the settings text boxes (32px, 4px radius), filled\r\n   to the volume in the darker warm grey over the lighter one, percentage centred on top. */\r\n.sound-setting-bar {\r\n  flex: 1 1 0;\r\n  height: 32px;\r\n  min-width: 0;\r\n  position: relative;\r\n}\r\n\r\n.sound-setting-value {\r\n  align-items: center;\r\n  color: rgb(250, 225, 225);\r\n  display: flex;\r\n  font-size: 14px;\r\n  inset: 0;\r\n  justify-content: center;\r\n  pointer-events: none;\r\n  position: absolute;\r\n}\r\n\r\n/* Beats `.ui input` (index.css), which would make the slider a 42px text field. */\r\n#sound-settings input.sound-setting-slider {\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  background: linear-gradient(to right, rgb(114, 103, 103) var(--fill, 0%), rgb(160, 144, 144) var(--fill, 0%));\r\n  border: 1px solid rgb(114, 103, 103);\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  display: block;\r\n  height: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 100%;\r\n}\r\n\r\n/* No knob: the edge of the fill is the position. */\r\n#sound-settings input.sound-setting-slider::-webkit-slider-thumb {\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  background: transparent;\r\n  height: 30px;\r\n  width: 1px;\r\n}\r\n\r\n#sound-settings input.sound-setting-slider::-moz-range-thumb {\r\n  background: transparent;\r\n  border: none;\r\n  height: 30px;\r\n  width: 1px;\r\n}\r\n\r\n.star {\r\n  position: fixed;\r\n}\r\n\r\n.star.twinkling, .power-background-star.twinkling {\r\n  animation: star-pulse 6000ms infinite;\r\n  transition: opacity 500ms ease-in-out;\r\n}\r\n\r\n@keyframes star-pulse {\r\n  0% {\r\n    filter: brightness(1);\r\n  }\r\n\r\n  50% {\r\n    filter: brightness(1.25) drop-shadow(0 0 var(--glow-size, 50px) rgba(255, 225, 225, 0.75));\r\n  }\r\n\r\n  100% {\r\n    filter: brightness(1);\r\n  }\r\n}\r\n\r\n.star-pulse {\r\n  animation: star-pulse 625ms 1;\r\n}\r\n\r\n.points-pulsing {\r\n  animation: star-pulse 625ms infinite;\r\n}\r\n\r\ntable {\r\n  border-collapse: collapse;\r\n}\r\n\r\n.back-button {\r\n  flex-basis: calc(50% - 3px);\r\n  margin: 6px 6px 0px 0px;\r\n}\r\n\r\n#holidays-link {\r\n  color: rgb(25, 22, 22);\r\n  cursor: pointer;\r\n  text-decoration: underline rgb(10, 9, 9) dashed;\r\n}\r\n\r\n.log-in-button {\r\n  flex-basis: 100%;\r\n}\r\n\r\n#name-input:focus::placeholder {\r\n  opacity: 0;\r\n}\r\n\r\n#name-input.error {\r\n  background-color: rgb(40, 36, 36);\r\n  margin: 0px;\r\n}\r\n\r\n#parent-form .log-in-button {\r\n  flex-basis: calc(50% - 3px);\r\n}\r\n\r\n#parent-register-form .email-input {\r\n  margin-top: 6px;\r\n}\r\n\r\n#parent-register-form .password-input {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.register-button {\r\n  flex-basis: calc(50% - 3px);\r\n  margin-top: 6px;\r\n}\r\n\r\n.register-form-button {\r\n  flex-basis: calc(50% - 3px);\r\n  margin: 0px 0px 0px 6px;\r\n}\r\n\r\n#schedule-form-button {\r\n  flex-basis: 100%;\r\n  margin-top: 6px;\r\n}\r\n\r\n.student-color-value {\r\n  fill: var(--student-color-value) !important;\r\n}\r\n\r\n.student-color-mid {\r\n  fill: var(--student-color-mid) !important;\r\n}\r\n\r\n.student-color-dark {\r\n  fill: var(--student-color-dark) !important;\r\n}\r\n\r\n#student-form, #parent-form, #parent-register-form, #schedule-body, #subscriptions-form, #teacher-form, #teacher-register-form {\r\n  margin-top: 54.29px;\r\n}\r\n\r\n#schedule-body button, #subscriptions-form button {\r\n  font-size: 14px;\r\n  font-stretch: 100%;\r\n  height: 36px;\r\n  width: 132px;\r\n}\r\n\r\n#schedule-body .grade-header {\r\n  background-color: rgba(250, 225, 225, 0.25);\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  font-weight: 650;\r\n  height: 28px;\r\n  padding: 2px;\r\n  width: 100%;\r\n}\r\n\r\n#schedule-body td {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  padding: 2px;\r\n  text-align: center;\r\n}\r\n\r\n#schedule-info-div, #schedule-info-div-2 {\r\n  font-size: 12px;\r\n  margin: -6px 0px 9px 0px;\r\n  text-align: center;\r\n  width: 100%;\r\n}\r\n\r\n#seats-div {\r\n  align-items: center;\r\n  background-color: rgba(250, 225, 225, 0.25);\r\n  border-radius: 4px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  font-size: 13px;\r\n  font-stretch: 90%;\r\n  height: 36px;\r\n  justify-content: center;\r\n  width: 28px;\r\n}\r\n\r\n#seats-div svg {\r\n  height: 8.5px;\r\n  margin-bottom: 1.5px;\r\n  width: 8.5px;\r\n}\r\n\r\n#sections-div {\r\n  background: rgba(250, 225, 225, 0.05);\r\n  border: 2px solid rgba(115, 104, 104);\r\n  padding: 2px;\r\n}\r\n\r\n.stop-button {\r\n  background-color: #a62121 !important;\r\n  font-size: 12px !important;\r\n  font-stretch: 80% !important;\r\n  height: 25px !important;\r\n  width: 40px !important;\r\n}\r\n\r\n#student-form .name-input {\r\n  margin-bottom: 6px;\r\n}\r\n\r\n/* Locked on the emoji step (setEmojiStep): the light informational box, dark text, no browser grey. */\r\n#student-form .name-input:disabled:not(.error) {\r\n  background-color: rgba(250, 225, 225, 0.25);\r\n  color: rgb(10, 9, 9);\r\n  -webkit-text-fill-color: rgb(10, 9, 9);\r\n}\r\n\r\n#student-form .name-note {\r\n  background: rgb(50, 45, 45);\r\n  border-radius: 4px;\r\n  color: rgb(250, 225, 225);\r\n  flex-basis: 100%;\r\n  font-size: 13px;\r\n  margin-bottom: 6px;\r\n  padding: 6px 10px;\r\n  text-align: center;\r\n}\r\n\r\n#subscriptions-div {\r\n  border: 3px solid rgba(10, 9, 9, 0.2);\r\n  border-radius: 3px;\r\n  font-size: 14px;\r\n  width: 100%;\r\n}\r\n\r\n#subscriptions-form {\r\n  width: 320px;\r\n}\r\n\r\n#subscriptions-table {\r\n  width: 100%;\r\n}\r\n\r\n#subscriptions-table td, #subscriptions-table td:first-child {\r\n  background-color: rgb(160, 144, 144);\r\n  height: 20px;\r\n  padding: 3px 6px;\r\n  text-align: center;\r\n}\r\n\r\n#subscriptions-table td:last-child, #subscriptions-table th:last-child {\r\n  padding-bottom: 3px;\r\n  padding-right: 3px;\r\n  width: 0px;\r\n}\r\n\r\n#subscriptions-table th {\r\n  background-color: rgb(160, 144, 144);\r\n  border-bottom: 2px solid rgba(10, 9, 9 0.2);\r\n  padding: 6px;\r\n  text-align: center;\r\n}\r\n\r\n#subscriptions-table tr:not(:first-child) {\r\n  border-bottom: 1px solid rgb(135, 122, 122);\r\n}\r\n\r\n#subscriptions-table tr:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n#time-div {\r\n  align-items: center;\r\n  background-color: rgba(250, 225, 225, 0.25);\r\n  border-radius: 4px;\r\n  display: flex;\r\n  font-size: 13px;\r\n  font-stretch: 90%;\r\n  height: 36px;\r\n  justify-content: center;\r\n  width: 128px;\r\n}\r\n\r\n#topic-div {\r\n  background-color: rgba(250, 225, 225, 0.25);\r\n  border-radius: 4px;\r\n  font-size: 13px;\r\n  font-weight: 650;\r\n  padding: 6px;\r\n}\r\n\r\n#topics-table {\r\n  width: 100%;\r\n}\r\n\r\n#topics-table td, #topics-table td:first-child {\r\n  background-color: rgba(135, 122, 122, 0.25);\r\n  font-size: 14px;\r\n  height: 20px;\r\n  padding: 3px 0px;\r\n  text-align: center;\r\n}\r\n\r\n#topics-table tr:not(:last-child) {\r\n  border-bottom: 1px solid rgb(10, 9, 9, 0.2);\r\n}\r\n\r\n.void-pulsing {\r\n  animation: void-pulse 625ms infinite;\r\n}\r\n\r\n@keyframes void-pulse {\r\n  0% {\r\n    filter: brightness(1);\r\n  }\r\n\r\n  50% {\r\n    filter: brightness(0.75) drop-shadow(0 0 50px rgba(10, 9, 10, 0.5));\r\n  }\r\n\r\n  100% {\r\n    filter: brightness(1);\r\n  }\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n/* #endregion */\r\n/* #region script.js */\r\n/* Center the inner dialog box. Scoped to .dialog.ui specifically — the\r\n   .overlay backdrop also carries class=\"overlay dialog\" (used by event-target\r\n   selectors), and we must NOT translate it: it is pinned to the screen's\r\n   four edges already, so a translate(-50%, -50%) would shift its\r\n   bottom-right to ≈ viewport center and leave the top-left off-screen. */\r\n.dialog.ui {\r\n  left: 50%;\r\n  position: fixed;\r\n  top: 50%;\r\n  /* A dashboard tile shows a student's screen at its own size, so the dialog is scaled by the tile's\r\n     --session-scale like every panel (dash.js resizeSession); everywhere else the variable is unset. */\r\n  transform: translate(-50%, -50%) scale(var(--session-scale-x, 1), var(--session-scale-y, 1));\r\n}\r\n\r\n.dialog button {\r\n  flex-basis: 100%;\r\n}\r\n\r\n.dialog.option button {\r\n  flex-basis: calc(50% - 3px);\r\n}\r\n\r\n.dialog.option .dialog-yes-button {\r\n  margin-right: 6px;\r\n}\r\n\r\n/* Two options that are choices rather than yes and no (the rabbit's \"as soon as you can\" and\r\n   \"tomorrow\") stand in rows, the same 6px apart the side by side pair is. */\r\n.dialog.option.stack button {\r\n  flex-basis: 100%;\r\n}\r\n\r\n.dialog.option.stack .dialog-yes-button {\r\n  margin-bottom: 6px;\r\n  margin-right: 0;\r\n}\r\n\r\n/* The video generation dialog's two instruction boxes (script, annotation). Scoped under .ui to\r\n   outrank `.ui input, .ui select, .ui textarea` (0,1,1), which fixes every control at 42px. The\r\n   placeholder IS the label — there is no text outside the box — so it stays legible against the\r\n   beige field and does not vanish on focus the way #name-input's does. */\r\n.ui .video-prompt-input {\r\n  font-size: 15px;\r\n  height: 72px;\r\n  padding: 8px 6px;\r\n  resize: none;\r\n}\r\n\r\n.ui .video-prompt-input + .video-prompt-input {\r\n  margin-top: 6px;\r\n}\r\n\r\n.ui .video-prompt-input::placeholder {\r\n  color: rgb(140, 126, 126);\r\n  opacity: 1;\r\n}\r\n\r\n.dialog button svg {\r\n  height: 10px;\r\n  margin-right: 1px;\r\n  width: 10px;\r\n}\r\n\r\n.dialog-check {\r\n  align-items: center;\r\n  cursor: pointer;\r\n  display: flex;\r\n  flex-basis: 100%;\r\n  gap: 6px;\r\n  justify-content: center;\r\n  margin-top: 6px;\r\n  user-select: none;\r\n}\r\n\r\n/* Scoped under .ui to outrank `.ui input, .ui select, .ui textarea` (0,1,1),\r\n   which styles every dialog control as a full-width 42px text field. */\r\n.ui .dialog-checkbox {\r\n  accent-color: rgb(140, 126, 126);\r\n  background-color: transparent;\r\n  border: none;\r\n  border-radius: 0;\r\n  cursor: pointer;\r\n  flex: 0 0 auto;\r\n  height: 14px;\r\n  margin: 0;\r\n  padding: 0;\r\n  width: 14px;\r\n}\r\n\r\n.dialog-check-text {\r\n  font-size: 13px;\r\n}\r\n\r\n.dialog-progress-bar {\r\n  background: linear-gradient(to right, #73e6d2 -15%, #ff80bf 50%, #ffe666 115%);\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  height: 6px;\r\n  left: 0px;\r\n  max-width: 100%;\r\n  position: absolute;\r\n  top: 0px;\r\n}\r\n\r\n.dialog-progress-div {\r\n  background-color: rgba(100, 90, 100, 0.5);\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  margin-top: 6px;\r\n  position: relative;\r\n  height: 6px;\r\n  width: 268px;\r\n}\r\n\r\n.dialog-text {\r\n  flex-basis: 100%;\r\n  font-size: 14px;\r\n  margin-bottom: 6px;\r\n  overflow-y: scroll;\r\n  text-align: center;\r\n  transform: translateY(-4px);\r\n}\r\n\r\n/* A dialog with no button below the text - the locked-account block, \"Nothing noteworthy\",\r\n   any message-only dialog - was noticeably bottom-heavy. .dialog-text's 6px bottom margin\r\n   exists to separate it from a button, so with no button it is dead space stacked on the\r\n   dialog's own 6px bottom padding.\r\n   Measured on the locked dialog: 12.3px above the title glyphs, 16px below the body glyphs.\r\n   The excess is only 3.7px rather than the full 6, because .dialog-text's transform pulls\r\n   the glyphs up 4px and that lift is already part of the gap below them - so zeroing the\r\n   margin would overshoot to 10px and make the TOP read heavy instead. 2px lands it at 12px.\r\n   :last-child is the test for \"nothing follows the text\", which covers buttons, checkboxes\r\n   and inputs alike without enumerating them. */\r\n.dialog .dialog-text:last-child {\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.dialog-text span svg {\r\n  height: 10px;\r\n  margin-right: 1px;\r\n  width: auto;\r\n}\r\n\r\n.drag-bottom {\r\n  bottom: 0px;\r\n  height: 6px;\r\n  left: -0.5%;\r\n  position: absolute;\r\n  width: 101%;\r\n  z-index: 3;\r\n}\r\n\r\n.drag-top {\r\n  align-items: center;\r\n  background-position-x: center;\r\n  background-repeat: no-repeat;\r\n  border-radius: 8px 8px 0px 0px;\r\n  display: inline-flex;\r\n  height: 8px;\r\n  justify-content: center;\r\n  left: -0.5%;\r\n  position: absolute;\r\n  top: 0px;\r\n  width: 101%;\r\n}\r\n\r\n.drag-top svg {\r\n  height: 6px;\r\n  width: 6px;\r\n}\r\n\r\n.focused {\r\n  align-self: stretch !important;\r\n  aspect-ratio: auto !important;\r\n  grid-column-end: span 3;\r\n  grid-row-end: span 3;\r\n  max-height: none !important;\r\n  max-width: 100% !important;\r\n  overflow: hidden;\r\n}\r\n\r\n\r\n.green-pulse {\r\n  animation: green-pulse 120s 1;\r\n}\r\n\r\n/* Structural only: these two exist so the Facts and grade sections can rebuild from\r\n   independent listeners without one wiping the other's innerHTML. #chart-stats is a flex\r\n   container, so a plain div child becomes a flex ITEM and the rows stop filling the panel -\r\n   which pushed them in from both edges, away from the panel buttons above. display: contents\r\n   removes the wrappers from layout entirely, leaving the rows direct flex children exactly as\r\n   they were before the split, while CSS structural selectors (ul:last-child and friends) go\r\n   on matching against the DOM tree unchanged. */\r\n#chart-facts, #chart-notes, #chart-codes {\r\n  display: contents;\r\n}\r\n\r\n/* ...but the shared `#chart-stats ul:last-child li:last-child` rule zeroes the bottom margin\r\n   of the last row in EVERY ul, and with the sections split each wrapper now has its own last\r\n   ul - so the Facts section lost the 6px that separates it from the grade header below.\r\n   Restore it for any section that is not the final one in the panel. */\r\n#chart-stats > *:not(:last-child) ul:last-child li:last-child {\r\n  margin-bottom: 6px;\r\n}\r\n\r\n/* One extra pixel of headroom on the data rows. The shared `#chart-stats li` padding is 4px\r\n   top, which reads a touch tight above the label - so the top gap goes to 5px, matching the\r\n   5px on the left and right. Scoped to the chart's own rows so the shared rule (and the\r\n   friends panel that leans on it) is untouched, and :not(.panel-header) keeps the section\r\n   headers on their original spacing. */\r\n#chart-facts li:not(.panel-header),\r\n#chart-codes li:not(.panel-header) {\r\n  padding-top: 5px;\r\n}\r\n\r\n/* The next tier's payout, dressed as a REWARD rather than a plain figure. Gold, gradient and\r\n   saturate copied from the toolbar's reward span (.toolbar-score-update-span.reward) - the\r\n   two-declaration form matters: the shorthand sets the gradient as background-IMAGE and clears\r\n   the colour, then background-color paints the gold behind it, and saturate(2) is what gives\r\n   that gold its actual hue. Points read as points everywhere in the app, so the number uses the\r\n   score font rather than the row's condensed 75%: #toolbar-score computes to 95% stretch at\r\n   12px, MEASURED not assumed (it sets no font-stretch of its own and inherits it). Height\r\n   matches the friends panel's TELEPORT button, the other small chip that rides a row like this;\r\n   the box-shadow is the panel's small-element value, the same one the progress bars carry. */\r\n.task-reward {\r\n  align-items: center;\r\n  background: linear-gradient(to bottom, rgba(200, 180, 180, 0.4) -100%, rgba(50, 45, 45, 0.4) 125%);\r\n  background-color: rgba(255, 172, 51, 0.25);\r\n  border-radius: 4px;\r\n  box-shadow: 0.05vmin 0.05vmin rgb(10, 9, 9);\r\n  display: flex;\r\n  filter: saturate(2);\r\n  font-size: 12px;\r\n  font-stretch: 95%;\r\n  font-weight: 550;\r\n  height: 15.5px;\r\n  letter-spacing: 0.025em;\r\n  padding: 0 4px 0 2px;\r\n  text-shadow: 0.05vmin 0.05vmin rgba(10, 9, 9, 0.5);\r\n}\r\n\r\n/* The MASTERY row's chip: the toolbar's correct-answer green (its span's background), not the\r\n   reward gold — the tier bonus multiplies fact points, never rewards (user directive, Sep 2026). */\r\n.task-reward.task-bonus {\r\n  background-color: rgb(34, 77, 41);\r\n}\r\n\r\n/* The plus sign's ink centre sits 0.75px below the digits' (measured with canvas\r\n   actualBoundingBox at the chip's own font: + is 7px tall on the baseline, the digits 9 over 1),\r\n   so it is lifted by that much to read as centred on the number. */\r\n.task-bonus .task-bonus-plus {\r\n  /* …plus the height of the chip's text shadow (0.05vmin, the same measure the shadow uses),\r\n     which reads as weight under the glyph and made the measured centre still look low. */\r\n  transform: translateY(calc(-0.75px - 0.05vmin));\r\n}\r\n\r\n/* The Notes rows' chip: what mastering the tier heals the note's fairy by, behind a white cross. Its\r\n   background is that fairy's health bar gradient, set inline per row (panel.js NOTE_SHADE); it was the\r\n   song-completion rainbow until the user asked for each fairy's own colour (Oct 2026). */\r\n.task-reward.task-heal {\r\n  filter: none;\r\n  /* The row's tier caption is an absolutely placed span across the whole row (panel.js taskRow), so it\r\n     paints over any chip that is not itself lifted. The other chips are lifted by their saturate()\r\n     filter (a filter paints in the positioned layer); without one, this chip sat under the caption\r\n     and its tooltip never showed. */\r\n  position: relative;\r\n}\r\n\r\n.task-reward svg {\r\n  height: 10px;\r\n  padding: 1px;\r\n  width: auto;\r\n}\r\n\r\n/* The completion flash inside a Facts row, matching the fact box's own \"Correct!\" exactly\r\n   (#fact-question plus its icon rule) so the two celebrations read as the same event: Archivo\r\n   16px/650 at 100% stretch, the hard 1px shadow, and a 16px icon with 4.5px of gap. No amount\r\n   here on purpose - the points land in the toolbar span like any other award, and repeating\r\n   them in the row would say the same thing twice. */\r\n.task-flash {\r\n  align-items: center;\r\n  color: rgb(250, 225, 225);\r\n  display: flex;\r\n  font-family: Archivo, sans-serif;\r\n  font-size: 16px;\r\n  font-stretch: 100%;\r\n  font-weight: 650;\r\n  height: 100%;\r\n  justify-content: center;\r\n  letter-spacing: normal;\r\n  text-shadow: 1px 1px rgb(10, 9, 9);\r\n  white-space: nowrap;\r\n  width: 100%;\r\n}\r\n\r\n/* `#chart-stats li span:first-child svg` sizes row icons at 11x12 and outranks a bare\r\n   `.task-flash svg`, so this matches its specificity - id + one class + three elements - and\r\n   wins on order instead. Without it the check mark came out 11x12 beside 16px text. */\r\n#chart-stats li span.task-flash svg {\r\n  height: 16px;\r\n  margin-right: 4.5px;\r\n  width: 16px;\r\n}\r\n\r\n/* .correct too: a solved graph repainted quietly (updateInputTheme's `quiet`) gets no pulse.\r\n   Only the rings of the points NOT chosen go: `svg.correct` outranks svg.css's `.point-color.selected`,\r\n   so without :not(.selected) the student's own placed points vanished once the line was right. */\r\n.green-pulse .point-color:not(.selected), svg.correct .point-color:not(.selected) {\r\n  opacity: 0;\r\n}\r\n\r\n.green-pulse .line-select, .green-pulse .point-select {\r\n  animation: gray-pulse 120s 1;\r\n}\r\n\r\n@keyframes gray-pulse {\r\n  0%, 1%, 100% {\r\n    filter: grayscale(0);\r\n  }\r\n  0.25% {\r\n    filter: grayscale(1);\r\n  }\r\n}\r\n\r\n@keyframes green-pulse {\r\n  0%, 1%, 100% {\r\n    background-color: transparent;\r\n    filter: drop-shadow(0 0 0 transparent);\r\n  }\r\n  0.25% {\r\n    background-color: rgb(34, 77, 41);\r\n    filter: drop-shadow(0 0 15vmin rgba(16, 38, 20, 0.5));\r\n  }\r\n}\r\n\r\n.header {\r\n  align-items: center;\r\n  box-sizing: border-box;\r\n  display: inline-flex;\r\n  height: 44px;\r\n  padding: 0;\r\n  position: relative;\r\n  width: 100%;\r\n  z-index: 1;\r\n}\r\n\r\n.header button svg {\r\n  height: 18px;\r\n  width: 18px;\r\n}\r\n\r\n.header-center {\r\n  align-items: center;\r\n  display: flex;\r\n  flex: 0 1 100%;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  justify-content: center;\r\n  pointer-events: none;\r\n}\r\n\r\n.header-center button, .header-left button, .header-right button {\r\n  outline: none;\r\n  pointer-events: auto;\r\n}\r\n\r\n.header-left, .header-right {\r\n  align-items: center;\r\n  display: flex;\r\n  flex: 0 0 25%;\r\n  height: 100%;\r\n  pointer-events: none;\r\n}\r\n\r\n.ui .header .header-left, .ui .header .header-right {\r\n  flex: 0 0 30.6px;\r\n}\r\n\r\n.ui .header-left button, .ui .header-right button {\r\n  height: 32px;\r\n  width: 32px;\r\n}\r\n\r\n.header-title {\r\n  pointer-events: none;\r\n  text-align: center;\r\n  text-shadow: none;\r\n  width: 100%;\r\n}\r\n\r\n.nametag {\r\n  align-items: center;\r\n  background-clip: content-box;\r\n  background-size: cover;\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n  color: rgb(250, 225, 225);\r\n  cursor: pointer;\r\n  display: flex;\r\n  font-family: Archivo, sans-serif;\r\n  font-size: 15px;\r\n  font-stretch: 100%;\r\n  font-weight: 550;\r\n  height: 30px;\r\n  letter-spacing: 0.025em;\r\n  padding: 5px 7px 6px 7px;\r\n  text-shadow: 1px 1px rgba(10, 9, 9, 0.5);\r\n  white-space: nowrap;\r\n}\r\n\r\n.nametag.small {\r\n  font-size: 13px;\r\n  transform: scale(0.85);\r\n}\r\n\r\n.nametag svg {\r\n  height: 18px;\r\n  margin-left: 4px;\r\n  width: 18px;\r\n}\r\n\r\n.nametag.small svg {\r\n  margin: 0 5px 0 0;\r\n}\r\n\r\n.overlay {\r\n  background: linear-gradient(rgba(10, 9, 9, 0.75) -50%, rgba(50, 45, 45, 0.5) 100%);\r\n  /* Exactly the screen: a fixed box pinned to all four edges follows the screen as a phone's address bar\r\n     comes and goes, so anything centred by the overlay sits in the screen's true middle */\r\n  inset: 0;\r\n  pointer-events: none;\r\n  position: fixed;\r\n  /* Above every in-app layer (toolbars, panels, menus all sit at 1-6).\r\n     Keep dialogs covering the entire viewport, including the top toolbar. */\r\n  z-index: 1000;\r\n}\r\n\r\n.overlay.dialog {\r\n  pointer-events: auto;\r\n}\r\n\r\n.overlay.paused {\r\n  background: none;\r\n}\r\n\r\nhtml.dash .overlay {\r\n  pointer-events: auto;\r\n}\r\n\r\n.overlay * {\r\n  pointer-events: auto;\r\n}\r\n\r\n.popup,\r\n#popup-warning {\r\n  align-items: center;\r\n  backdrop-filter: blur(12.5px);\r\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.1) -100%, rgba(20, 18, 18, 0.5) 200%);\r\n  border-radius: 10vmin;\r\n  box-shadow: 0.05vmin 0.05vmin rgba(10, 9, 9, 0.5);\r\n  color: rgb(250, 225, 225);\r\n  display: none;\r\n  font-family: Archivo, sans-serif;\r\n  font-size: 1.5vmin;\r\n  font-stretch: 102.5%;\r\n  font-weight: 550;\r\n  height: 1.5vmin;\r\n  justify-content: center;\r\n  letter-spacing: 0.065em;\r\n  padding: 1vmin 1.375vmin;\r\n  position: absolute;\r\n  left: 50%;\r\n  text-shadow: 0.125vmin 0.125vmin rgba(10, 9, 9, 0.5);\r\n  transform: translateX(-50%);\r\n  transition: opacity 1000ms ease-in-out;\r\n  white-space: nowrap;\r\n}\r\n\r\n.popup svg .color {\r\n  fill: rgb(250, 225, 225) !important;\r\n}\r\n\r\n#popup {\r\n  top: calc(100% + 2.5vmin);\r\n}\r\n\r\n.answer-div #popup {\r\n  top: calc(100% + 2vmin);\r\n}\r\n\r\n.math-div #popup {\r\n  top: calc(100% + 0.75vmin);\r\n}\r\n\r\n/* A question whose box rows end in a spacer line (.br, 4.75vmin) with another question right after\r\n   it: the popup goes in the middle of the gap between the last boxes and the next question's text,\r\n   not under the spacer, where it sat on that text (mat710's inequalities; measured live). */\r\n.text-div:has(+ .text-div) > .br + #popup {\r\n  top: calc(100% - 2.875vmin);\r\n}\r\n\r\n#popup svg {\r\n  height: 1.75vmin;\r\n  margin: 0 0.75vmin 0 -0.35vmin;\r\n  padding: 0.2vmin 0 0.3vmin 0;\r\n  vertical-align: middle;\r\n  width: 1.75vmin;\r\n}\r\n\r\n.popup-timer-bar {\r\n  animation: induction var(--timer) linear infinite alternate;\r\n  background: linear-gradient(to right, #73e6d2 -15%, #ff80bf 50%, #ffe666 115%);\r\n  border-radius: 10vmin;\r\n  height: 100%;\r\n  left: 0;\r\n  mask-image: linear-gradient(to right, black, black);\r\n  mask-position: left;\r\n  mask-repeat: no-repeat;\r\n  mask-size: 0% 100%;\r\n  opacity: 0.5;\r\n  overflow: hidden;\r\n  position: absolute;\r\n  top: 0;\r\n  width: 100%;\r\n  z-index: -1;\r\n}\r\n\r\n@keyframes induction {\r\n  from {\r\n    mask-size: 0% 100%;\r\n  }\r\n  to {\r\n    mask-size: 102.5% 100%;\r\n  }\r\n}\r\n\r\n.preview {\r\n  display: none;\r\n  font-family: Archivo, sans-serif;\r\n  width: 400px;\r\n}\r\n\r\n/* The sparkle and Copy belong to the CARD, so the card is what they measure from. Without this\r\n   the nearest positioned ancestor is .preview-container, and every button offset below was\r\n   really a measurement from the bottom of the whole stack - so adding the descriptor box\r\n   between the card and the page count pushed both buttons 36px down, out of the card's corner\r\n   and onto the descriptor. Scoped with :has so the canvas preview's own buttons, which are\r\n   still tuned to the container, are left alone. */\r\n.preview:has(.memo) {\r\n  position: relative;\r\n}\r\n\r\n.preview .copy-button {\r\n  bottom: 213px;\r\n  position: absolute;\r\n  right: 92px;\r\n}\r\n\r\n/* See-through: the button sits over the card's bottom corner, and on a card that scrolls there\r\n   is text passing underneath it. */\r\n.preview .copy-text-button {\r\n  background-color: rgba(135, 122, 122, 0.6);\r\n  border: none;\r\n  border-radius: 4px;\r\n  bottom: 7px;\r\n  box-sizing: border-box;\r\n  box-shadow: none;\r\n  color: rgb(250, 225, 225);\r\n  cursor: pointer;\r\n  font-family: Archivo, sans-serif;\r\n  font-size: 14px;\r\n  font-stretch: 95%;\r\n  font-weight: 600;\r\n  height: 24px;\r\n  justify-content: center;\r\n  letter-spacing: 0.025em;\r\n  padding: 3px 6.5px;\r\n  position: absolute;\r\n  right: 8px;\r\n  z-index: 1;\r\n}\r\n\r\n/* Copy confirmation: the same pulse the sparkle uses while generating. A label swap to\r\n   \"Copied!\" was wider than the button, so it spread leftwards across the sparkle; the\r\n   animation says the same thing without moving anything. ONE beat: the sparkle's infinite\r\n   loop reads as ongoing work, a single blink reads as done. */\r\n.preview .copy-text-button.copied {\r\n  animation: memo-generating 0.5s ease-in-out;\r\n}\r\n\r\n/* Sparkles, sitting immediately left of Copy. Same geometry so the pair reads as one control\r\n   group; `right` clears Copy's width plus the gap. */\r\n.preview .preview-ai-button {\r\n  align-items: center;\r\n  background-color: rgba(135, 122, 122);\r\n  border: none;\r\n  border-radius: 4px;\r\n  bottom: 7px;\r\n  box-shadow: none;\r\n  box-sizing: border-box;\r\n  cursor: pointer;\r\n  display: flex;\r\n  height: 24px;\r\n  justify-content: center;\r\n  padding: 3px 6px;\r\n  position: absolute;\r\n  /* Copy's own right offset (8px) + its rendered width (47px) + the 4px gap Copy itself keeps\r\n     from the memo's inner border edge. Measured rather than guessed: the memo card carries a\r\n     4px border, so Copy's `right: 8px` reads as 4px of visible space, and an 8px gap here\r\n     looked wider than the one beside it. */\r\n  right: calc(8px + 47px + 4px);\r\n  width: 28px;\r\n  z-index: 1;\r\n}\r\n\r\n/* The icon ships with its own fill and a drop shadow. Paint it white and drop the shadow, per\r\n   the button's flat treatment. */\r\n.preview .preview-ai-button svg {\r\n  filter: none;\r\n  height: 15px;\r\n  width: 15px;\r\n}\r\n\r\n.preview .preview-ai-button svg * {\r\n  fill: rgb(250, 225, 225);\r\n  filter: none;\r\n}\r\n\r\n/* Nothing noteworthy: the same greyed-out reading as :disabled, but hoverable. The global\r\n   `button:disabled` rule kills pointer events, and Chrome gives a disabled control no hover\r\n   at all, so the button's title — the teacher's read-out of the figures behind the empty\r\n   result — could never be seen. The click is guarded in script.js instead. */\r\n.preview .preview-ai-button.empty {\r\n  cursor: default;\r\n  opacity: 0.25;\r\n}\r\n\r\n/* Generating: the sparkle pulses in place rather than swapping in an orbit, which would\r\n   resize the button and shift Copy beside it. */\r\n.preview .preview-ai-button.generating {\r\n  pointer-events: none;\r\n}\r\n\r\n.preview .preview-ai-button.generating svg {\r\n  animation: memo-generating 1s ease-in-out infinite;\r\n}\r\n\r\n@keyframes memo-generating {\r\n  0%, 100% { opacity: 1; }\r\n  50% { opacity: 0.35; }\r\n}\r\n\r\n.preview .download-button {\r\n  bottom: 213px;\r\n  position: absolute;\r\n  right: 12px;\r\n}\r\n\r\n.preview canvas {\r\n  height: 300px;\r\n  width: 400px;\r\n}\r\n\r\n.preview div {\r\n  background-color: rgb(168, 150, 150);\r\n  border: 4px solid rgb(135, 122, 122);\r\n  border-radius: 4px;\r\n  font-size: 14.5px;\r\n  font-weight: 600;\r\n  line-height: 18px;\r\n  padding: 5px 7px;\r\n  width: 100%;\r\n}\r\n\r\n/* A memo is a run of text and <br>s, not a flex layout. `.ui` makes it a flex container, which\r\n   blockifies every child — so the editable name span became a flex ITEM on its own line\r\n   instead of sitting in the sentence (computed display: inline -> block). Normal block flow\r\n   restores an inline formatting context for the text, which is all a memo ever needed. */\r\n.preview .memo {\r\n  display: block;\r\n}\r\n\r\n/* A long memo (a bonus code's, one line per problem) scrolls inside its card instead of running\r\n   off both ends of the screen, with the same top and bottom fade as the other scrolling lists.\r\n   The container is centred 50px below the middle of the window and also holds the caption and\r\n   the page count, which is what the 220px leaves room for. --scroll is set by dash.js only\r\n   while the list overflows, so without it the mask is invalid and nothing is faded. */\r\n.preview .memo-scroll {\r\n  display: block;\r\n  mask-image: linear-gradient(rgba(0, 0, 0, calc(1 - var(--scroll))) 0%, rgba(0, 0, 0, calc(0.75 * (1 / var(--scroll)))) 5%, rgba(0, 0, 0, 1) 10%, rgba(0, 0, 0, 1) 90%, rgba(0, 0, 0, calc(0.75 * (1 / (1 - var(--scroll))))) 95%, rgba(0, 0, 0, var(--scroll)) 100%);\r\n  max-height: calc(100vh - 220px);\r\n  overflow-y: auto;\r\n}\r\n\r\n/* The memo's editable name. Deliberately weightless: inline so it shrink-wraps its text,\r\n   inheriting every font property, with no padding, border or background to shift the\r\n   sentence around it. The only always-on affordance is a faint dotted underline, which\r\n   occupies no layout space; the field fills in on hover/focus so it reads as editable\r\n   without turning the memo into a form. min-width keeps an emptied name clickable. */\r\n.memo-name {\r\n  border-bottom: 1px dotted rgba(10, 9, 9, 0.35);\r\n  cursor: text;\r\n  display: inline;\r\n  min-width: 12px;\r\n  outline: none;\r\n}\r\n\r\n.memo-name:hover,\r\n.memo-name:focus {\r\n  background-color: rgba(250, 225, 225, 0.35);\r\n  border-bottom-color: rgba(10, 9, 9, 0.7);\r\n  border-radius: 2px;\r\n}\r\n\r\n.preview-container {\r\n  align-items: center;\r\n  display: flex;\r\n  flex-direction: column;\r\n  left: 50vw;\r\n  position: relative;\r\n  top: calc(50vh + 50px);\r\n  transform: translate(-50%, -50%);\r\n  width: 400px;\r\n}\r\n\r\n.preview-count {\r\n  background-color: rgba(135, 122, 122, 0.8);\r\n  margin-top: 8px;\r\n  padding: 6px 12px;\r\n  width: auto;\r\n}\r\n\r\n/* What the card measures, in the page count's own box, sitting between the card and the count.\r\n   It has to live outside the card: everything inside one is lifted by Copy and sent home, and\r\n   this is a label for whoever is flipping through the pages. Same rule as the count so the two\r\n   read as one stack - a step down in size, since it is a caption and the count is the control,\r\n   and centred because it wraps to two lines on the longer descriptors where the count never\r\n   wraps at all. */\r\n.preview-header {\r\n  background-color: rgba(135, 122, 122, 0.8);\r\n  font-size: 14px;\r\n  margin-top: 8px;\r\n  padding: 6px 12px;\r\n  text-align: center;\r\n  width: auto;\r\n}\r\n\r\n.preview-navigation {\r\n  display: flex;\r\n  left: 50%;\r\n  position: fixed;\r\n  top: 50%;\r\n  transform: translate(-50%, 104px);\r\n}\r\n\r\n.preview-next {\r\n  left: calc(50% + 210px);\r\n}\r\n\r\n.preview-next, .preview-previous {\r\n  background-color: rgba(135, 122, 122, 0.8);\r\n  border: none;\r\n  border-radius: 100px;\r\n  cursor: pointer;\r\n  box-shadow: 0.15vmin 0.15vmin rgba(10, 9, 9, 0.5);\r\n  font-family: 'Archivo';\r\n  font-size: 28px;\r\n  font-weight: bold;\r\n  height: 45px;\r\n  padding: 8px 13px;\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-315%);\r\n  width: 45px;\r\n}\r\n\r\n.preview-previous {\r\n  left: calc(50% - 255px);\r\n}\r\n\r\n.red-pulse {\r\n  animation: red-pulse 120s 1;\r\n}\r\n\r\n@keyframes red-pulse {\r\n  0%, 1%, 100% {\r\n    background-color: transparent;\r\n    filter: drop-shadow(0 0 0 transparent);\r\n  }\r\n  0.25% {\r\n    background-color: rgb(77, 19, 19);\r\n    filter: drop-shadow(0 0 15vmin rgba(38, 9, 9, 0.5));\r\n  }\r\n}\r\n\r\n/* The fairy low-health popup at \"very low\": three quick flashes over its 3s display, in the\r\n   wrong-answer red-pulse colours at a cadence that fits a popup instead of a 120s answer lock. The\r\n   warning is its own element (#popup-warning, styled like .popup but WITHOUT the class — getPopup finds the\r\n   regular popup by that class and would otherwise reuse the warning as it). */\r\n#popup-warning.red-pulse {\r\n  animation: popup-red-pulse 1s 3;\r\n}\r\n\r\n@keyframes popup-red-pulse {\r\n  0%, 100% {\r\n    background-color: transparent;\r\n    filter: drop-shadow(0 0 0 transparent);\r\n  }\r\n  50% {\r\n    background-color: rgb(77, 19, 19);\r\n    filter: drop-shadow(0 0 2vmin rgba(77, 19, 19, 0.6));\r\n  }\r\n}\r\n\r\n#refresh-button {\r\n  flex-basis: 100%;\r\n}\r\n/* #endregion */\r\n\r\n/* #region cursor */\r\n#cursor {\r\n  background: rgb(250, 225, 225);\r\n  border: 5px solid var(--student-color-value);\r\n  border-radius: 100px;\r\n  height: 5px;\r\n  opacity: 0.75;\r\n  position: fixed;\r\n  transform: translate(-50%, -10%);\r\n  width: 5px;\r\n  z-index: 3;\r\n}\r\n\r\nhtml.dash #cursor {\r\n  pointer-events: none;\r\n}\r\n\r\nhtml.dash:not(.focused-session) #cursor {\r\n  display: none;\r\n}\r\n\r\n/* Class announcements that stay out of the way (script.js showAnnouncement): banners stacked under\r\n   the toolbar, each closed with its x, the page usable underneath. A blocking one is a dialog. */\r\n#announcements {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  /* the page's full width less the standard 6px each side: a message wraps only on a narrow screen.\r\n     On a dashboard tile it is scaled by the tile's --session-scale like every panel, and made wider\r\n     by the inverse first so it still spans the tile and wraps where the student's screen does. */\r\n  left: 50%;\r\n  pointer-events: none;\r\n  position: fixed;\r\n  top: 42px;\r\n  transform: translateX(-50%) scale(var(--session-scale-x, 1), var(--session-scale-y, 1));\r\n  transform-origin: top center;\r\n  width: calc((100% - 12px) * var(--session-scale-x-inv, 1));\r\n  z-index: 1000;\r\n}\r\n\r\n/* As wide as its text (.ui would fix it at 240px), the standard sizes otherwise: the .ui font, a\r\n   6px inset all round (a .ui box with no header has no top inset of its own), and the close x\r\n   every panel and dialog header uses, 32px with an 18px icon (.ui .header-right button). */\r\n#announcements {\r\n  align-items: center;\r\n}\r\n\r\n#announcements .announcement {\r\n  flex-wrap: nowrap;\r\n  gap: 6px;\r\n  max-width: 100%;\r\n  padding: 6px;\r\n  pointer-events: auto;\r\n  width: fit-content;\r\n}\r\n\r\n/* Bare text is padded as if it sat in a box of its own (6px inside, like any boxed text), on both sides,\r\n   so it is 12px from the banner's left edge and 12px from the close button */\r\n#announcements .announcement-text {\r\n  padding: 0 6px;\r\n}\r\n\r\n#announcements .announcement-close {\r\n  flex: none;\r\n  height: 32px;\r\n  width: 32px;\r\n}\r\n\r\n#announcements .announcement-close svg {\r\n  height: 18px;\r\n  width: 18px;\r\n}\r\n/* #endregion */\r"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
